const UM31Table = {
  columns: ["Наименование параметра", "Значение параметра"],
  rows: [
    {
      items: [
        "Тип импульсных датчиков",
        "герконовый, транзисторный, активный (потенциальный)"
      ]
    },
    { items: ["Минимальная длительность импульса, мс", "10"] },
    { isGroup: true, items: ["Свойства", ""] },
    { isGroupItem: true, items: ["1", "5"] },
    { isGroupItem: true, items: ["2", "6"] },
    { items: ["Степень защиты корпуса", "IP20"] }
  ]
};

const UM31 = {
  id: "UM31",
  name: "<b>УМ-31</b>",
  img: "/heatmeters/UM31.png",
  imgAlt: "vist",
  description: [
    {
      isPreview: true,
      header: null,
      text:
        "Устройство мониторинга УМ-31 предназначено для сбора показаний с электросчётчиков, применяемых в жилых комплексах и передачи консолидированной информации на центральный пульт информационно-измерительных систем. Является средством измерения. Осуществляет информирование дежурного персонала о состоянии электросчётчиков, в том числе и аварийном, может передавать на центральный пульт SMS сообщения.",
      list: null,
      table: null
    },
    {
      isPreview: false,
      header: "Функции УМ-31:",
      text: null,
      list: {
        type: "dots",
        items: [
          "сбор информации с приборов учёта, имеющих цифровой интерфейс",
          "передачу консолидированной информации по сети GSM 900/1800",
          "цифровая обработка сигнала, минимальное время одного измерения, высокая помехозащищенность"
        ]
      },
      table: null
    },
    {
      header: null,
      text:
        "Информирование дежурного персонала о состоянии электросчётчиков, в том числе и аварийном, может осуществляться передачей на центральный пульт SMS сообщений.",
      list: null,
      table: UM31Table
    }
  ]
};

//******************************************************************************************

const TSRV023Table = {
  columns: ["Наименование параметра", "Значение параметра"],
  rows: [
    { isGroup: true, items: ["Количество каналов измерения:", ""] },
    { isGroupItem: true, items: ["— расхода", "до 6"] },
    { isGroupItem: true, items: ["— температуры", "до 6"] },
    { isGroupItem: true, items: ["— давления", "до 6"] },
    {
      items: ["Количество контролируемых теплосистем", "до 3"]
    },
    {
      items: [
        "Количество входов подключения сигнала направления потока (автореверса)",
        "1"
      ]
    }
  ]
};

const TSRV023 = {
  id: "TSRV023",
  name: "<b>ВЗЛЕТ ТСР-М (ТСР-023, 023-М)</b>",
  img: "/heatmeters/TSRV023.png",
  imgAlt: "TCP023",
  description: [
    {
      isPreview: true,
      header: null,
      text:
        "Оптимальный выбор для организации учета на ЦТП и в многотрубных системах. Предназначен для измерения, индикации, регистрации параметров теплоносителя и тепловой энергии в теплосистемах различного типа, конфигурации и назначения, а также других вспомогательных параметров на узлах учета.",
      list: null,
      table: null
    },
    {
      isPreview: false,
      header: "Функциональные возможности:",
      text: null,
      list: {
        type: "dots",
        items: [
          "наличие автореверса;",
          "гибкая программная настройка конфигурации измерительной схемы;",
          "установка двух разных значений температуры холодной воды для отопительного и межотопительного сезонов;"
        ]
      },
      table: null
    },
    {
      header: null,
      text:
        "Теплосчетчик-регистратор ВЗЛЕТ ТСР-М исполнения ТСР-023, -023М комплектуется на базе тепловычислителя ВЗЛЕТ ТСРВ (включен в Государственный реестр средств измерений за № 27010-04):",
      list: null,
      table: null
    },
    {
      header: null,
      text:
        "<b>— ТСРВ-023, -023М —</b> обеспечение учета в 3-х независимых системах при общем количестве трубопроводов до 6-ти, автореверс, электропитание =24В.",
      list: null,
      table: null
    },
    {
      header: null,
      text: "Технические характеристики:",
      list: null,
      table: TSRV023Table
    }
  ]
};
//****************************************************************************************** ТСР-024М

const TSR024MTable = {
  columns: ["Наименование параметра", "Значение параметра"],
  rows: [
    { isGroup: true, items: ["Количество каналов измерения:", ""] },
    { isGroupItem: true, items: ["— расхода", "до 6"] },
    { isGroupItem: true, items: ["— температуры", "до 6"] },
    { isGroupItem: true, items: ["— давления", "до 6"] },
    {
      items: ["Количество контролируемых теплосистем", "до 3"]
    },
    {
      items: ["Номинальный диаметр, DN", "от 10 до 5 000"]
    },
    {
      items: ["Диапазон измерения среднего объемного расхода, м^3^/ч", "от 0,01 до 1 000 000"]
    },
    {
      items: ["Диапазон измерения температуры, ^0^C", "от минус 50 до 180"]
    },
    {
      items: ["Диапазон измерения давления, МПа", "от 0,1 до 10"]
    },
    {
      items: ["Относительная погрешность измерения количества тепла, %", "не более ±5,0"]
    },
    {
      items: ["Температура окружающей среды для тепловычислителя, ^0^C", "от 5 до 50"]
    },
    {
      items: ["Длина линии связи между тепловычислителем и первичными преобразователями, м", "до 300"]
    },
    { isGroup: true, items: ["Глубина архивов измерительной информации, записей:", ""] },
    { isGroupItem: true, items: ["- часового", "1488 (62 суток)"] },
    { isGroupItem: true, items: ["- суточного", "366"] },
    { isGroupItem: true, items: ["- месячного", "48"] },
    {
      items: ["Степень защиты", "IP54"]
    },
    {
      items: ["Питание тепловычислителя", "=24В"]
    },
    {
      items: ["Мощность потребления тепловычислителя, Вт", "не более 2,5"]
    },
    {
      items: ["Средняя наработка на отказ, ч.", "75 000"]
    },
    {
      items: ["Средний срок службы, лет", "12"]
    },
    {
      items: ["Гарантийный срок тепловычислителя, лет", "6"]
    },
    {
      items: ["Масса тепловычислителя, кг", "не более 3"]
    },
    {
      items: ["Габаритные размеры тепловычислителя, мм", "250х135х98"]
    },
    {
      items: ["Способ крепления", "на DIN-рейку"]
    }
  ]
};

const TSR024M = {
  id: "TSR024M",
  name: "<b>ТСРВ-024М</b>",
  img: "/heatmeters/TSRV024.png",
  imgAlt: "vist",
  description: [
    {
      isPreview: true,
      header: null,
      text:
        "Предназначен для измерения, индикации, регистрации параметров теплоносителя и тепловой энергии в теплосистемах различного типа, конфигурации и назначения, а также других вспомогательных параметров на узлах учета. Теплосчетчик-регистратор ВЗЛЕТ ТСР-М исполнения ТСР-024М комплектуется на базе тепловычислителя ВЗЛЕТ ТСРВ.",
      list: null,
      table: null
    },
    {
      isPreview: false,
      header: "Функциональные возможности ТСР-024М:",
      text: null,
      list: {
        type: "dots",
        items: [
          "вычисление количества тепловой энергии и сохранение значений в архивах;",
          "учет тепловой энергии в 3-х независимых теплосистемах, содержащих до 4-х трубопроводов;",
          "задание автоматической реакции на 32 нештатных ситуации;",
          "отображение всех текущих результатов измерений и архивных данных на дисплее прибора;",
          "отображение всей текущей измерительной и архивной информации на индикаторе прибора;",
          "отображение зафиксированных нештатных состояний теплосистемы на индикаторе прибора;",
          "егистрация в журналах действий пользователя, нештатных ситуаций, отказов и режимов работы.",
        ]
      },
      table: null
    },
    {
      header: "Отличительные особенности ТСР-024М:",
      text: null,
      list: {
        type: "dots",
        items: [
          "наличие входа сигнала автореверса;",
          "наличие в памяти 11-ти наиболее часто применяемых типовых схем измерительных систем и алгоритмов расчета;",
          "наличие контрольной суммы базы установочных параметров и контрольной суммы настроечной базы данных прибора;",
          "питание расходомеров и датчиков давления от тепловычислителя;",
          "демонтаж прибора для проведения поверки без отключения кабелей связи;",
          "наличие многоуровневой системы защиты от несанкционированного доступа;",
          "наличие программы «Конфигуратор базы», позволяющей быстро и просто настроить тепловычислитель;",
          "наглядная настройка тепловычислителя компьютерной программой «Конфигуратор базы» в полноэкранном режиме.",
        ]
      },
      table: null
    },
    {
      header: null,
      text:
        "ТСРВ-024М — обеспечение учета в 3-х независимых системах при общем количестве трубопроводов до 9-ти, автореверс, электропитание =24В.",
      list: null,
      table: TSR024MTable
    }
  ]
};
//****************************************************************************************** ТСРВ-026М
const TSR026MTable = {
  columns: ["Наименование параметра", "Значение параметра"],
  rows: [
    { isGroup: true, items: ["Количество каналов измерения:", ""] },
    { isGroupItem: true, items: ["— расхода", "до 4"] },
    { isGroupItem: true, items: ["— температуры", "до 5"] },
    { isGroupItem: true, items: ["— давления", "до 4"] },
    {
      items: ["Количество контролируемых теплосистем", "1 (отопительный/межотопительный/ГВС)"]
    },
    {
      items: ["Номинальный диаметр, DN", "от 10 до 5 000"]
    },
    {
      items: ["Диапазон измерения среднего объемного расхода, м^3^/ч", "от 0,01 до 1 000 000"]
    },
    {
      items: ["Диапазон измерения температуры, ^0^C", "от минус 50 до 180"]
    },
    {
      items: ["Относительная погрешность измерения количества тепла, %", "не более ±5,0"]
    },
    {
      items: ["Температура окружающей среды для тепловычислителя, ^0^C", "от 5 до 50"]
    },
    {
      items: ["Длина линии связи между тепловычислителем и первичными преобразователями, м", "до 300"]
    },
    { isGroup: true, items: ["Глубина архивов измерительной информации, записей:", ""] },
    { isGroupItem: true, items: ["- часового", "1480 (60 суток)"] },
    { isGroupItem: true, items: ["- суточного", "186"] },
    { isGroupItem: true, items: ["- месячного", "48"] },
    {
      items: ["Степень защиты", "IP54"]
    },
    {
      items: ["Питание тепловычислителя", "внешнее питание =24В, аккумуляторная батарея (для поддержания работоспособности при перерывах питания)"]
    },
    {
      items: ["Ресурс работы батареи,ч.", "не менее 330*"]
    },
    {
      items: ["Средняя наработка на отказ, ч.", "75 000"]
    },
    {
      items: ["Средний срок службы, лет", "12"]
    },
    {
      items: ["Гарантийный срок тепловычислителя, лет", "6"]
    },
    {
      items: ["Масса тепловычислителя, кг", "не более 1"]
    },
    {
      items: ["Габаритные размеры тепловычислителя, мм",
        "190х125х80"]
    },
    {
      items: ["Способ крепления", "на DIN-рейку"]
    }
  ]
};

const TSR026M = {
  id: "TSR026M",
  name: "<b>ТСРВ-026М</b>",
  img: "/heatmeters/TSRV026.png",
  imgAlt: "vist",
  description: [
    {
      isPreview: true,
      header: null,
      text:
        "Теплосчетчик-регистратор ВЗЛЕТ ТСР-М исполнения ТСР-026М - оптимальный выбор для объектов ЖКХ. ТСР-026М комплектуется на базе тепловычислителя ВЗЛЕТ ТСРВ (включен в Государственный реестр средств измерений за № 27010-04) исполнения ТСРВ-026М. Тепловычислитель ТСРВ-026М представляет собой доступное решение для использования на большинстве объектов для абонентского учета тепла с точностью, регламентируемой для коммерческого учета. Обладает повышенной защитой от несанкционированного доступа. Является лучшим в своем классе решением для общедомового коммерческого учета с возможностью включения в систему диспетчеризации.",
      list: null,
      table: null
    },
    {
      header: null,
      text:
        "ТСРВ-026М — обеспечение учета в одной системе при общем количестве трубопроводов до 4-х, электропитание =24В, встроенная аккумуляторная батарея.",
      list: null,
      table: null
    },
    {
      header: "Функциональные возможности ТСРВ-026М:",
      text: null,
      list: {
        type: "dots",
        items: [
          "вычисление количества тепловой энергии и сохранение значений в архивах;",
          "расчет тепловой энергии в 4-х трубопроводах;",
          "возможность подключения датчика температуры наружного воздуха;",
          "задание автоматической реакции на 31 нештатную ситуацию;",
          "раздельный учет по системе отопления и системе горячего водоснабжения;",
          "отображение зафиксированных нештатных состояний теплосистемы на индикаторе прибора;",
          "использование в расчетах разных договорных значений температуры холодной воды для отопительного и межотопительного сезонов;",
          "регистрация в журналах действий пользователя, нештатных ситуаций, отказов и режимов работы."
        ]
      },
      table: null
    },
    {
      header: "Отличительные особенности ТСРМ-026М:",
      text: null,
      list: {
        type: "dots",
        items: [
          "автоматическая смена формул расчета тепловой энергии отопительного и межотопительного сезонов;",
          "в приборе предусмотренны 11 типовых схем теплоснабжения и есть возможность конфигурирования любой пользовательской схемы;",
          "наличие контрольной суммы базы установочных параметров;",
          "сохранение работоспособности при перерывах внешнего питания;",
          "возможность приема сигналов от внешних датчиков (задымления, охраны);",
          "назначение контрактного времени для архивирования результатов измерений и вычислений;",
          "многоуровневая система защиты от несанкционированного доступа;",
          "наглядная настройка тепловычислителя с помощью бесплатной компьютерной программы «Конфигуратор базы» в полноэкранном режиме."
        ]
      },
      table: null
    },
    {
      header: "Вывод информации:",
      text: null,
      list: {
        type: "dots",
        items: [
          "на жидкокристаллический индикатор;",
          "по последовательному интерфейсу RS-232."

        ]
      },
      table: TSR026MTable
    }
  ]
};
//****************************************************************************************** ТСР-027

const TSR027Table = {
  columns: ["Наименование параметра", "Значение параметра"],
  rows: [
    { isGroup: true, items: ["Количество каналов измерения:", ""] },
    { isGroupItem: true, items: ["— расхода", "до 6"] },
    { isGroupItem: true, items: ["— температуры", "до 6"] },
    { isGroupItem: true, items: ["— давления", "до 6"] },
    {
      items: ["Количество контролируемых теплосистем", "до 3"]
    },
    {
      items: ["Количество входов подключения сигнала направления потока (автореверса)", "1"]
    },
    {
      items: ["Диаметр условного прохода, Dy, мм", "от 10 до 5 000"]
    },
    {
      items: ["Диапазон измерения среднего объемного расхода, м^3^/ч", "от 0,01 до 1 000 000"]
    },
    {
      items: ["Диапазон измерения температуры, ^0^C", "от минус 50 до 180"]
    },
    {
      items: ["Диапазон измерения давления, МПа", "от 0 до 2,5"]
    },
    {
      items: ["Относительная погрешность измерения количества тепла, %", "не более ±5,0"]
    },
    {
      items: ["Температура окружающей среды для тепловычислителя, ^0^C", "от 5 до 50"]
    },
    {
      items: ["Длина линии связи между тепловычислителем и первичными преобразователями, м", "до 300"]
    },
    { isGroup: true, items: ["Глубина архивов измерительной информации, записей:", ""] },
    { isGroupItem: true, items: ["- часового", "1500 (62,5 суток)"] },
    { isGroupItem: true, items: ["- суточного", "366"] },
    { isGroupItem: true, items: ["- месячного", "48"] },
    {
      items: ["Степень защиты", "IP54"]
    },
    {
      items: ["Питание тепловычислителя", "=24В"]
    },
    {
      items: ["Мощность потребления тепловычислителя, Вт", "не более 2,5"]
    },
    {
      items: ["Средняя наработка на отказ, ч.", "75 000"]
    },
    {
      items: ["Средний срок службы, лет", "12"]
    },
    {
      items: ["Гарантийный срок тепловычислителя, мес", "28"]
    },
    {
      items: ["Масса тепловычислителя, кг", "не более 3"]
    },
    {
      items: ["Габаритные размеры тепловычислителя, мм", "250х154х105"]
    },
    {
      items: ["Способ крепления", "на DIN-рейку"]
    }
  ]
};

const TSR027 = {
  id: "TSR027",
  name: "<b>ТСР-027</b>",
  img: "/heatmeters/ТSR027.png",
  imgAlt: "vist",
  description: [
    {
      isPreview: true,
      header: null,
      text:
        "ТСРВ-027 внесен в отраслевой каталог средств измерений ОАО «Газпром». Теплосчётчик-регистратор специального исполнения для сложных условий эксплуатации с упрощённой настройкой. Предназначен для измерения, индикации, регистрации параметров теплоносителя и тепловой энергии, а также других параметров в 3-х независимых системах при общем количестве трубопроводов до 6-ти в сложных условиях эксплуатации.",
      list: null,
      table: null
    },
    {
      header: null,
      text:
        "Теплосчетчик-регистратор ВЗЛЕТ ТСР-М исполнений ТСР-027 комплектуется на базе тепловычислителя ВЗЛЕТ ТСРВ (включен в Государственный реестр средств измерений за № 27010-04) исполнения ТСРВ-027, ниже приведены его характеристики.",
      list: null,
      table: null
    },
    {
      header: "Функциональные возможности ТСР-027:",
      text: null,
      list: {
        type: "dots",
        items: [
          "конфигурирование до 6-ти трубопроводов в 3-х теплоситемах;",
          "гибкая программная настройка конфигурации измерительной схемы;",
          "программное задание формулы расчета результирующего количества тепла для трех теплосистем и его архивация;",
          "регистрация в журнале действий оператора;",
          "отображение всей текущей измерительной и архивной информации на индикаторе прибора;",
          "отображение зафиксированных нештатных состояний теплосистемы на индикаторе прибора;",
          "расчет суммарного количества тепловой энергии по всем теплосистемам."
        ]
      },
      table: null
    },
    {
      header: "Отличительные особенности ТСР-027:",
      text: null,
      list: {
        type: "dots",
        items: [
          "корпус тепловычислителя выполнен из литого алюминия;",
          "наличие входа сигнала автореверса;",
          "наличие многоуровневой защиты архивных и установочных данных от несанкционированного доступа;",
          "возможность питания расходомеров и датчиков давления от тепловычислителя;",
          "возможность демонтажа прибора для проведения поверки без отключения кабелей связи",
          "базовая комплектация электромагнитными расходомерами ВЗЛЕТ ЭР исполнений ЭРСВ-440Л/Ф с широким динамическим диапазоном."

        ]
      },
      table: null
    },
    {
      header: "Вывод информации:",
      text: null,
      list: {
        type: "dots",
        items: [
          "на жидкокристаллический индикатор;",
          "по последовательному интерфейсу RS-232/RS-485;",
          "в виде импульсной последовательности или логических сигналов;",
          "по интерфейсу Ethernet (по заказу)."
        ]
      },
      table: TSR027Table
    }
  ]
};

//****************************************************************************************** ТСРВ-034

const TSR034Table = {
  columns: ["Наименование параметра", "Значение параметра"],
  rows: [
    { isGroup: true, items: ["Количество каналов измерения:", ""] },
    { isGroupItem: true, items: ["— расхода", "до 3"] },
    { isGroupItem: true, items: ["— температуры", "до 3"] },
    {
      items: ["Количество контролируемых теплосистем", "1"]
    },
    {
      items: ["Номинальный диаметр, DN", "от 10 до 200"]
    },
    {
      items: ["Диапазон измерения среднего объемного расхода, м^3^/ч", "от 0,01 до 1360"]
    },
    {
      items: ["Диапазон измерения температуры, ^0^C", "от минус 50 до 180"]
    },
    {
      items: ["Относительная погрешность измерения количества тепла, %", "не более ±5,0"]
    },
    {
      items: ["Температура окружающей среды для тепловычислителя, ^0^C", "от 5 до 50"]
    },
    {
      items: ["Длина линии связи между тепловычислителем и первичными преобразователями, м", "до 300"]
    },
    { isGroup: true, items: ["Глубина архивов измерительной информации, записей:", ""] },
    { isGroupItem: true, items: ["- часового", "1080 (45 суток)"] },
    { isGroupItem: true, items: ["- суточного", "60"] },
    { isGroupItem: true, items: ["- месячного", "48"] },
    {
      items: ["Степень защиты", "IP54"]
    },
    {
      items: ["Средняя наработка на отказ, ч.", "75 000"]
    },
    {
      items: ["Средний срок службы, лет", "12"]
    },
    {
      items: ["Гарантийный срок тепловычислителя, лет", "6"]
    },
    {
      items: ["Масса тепловычислителя, кг", "не более 1"]
    },
    {
      items: ["Габаритные размеры тепловычислителя, мм", "190х125х80"]
    },
    {
      items: ["Способ крепления", "на DIN-рейку"]
    }
  ]
};

const TSR034 = {
  id: "TSR034",
  name: "<b>ТСРВ-034</b>",
  img: "/heatmeters/TSRV034.png",
  imgAlt: "vist",
  description: [
    {
      isPreview: true,
      header: null,
      text:
        "ТСРВ-034 - оптимальный выбор для организации учета в жилищно-коммунальной сфере. Предназначен для измерения, индикации, регистрации параметров теплоносителя и тепловой энергии, а также других параметров в теплосистемах различного типа, конфигурирования на узлах учета от квартиры до ТЭЦ. ВЗЛЕТ ТСР-М исполнения ТСР-034 комплектуется на базе тепловычислителя ВЗЛЕТ ТСРВ (включен в Государственный реестр СИ за № 27010-04) исполнения ТСРВ-034, ниже приведены его характеристики.",
      list: null,
      table: null
    },
    {
      isPreview: false,
      header: null,
      text:
        " ТСРВ-034 — обеспечение учета в одной системе при общем количестве трубопроводов до 3-х, электропитание =24В, встроенная аккумуляторная батарея для обеспечения работоспособности при перерывах внешнего питания до 330 часов.",
      list: null,
      table: null
    },
    {
      header: "Функциональные возможности ТСР-034:",
      text: null,
      list: {
        type: "dots",
        items: [
          "гибкая программная настройка конфигурации измерительной системы;",
          "программное задание алгоритма расчета результирующего количества тепла и его архивация;",
          "программное задание условий (критериев) нештатных ситуаций и реакций теплосчетчика при их возникновении;",
          "отображение всей текущей измерительной и архивной информации на индикаторе прибора;",
          "отображение зафиксированных нештатных состояний теплосистемы на индикаторе прибора;",
          "автоматическая смена алгоритмов расчета тепла для отопительного и межотопительного сезонов при изменении направления потока в обратном трубопроводе;",
          "использование в расчетах разных значений температуры холодной воды для отопительного и межотопительного сезонов;",
          "контроль питания расходомера."
        ]
      },
      table: null
    },
    {
      header: "Отличительные особенности ТСР-034:",
      text: null,
      list: {
        type: "dots",
        items: [
          "переход к упрощенному пользовательскому меню;",
          "работа с энергонезависимыми преобразователями расхода;",
          "режим работы в системах непрерывного автоматического опроса;",
          "сохранение работоспособности при перерывах внешнего питания."

        ]
      },
      table: null
    },
    {
      header: "Вывод информации:",
      text: null,
      list: {
        type: "dots",
        items: [
          "на жидкокристаллический индикатор;",
          "по последовательному интерфейсу RS-232."
        ]
      },
      table: null
    },
    {
      header: "Оборудование, рекомендуемое к использованию в составе теплосчетчика ВЗЛЕТ ТСР-М исполнения ТСР-034:",
      text: null,
      list: {
        type: "dots",
        items: [
          "расходомеры электромагнитные ВЗЛЕТ ЭР;",
          "расходомеры ультразвуковые ВЗЛЕТ МР (УРСВ-5хх ц);",
          "термопреобразователи сопротивления ВЗЛЕТ ТПС."
        ]
      },
      table: TSR034Table
    }
  ]
};

//****************************************************************************************** ТСР-031

const TSR031Table = {
  columns: ["Наименование параметра", "Значение параметра"],
  rows: [
    { isGroup: true, items: ["Количество каналов измерения:", ""] },
    { isGroupItem: true, items: ["— расхода", "до 3"] },
    { isGroupItem: true, items: ["— температуры", "до 3"] },
    {
      items: ["Количество контролируемых теплосистем", "1"]
    },

    {
      items: ["Диаметр условного прохода, Dy, мм", "от 10 до 200"]
    },
    {
      items: ["Диапазон измерения среднего объемного расхода, м^3^/ч", "от 0,01 до 1360"]
    },
    {
      items: ["Диапазон измерения температуры, ^0^C", "от минус 50 до 180"]
    },
    {
      items: ["Относительная погрешность измерения количества тепла, %", "не более ±5,0 (класс С по ГОСТ 51649)"]
    },
    {
      items: ["Температура окружающей среды для тепловычислителя, ^0^C", "от 5 до 50"]
    },
    {
      items: ["Длина линии связи между тепловычислителем и первичными преобразователями, м", "до 300"]
    },
    { isGroup: true, items: ["Глубина архивов измерительной информации, записей:", ""] },
    { isGroupItem: true, items: ["- часового", "1080"] },
    { isGroupItem: true, items: ["- суточного", "60"] },
    { isGroupItem: true, items: ["- месячного", "48"] },
    {
      items: ["Степень защиты", "IP54"]
    },
    {
      items: ["Питание тепловычислителя", "от встроенной батареи 3,6 В"]
    },
    {
      items: ["Ресурс работы батареи, лет", " 	не менее 4"]
    },
    {
      items: ["Средняя наработка на отказ, ч.", "75 000"]
    },
    {
      items: ["Средний срок службы, лет", "12"]
    },
    {
      items: ["Гарантийный срок тепловычислителя, лет", "4"]
    },
    {
      items: ["Масса тепловычислителя, кг", "не более 0,9"]
    },
    { isGroup: true, items: ["Габаритные размеры тепловычислителя, мм:", ""] },
    { isGroupItem: true, items: ["- ТСРВ-031", "160 х 110 х 62"] },
    { isGroupItem: true, items: ["- ТСРВ-033", "190 х 138 х 81"] },
    {
      items: ["Способ крепления", "на DIN-рейку"]
    }
  ]
};

const TSR031 = {
  id: "TSR031",
  name: "<b>ТСР-031</b>",
  img: "/heatmeters/TSRV031.png",
  imgAlt: "vist",
  description: [
    {
      isPreview: true,
      header: null,
      text:
        "ТСР-031 - наилучший выбор для решения задач абонентского учета. Предназначен для измерения, индикации, регистрации параметров теплоносителя и тепловой энергии в теплосистемах различного типа, конфигурации и назначения, а также других вспомогательных параметров на узлах учета.",
      list: null,
      table: null
    },
    {
      header: "Функциональные возможности ТСР-031:",
      text: null,
      list: {
        type: "dots",
        items: [
          "возможность работы с энергонезависимыми преобразователями расхода;",
          "гибкая программная настройка конфигурации измерительной схемы",
          "возможность программного задания условий (критериев) нештатных ситуаций и реакций теплосчетчика при их возникновении;",
          "программное задание формулы расчета результирующего количества тепла и его архивация;",
          "просмотр всей текущей измерительной и архивной информации на индикаторе прибора;",
          "просмотр зафиксированных нештатных состояний теплосистемы на индикаторе прибора;",
          "высокая степень защиты от несанкционированного доступа;",
          "установка двух разных значений температуры холодной воды для отопительного и межотопительного сезонов;",
          "контроль отключения питания расходомеров;",
          "возможность перехода к упрощенному пользовательскому меню (для ТСР-033)."
        ]
      },
      table: null
    },
    {
      header: "Энергонезависимый теплосчетчик-регистратор ВЗЛЕТ ТСР-М исполнений ТСР-031, -033 комплектуется на базе тепловычислителя ВЗЛЕТ ТСРВ (включен в Государственный реестр средств измерений за № 27010-04):",
      text: null,
      list: {
        type: "dots",
        items: [
          "ТСРВ-031, -033 — обеспечение учета в системах с 1-м независимым контуром при общем количестве трубопроводов до 3-х, энергонезависимый.",
        ]
      },
      table: null
    },

    {
      header: "Оборудование, рекомендуемое к использованию в составе теплосчетчика ВЗЛЕТ ТСР-М:",
      text: null,
      list: {
        type: "dots",
        items: [
          "расходомеры электромагнитные ВЗЛЕТ ЭР;",
          "расходомеры ультразвуковые ВЗЛЕТ МР (УРСВ-5хх);",
          "термопреобразователи сопротивления ВЗЛЕТ ТПС."

        ]
      },
      table: TSR031Table
    }
  ]
};

//****************************************************************************************** ТСР-032

const TSR032Table = {
  columns: ["Наименование параметра", "Значение параметра"],
  rows: [
    { isGroup: true, items: ["Количество каналов измерения:", ""] },
    { isGroupItem: true, items: ["— расхода", "до 3"] },
    { isGroupItem: true, items: ["— температуры", "до 3"] },
    {
      items: ["Количество контролируемых теплосистем", "1"]
    },

    {
      items: ["Диаметр условного прохода, Dy, мм", "от 10 до 200"]
    },
    {
      items: ["Диапазон измерения среднего объемного расхода, м^3^/ч", "от 0,01 до 1360"]
    },
    {
      items: ["Диапазон измерения температуры, ^0^C", "от минус 50 до 180"]
    },
    {
      items: ["Относительная погрешность измерения количества тепла, %", "не более ±5,0 (класс С по ГОСТ 51649)"]
    },
    {
      items: ["Температура окружающей среды для тепловычислителя, ^0^C", "от 5 до 50"]
    },
    {
      items: ["Длина линии связи между тепловычислителем и первичными преобразователями, м", "до 300"]
    },
    { isGroup: true, items: ["Глубина архивов измерительной информации, записей:", ""] },
    { isGroupItem: true, items: ["- часового", "1080"] },
    { isGroupItem: true, items: ["- суточного", "60"] },
    { isGroupItem: true, items: ["- месячного", "48"] },
    {
      items: ["Степень защиты", "IP54"]
    },
    {
      items: ["Питание тепловычислителя", "внешнее питание =24В, аккумуляторная батарея(для поддержания работоспособности при перерывах питания)"]
    },
    {
      items: ["Ресурс работы батареи, ч", "не менее 330*"]
    },
    {
      items: ["Средняя наработка на отказ, ч.", "75 000"]
    },
    {
      items: ["Средний срок службы, лет", "12"]
    },
    {
      items: ["Гарантийный срок тепловычислителя, лет", "4"]
    },
    {
      items: ["Масса тепловычислителя, кг", "не более 0,9"]
    },
    { isGroup: true, items: ["Габаритные размеры тепловычислителя, мм:", ""] },
    { isGroupItem: true, items: ["- ТСРВ-032", "160 × 110 х 62"] },
    { isGroupItem: true, items: ["- ТСРВ-034", "190 х 138 х 81"] },
    {
      items: ["Способ крепления", "на DIN-рейку"]
    }
  ]
};

const TSR032 = {
  id: "TSR032",
  name: "<b>ТСР-032</b>",
  img: "/heatmeters/TSRV032.png",
  imgAlt: "vist",
  description: [
    {
      isPreview: true,
      header: null,
      text:
        "ТСР-032 - оптимальный выбор для организации учета в жилищно-коммунальной сфере. Предназначен для измерения, индикации, регистрации параметров теплоносителя и тепловой энергии в теплосистемах различного типа, конфигурации и назначения, а также других вспомогательных параметров на узлах учета.",
      list: null,
      table: null
    },
    {
      header: "Функциональные возможности ТСР-032:",
      text: null,
      list: {
        type: "dots",
        items: [
          "возможность работы с энергонезависимыми преобразователями расхода;",
          "гибкая программная настройка конфигурации измерительной схемы",
          "возможность программного задания условий (критериев) нештатных ситуаций и реакций теплосчетчика при их возникновении;",
          "программное задание формулы расчета результирующего количества тепла и его архивация;",
          "просмотр всей текущей измерительной и архивной информации на индикаторе прибора;",
          "просмотр зафиксированных нештатных состояний теплосистемы на индикаторе прибора;",
          "высокая степень защиты от несанкционированного доступа;",
          "установка двух разных значений температуры холодной воды для отопительного и межотопительного сезонов;",
          "контроль отключения питания расходомеров;",
          "обеспечение работоспособности при перерывах внешнего питания."
        ]
      },
      table: null
    },
    {
      header: "Теплосчетчик-регистратор ВЗЛЕТ ТСР-М исполнений ТСР-032, -034 комплектуется на базе тепловычислителя ВЗЛЕТ ТСРВ (включен в Государственный реестр средств измерений за № 27010-04):",
      text: null,
      list: {
        type: "dots",
        items: [
          " ТСРВ-032, -034 — обеспечение учета в одной системе при общем количестве трубопроводов до 3-х, электропитание =24В, встроенная аккумуляторная батарея.",
        ]
      },
      table: TSR032Table
    },
    {
      header: "Вывод информации:",
      text: null,
      list: {
        type: "dots",
        items: [
          "на жидкокристаллический индикатор;",
          "в виде импульсной последовательности или логических сигналов;",
          "по последовательному интерфейсу RS-232."

        ]
      },
      table: null
    },
    {
      header: "Оборудование, рекомендуемое к использованию в составе теплосчетчика ВЗЛЕТ ТСР-М исполнения ТСР-032 или ТСР-034:",
      text: null,
      list: {
        type: "dots",
        items: [
          "расходомеры электромагнитные ВЗЛЕТ ЭР;",
          "расходомеры ультразвуковые ВЗЛЕТ МР (УРСВ-5хх);",
          "термопреобразователи сопротивления ВЗЛЕТ ТПС."

        ]
      },
      table: null
    }
  ]
};

const TSR033Table = {
  columns: ["Наименование параметра", "Значение параметра"],
  rows: [
    { isGroup: true, items: ["Количество каналов измерения:", ""] },
    { isGroupItem: true, items: ["— расхода", "до 3"] },
    { isGroupItem: true, items: ["— температуры", "до 3"] },
    {
      items: ["Количество контролируемых теплосистем", "1"]
    },
    {
      items: ["Номинальный диаметр, DN", "от 10 до 200"]
    },
    {
      items: ["Диапазон измерения среднего объемного расхода, м^3^/ч", "от 0,01 до 1360"]
    },
    {
      items: ["Диапазон измерения температуры, ^0^C", "от минус 50 до 180"]
    },
    {
      items: ["Относительная погрешность измерения количества тепла, %", "не более ±5,0"]
    },
    {
      items: ["Температура окружающей среды для тепловычислителя, ^0^C", "от 5 до 50"]
    },
    {
      items: ["Длина линии связи между тепловычислителем и первичными преобразователями, м", "до 300"]
    },
    { isGroup: true, items: ["Глубина архивов измерительной информации, записей:", ""] },
    { isGroupItem: true, items: ["- часового", "1080 (45 суток)"] },
    { isGroupItem: true, items: ["- суточного", "60"] },
    { isGroupItem: true, items: ["- месячного", "48"] },
    {
      items: ["Степень защиты", "IP54"]
    },
    {
      items: ["Средняя наработка на отказ, ч.", "75 000"]
    },
    {
      items: ["Средний срок службы, лет", "12"]
    },
    {
      items: ["Гарантийный срок тепловычислителя, лет", "6"]
    },
    {
      items: ["Масса тепловычислителя, кг", "не более 1"]
    },
    {
      items: ["Габаритные размеры тепловычислителя, мм", "190х125х80"]
    },
    {
      items: ["Способ крепления", "на DIN-рейку"]
    }
  ]
};

const TSR033 = {
  id: "TSR033",
  name: "<b>ТСР-033</b>",
  img: "/heatmeters/TSRV033.png",
  imgAlt: "vist",
  description: [
    {
      isPreview: true,
      header: null,
      text:
        "ТСР-033 - наилучший выбор для решения задач абонентского учета. Предназначен для измерения, индикации, регистрации параметров теплоносителя и тепловой энергии, а также других параметров в теплосистемах различного типа, конфигурирования на узлах учета от квартиры до ТЭЦ. ТСР-033 - энергонезависимый теплосчетчик-регистратор без измерения давления (питание от встроенной батареи).",
      list: null,
      table: null
    },
    {
      header: null,
      text:
        "Энергонезависимый теплосчетчик-регистратор ВЗЛЕТ ТСР-М исполнение ТСР-033 комплектуется на базе тепловычислителя ВЗЛЕТ ТСРВ (включен в Государственный реестр средств измерений за № 27010-04) исполнения ТСРВ-033, ниже приведены его характеристики.",
      list: null,
      table: null
    },
    {
      header: null,
      text:
        "ТСРВ-033 — обеспечение учета в одной теплосистеме при общем количестве трубопроводов до трех, энергонезависимый.",
      list: null,
      table: null
    },
    {
      header: "Функциональные возможности ТСР-033:",
      text: null,
      list: {
        type: "dots",
        items: [
          "гибкая программная настройка конфигурации измерительной системы;",
          "программное задание алгоритма расчета результирующего количества тепла и его архивация;",
          "программное задание условий (критериев) нештатных ситуаций и реакций теплосчетчика при их возникновении;",
          "отображение всей текущей измерительной и архивной информации на индикаторе прибора;",
          "отображение зафиксированных нештатных состояний теплосистемы на индикаторе прибора;",
          "автоматическая смена алгоритмов расчета тепла для отопительного и межотопительного сезонов при изменении направления потока в обратном трубопроводе;",
          "использование в расчетах разных значений температуры холодной воды для отопительного и межотопительного сезонов;",
          "контроль питания расходомера."
        ]
      },
      table: null
    },
    {
      header: "Отличительные особенности ТСР-033:",
      text: null,
      list: {
        type: "dots",
        items: [
          "переход к упрощенному пользовательскому меню;",
          "работа с энергонезависимыми перобразователями расхода."
        ]
      },
      table: null
    },
    {
      header: "Вывод информации:",
      text: null,
      list: {
        type: "dots",
        items: [
          "на жидкокристаллический индикатор;",
          "по последовательному интерфейсу RS-232."

        ]
      },
      table: null
    },
    {
      header: "Оборудование, рекомендуемое к использованию в составе теплосчетчика ВЗЛЕТ ТСР-М исполнения ТСР-032 или ТСР-034:",
      text: null,
      list: {
        type: "dots",
        items: [
          "расходомеры электромагнитные ВЗЛЕТ ЭР;",
          "расходомеры ультразвуковые ВЗЛЕТ МР (УРСВ-5хх);",
          "термопреобразователи сопротивления ВЗЛЕТ ТПС."

        ]
      },
      table: TSR033Table
    }
  ]
};

//****************************************************************************************** ТСРВ-010M

const TSRV010MTable = {
  columns: ["Наименование параметра", "Значение параметра"],
  rows: [
    { items: ["Завод изготовитель", "АО «Взлет»"] },
    { items: ["Вес (кг):", "5,5"] },
    { items: ["Габариты", "380x257x125"] },
    { items: ["Уровень пылевлагозашиты:", "IP54"] },
    { items: ["Средний срок службы (лет)", "12"] },
    { items: ["Средняя наработка на отказ (часов)", "75000"] },
    { items: ["Межповерочный интервал (мес.):", "48"] }
  ]
};

const TSRV010M = {
  id: "TSRV010M",
  name: "<b>ТСРВ-010М</b>",
  img: "/heatmeters/TSRV110M.png",
  imgAlt: "vist",
  description: [
    {
      isPreview: true,
      header: null,
      text:
        "Теплосчетчик-регистратор «ВЗЛЕТ ТСР-М» предназначен для исполь-зования на узлах учета тепловой энергии с целью измерения параметров теплоноси-теля и представления данных по потреблению тепло- и водоресурсов. Теплосчетчик соответствует ГОСТ Р 51649-2000, рекомендациям МИ 2412, МИ 2573, МОЗМ Р75 и другой нормативной документации, регламентирующей тре-бования к приборам учета. Теплосчетчик-регистратор «ВЗЛЕТ ТСР-М» исполнения ТСР-010М обеспечивает:",
      list: null,
      table: null
    },
    {
      header: null,
      text: null,
      list: {
        type: "dots",
        items: [
          "измерение текущих значений расхода, температуры и давления в четырех не-зависимых точках измерения (трубопроводах) и определение текущих и средних за интервал архивирования значений параметров теплоносителя;",
          "определение значений тепловой мощности и количества теплоты в одной или двух теплосистемах;",
          "ввод и просмотр согласованных в установленном порядке договорных значе-ний температуры, давления и расхода, в том числе, ввод по сети температуры и дав-ления в источнике холодной воды;",
          "защиту архивных и установочных данных от несанкционированного доступа;",
          "возможность выбор режима функционирования (конфигурации системы из-мерения и алгоритма расчета) с учетом вида контролируемой теплосистемы и набо-ра используемых первичных преобразователей расхода, температуры и давления;",
          "архивирование в энергонезависимой памяти результатов измерений и вычис-лений, а также параметров функционирования;",
          "индикацию измеренных, расчетных, установочных и архивированных пара-метров;",
          "вывод измерительной, диагностической, установочной, архивной и т.д. ин-формации через последовательный интерфейс RS-232 (в том числе через телефон-ный или радиомодем), а также вывод измерительной и архивной информации на пе-чатающее устройство через персональный компьютер или адаптер принтера;",
          "автоматический контроль и индикацию наличия неисправностей теплосчет-чика и нештатных ситуаций (НС), а также определение, индикацию и запись в архи-вы времени наработки и простоя теплосчетчика;",
          "кроме того, теплосчетчик позволяет задавать автоматическую смену алгорит-мов расчета при переходе от отопительного к межотопительному сезону."
        ]
      },
      table: TSRV010MTable
    },
  ]
};

//****************************************************************************************** ТСРВ-030

const TSRV030Table = {
  columns: ["Наименование параметра", "Значение параметра"],
  rows: [
    { items: ["Завод изготовитель", "АО «Взлет»"] },
    { items: ["Уровень пылевлагозашиты:", "IP54"] },
    { items: ["Средний срок службы (лет)", "12"] },
    { items: ["Средняя наработка на отказ (часов)", "75000"] },
    { items: ["Межповерочный интервал (мес.):", "48"] },
    { items: ["Гарантийный срок (мес.):", "60"] }
  ]
};

const TSRV030 = {
  id: "TSRV030",
  name: "<b>ТСРВ-030</b>",
  img: "/heatmeters/TSRV030.png",
  imgAlt: "vist",
  description: [
    {
      isPreview: true,
      header: null,
      text:
        "Теплосчетчик 'ВЗЛЕТ ТСР-У' предназначен для коммерческого учета потребленного тепла в открытых и закрытых системах теплоснабжения. Теплосчетчик может рассчитывать отребляемую тепловую энергию по трем независимым системам, имеет по 6 каналов для измерения расхода, температуры и давления для каждой теплосистемы. Новая идеология тепловычислителя позволяет потребителю программировать с лицевой панели конфигурацию системы измерения и алгоритмы расчета, просматривать архивные данные.",
      list: null,
      table: null
    },
    {
      header: null,
      text:
        "Программирование с клавиатуры прибора условий нештатных ситуаций по каждой из теплосистем и реакции тепловычислителя при достижении граничных значений по температуре, расходу или давлению.",
      list: null,
      table: null
    },
    {
      header: null,
      text:
        "Наличие импульсных входов по расходу с программируемым весом импульса упрощает комплектование и поверку.",
      list: null,
      table: null
    },
    {
      header: null,
      text:
        "Построение измерительных каналов позволяет использовать в составе теплосчетчика расходомеры, преобразователи температуры и давления различных типов. Раздельный учет времени отказов и времени нештатных ситуаций по каждой теплосистеме.",
      list: null,
      table: null
    },
    {
      header: "Архивирование:",
      text: null,
      list: {
        type: "dots",
        items: [
          "Измеренных значений в архивах: часовом (за 60 суток), суточном (за 60 суток) и месячном (за 24 месяца)",
          "До 2000 действий оператора в электронном журнале",
          "Время сохранности архивных и установочных данных, а также журнала оператора при отключении внешнего питания до одного года"
        ]
      },
      table: null
    },
    {
      header: "Представление измерительной информации",
      text: null,
      list: {
        type: "dots",
        items: [
          "На встроенном дисплее",
          "В виде частотно-импульсных или токовых сигналов",
          "Через последовательные интерфейсы RS232 (в том числе через телефонный или радиомодем), RS485",
          "На печатающем устройстве через адаптер принтера 'ВЗЛЕТ АП'",
          "На пульте управления и индикации 'ВЗЛЕТ ПУИ', предназначенном для переноса данных с целью анализа и составления отчетов"
        ]
      },
      table: null
    },
    {
      header: "Отличительные особенности",
      text: null,
      list: {
        type: "dots",
        items: [
          "Гибкая программная настройка конфигурации измерительной системы",
          "Программирование алгоритма расчета параметров и критериев нештатных ситуаций для контролируемых теплосистем",
          "Одновременный учет в 3-х независимых теплосистемах",
          "Поставляется программное обеспечение пользователя для диспетчерского контроля текущих значений измерямых параметров и сбора архивных данных c целью подготовки отчета о теплопотреблении",
          "Открытый протокол обмена, дающий возможность включения в существующие системы сбора информации",
          "В качестве преобразователей расхода могут использоваться расходомеры различных типов и принципов измерения с импульсным выходом",
          "Установка договорных значений давлений и температуры холодной воды",
        ]
      },
      table: TSRV030Table
    },

  ]
};

//****************************************************************************************** АКРОН-01 (ЭХО-Р-02)
const AKRON01 = {
  id: "AKRON01",
  name: "<b>АКРОН-01 (ЭХО-Р-02)</b>",
  img: "/heatmeters/AKRON01.png",
  imgAlt: "vist",
    description: [
        {
            "isPreview": true,
            "header": "НАЗНАЧЕНИЕ И ОБЛАСТЬ ПРИМЕНЕНИЯ",
            "text": "Расходомер АКРОН-02-1 предназначен для измерения объемного расхода и суммарного объема звукопроводящих жидкостей, в том числе сточных вод, протекающих в напорном трубопроводе, изготовленном из звукопроводящих материалов, для контроля и учета, в том числе коммерческого, в канализационных сетях, на очистных сооружениях, промышленных предприятиях, при значительном расстоянии от объекта измерения до места установки электронного блока (l \u2264 1200м).",
            "list": null,
            "table": null
        },
        {
            "isPreview": false,
            "header": "ТЕХНИЧЕСКИЕ ДАННЫЕ ",
            "text": "Расходомер обеспечивает измерение объемного расхода и суммарного (интегрального) объема (количества) звукопроводящих жидкостей с низким содержанием газообразных и твердых веществ при полностью заполненном сечении напорного трубопровода, протекающих в прямом и обратном направлении. Необходимость измерения потока жидкости, протекающей в обратном направлении, должна указываться в заказе. Допускается наличие в контролируемой среде газовых включений и твердых частиц в количестве не более 1 % объема. ",
            "list": null,
            "table": null
        },
        {
            "isPreview": false,
            "header": "",
            "text": "Электронный блок БЭ-4 формирует выходной сигнал расходомера  показания жидкокристаллического дисплея, на котором отображается следующая информация:",
            "list": null,
            "table": null
        },
        {
            "isPreview": false,
            "header": null,
            "text": null,
            "list": {
                "type": "dots",
                "items": [
                    {
                        "text": "объемный расход жидкости в трубопроводе, м3/ч; ",
                        "sublist": null
                    },
                    {
                        "text": "суммарный объем жидкости, протекающей в трубопроводе, м3; ",
                        "sublist": null
                    },
                    {
                        "text": "скорость потока жидкости в трубопроводе, м/с; ",
                        "sublist": null
                    },
                    {
                        "text": "время работы расходомера, ч; мин.; ",
                        "sublist": null
                    },
                    {
                        "text": "дата и время; ",
                        "sublist": null
                    },
                    {
                        "text": "содержимое архивов: ",
                        "sublist": {
                            "type": "dots",
                            "items": [
                                {
                                    "text": "почасового – 1925 записей; ",
                                    "sublist": null
                                },
                                {
                                    "text": "посуточного – 2200 записей; ",
                                    "sublist": null
                                },
                                {
                                    "text": "перерывов учета – 100 записей; ",
                                    "sublist": null
                                }
                            ]
                        }
                    },
                    {
                        "text": "параметры трубопровода; ",
                        "sublist": null
                    },
                    {
                        "text": "тип контролируемой жидкости в трубопроводе (холодная или горячая вода, сточные воды и т.д.) ",
                        "sublist": null
                    },
                    {
                        "text": "индикация настройки акустического канала при монтаже; ",
                        "sublist": null
                    },
                    {
                        "text": "диагностические сообщения. ",
                        "sublist": null
                    }
                ]
            },
            "table": null
        },
        {
            "isPreview": false,
            "header": null,
            "text": "Вывод информации на дисплей осуществляется с помощью кнопок \u0022Просмотр\u0022, \u0022Архив\u0022, \u0022Ввод\u0022, расположенных на передней панели расходомера, и кнопки \u0022Меню\u0022, расположенной под крышкой прибора. Расходомер может иметь: ",
            "list": null,
            "table": null
        },
        {
            "isPreview": false,
            "header": null,
            "text": null,
            "list": {
                "type": "dots",
                "items": [
                    {
                        "text": "активный токовый выход (диапазон 0-5, 0-20, 4-20 мА постоянного тока, выбирается пользователем); ",
                        "sublist": null
                    },
                    {
                        "text": "релейный или импульсный выход (сухие контакты реле: максимальное напряжение на контактах не более 60 В постоянного или переменного тока, ток через контакты реле не более 200 мА);",
                        "sublist": null
                    },
                    {
                        "text": "встроенный интерфейс USB, обеспечивающий возможность вывода информации на компьютер; ",
                        "sublist": null
                    },
                    {
                        "text": "встроенный интерфейс RS-232 или RS-485, обеспечивающий возможность вывода информации непосредственно на компьютер или посредством GSM-модема производства фирмы \u00ABСигнур\u00BB. ",
                        "sublist": null
                    }
                ]
            },
            "table": null
        },
        {
            "isPreview": false,
            "header": null,
            "text": "Все выходные сигналы гальванически отвязаны.",
            "list": null,
            "table": null
        }
    ]
};

//****************************************************************************************** РМ-5

const RM5 = {
  id: "RM5",
  name: "<b>РМ-5</b>",
  img: "/heatmeters/RM5.png",
  imgAlt: "vist",
  description: [
    {
      isPreview: true,
      header: null,
      text: "Электромагнитные счетчики-расходомеры серии РМ-5. Принцип действия: электромагнитный. Счетчики-расходомеры предназначены:",
      list: {
        type: "dots",
        items: [
          "РМ-5-Т — с полнопроходными первичными преобразователями — для измерения объемного (массового) расхода и объема (массы) электропроводящих жидкостей в различных отраслях промышленности;",
          "РМ-5-Т-И — для измерения объема электропроводящих жидкостей в различных отраслях промышленности;",
          "РМ-5-Э — с полнопроходными первичными преобразователями — для измерения объемного (массового) расхода и объема (массы) электропроводящих жидкостей в эталонных установках для поверки расходомеров и счетчиков жидкости."
        ]
      }
    },
  ]
};
const AnСom = {
  id: "AnСom",
  name: "<b>Контроллер AnСom</b>",
  img: "/heatmeters/AnСom.png",
  imgAlt: "vist",
    description:
        [
            {
                "isPreview": true,
                "header": "Назначение ",
                "text": "GPRS/EDGE/CSD/SMS модемы AnCom RM предназначены для обеспечения надежной, устойчивой и безопасной М2М связи в индустриальных территориально распределенных системах с высокими требованиями к надежности канала передачи данных. Модемы нашли широкое применение в системах коммерческого учета энергоресурсов (газ, вода, тепло, электроэнергия), в системах управления резервным электропитанием, управления скважинами и насосами, мониторинга окружающей среды, управления уличным освещением, контроля состояния инженерных сооружений, мониторинга транспорта, охраны зданий и территорий. При использовании модемов AnCom RM совместно с коммуникационным сервером AnCom Server RM обеспечивается законченное решение: GPRS/EDGE канал передачи данных AnCom.",
                "list": null,
                "table": null
            },
            {
                "isPreview": false,
                "header": "Линейка продукции AnCom RM: ",
                "text": null,
                "list": {
                    "type": "dots",
                    "items": [
                        {
                            "text": "AnCom RM/D - универсальные модемы общего применения для систем промышленной автоматизации и диспетчеризации;",
                            "sublist": null
                        },
                        {
                            "text": "AnCom RM/S - универсальные модемы общего применения для систем промышленной автоматизации и диспетчеризации в уменьшенном корпусе, оптимизированные по соотношению цена/функциональность;",
                            "sublist": null
                        },
                        {
                            "text": "AnCom RM/L – контроллер АСУНО со встроенным GSM модемом;",
                            "sublist": null
                        },
                        {
                            "text": "AnCom RM/E – резервируемый модем с коммутацией доступа к объекту автоматизации в исполнениях проводной/GSM либо УСПД/GSM;",
                            "sublist": null
                        },
                        {
                            "text": "AnCom RM/M - встраиваемый в аппаратуру пользователя (приборы учета, контроллеры и т.п.) модуль Wavecom Q2687H-408 с прошивкой программного обеспечения AnCom",
                            "sublist": null
                        }
                    ]
                },
                "table": null
            },
            {
                "isPreview": false,
                "header": "Универсальный модем общего назначения AnCom RM/D",
                "text": "Многофункциональная серия AnCom RM/D, отвечающая высоким требованиям безопасности и надежности канала передачи данных, предназначена для решения широкого спектра задач телемеханики и телеметрии, позволяет адаптироваться к практически любой структуре распределенной сети, разнородному парку объектов промышленной автоматизации, управления, мониторинга и диспетчеризации; отличается высокой функциональностью, гибкостью и надежностью. ",
                "list": null,
                "table": null
            },
            {
                "isPreview": false,
                "header": "Универсальный модем для систем AСКУЭ AnCom RM/S ",
                "text": "Серия AnCom RM/S является модификацией GSM модема AnCom RM/D в уменьшенном корпусе: с сохранением аппаратно/программных возможностей и оптимизацией соотношения цена/функциональность при ограниченном количестве вариантов исполнения. Модемы AnCom RM/S ориентированы на применение в системах коммерческого учета энергоресурсов (AСКУЭ и АСКУПЭ) – энерго- и теплоучёта, а также в любых других системах автоматизации, управления, мониторинга или диспетчеризации, использующих интерфейс RS-485 и RS-232 для обмена данными с оконечным устройством. ",
                "list": null,
                "table": null
            },
            {
                "isPreview": false,
                "header": "Встраиваемый модуль Wavecom с прошивкой ПО AnCom (RM/M) ",
                "text": "Встраиваемый GSM модем AnCom RM/M предназначен для применения в аппаратуре пользователя: в приборах учета, УСПД, контроллерах и т.п. Модем представляет собой сотовый GSM-терминал - модуль Wavecom Sierra Wireless Q2687H-408 с предустановленным программным обеспечением AnCom.",
                "list": null,
                "table": null
            }
        ]
};

//******************************************************************************************ПРЭМ

const PREM = {
  id: "PREM",
  name: "<b>ПРЭМ</b>",
  img: "/heatmeters/PREM.png",
  imgAlt: "vist",
  description: [
    {
      isPreview: true,
      header: null,
      text: "ПРЭМ Госреестр № 17858-11 / Свидетельство об утверждении типа RU.C.29.001 A № 42565",
      list: null,
      table: null
    },
    {
      isPreview: true,
      header: null,
      text: "Преобразователи расхода электромагнитные - ПРЭМ предназначены для преобразования объемного расхода и объема электропроводных жидкостей в их показания, регистрации и представления результатов измерений на внешние устройства.",
      list: null,
      table: null
    },
    {
      header: null,
      text: "Преобразователи могут быть применены для контроля и учета, в том числе при учетно-расчетных операциях, объемного расхода и объема жидкостей на объектах теплоэнергетического комплекса, на промышленных предприятиях и в жилищно-коммунальном хозяйстве.",
      list: null,
      table: null
    },
  ]
};

//****************************************************************************************** СПТ-941

const SPT941 = {
  id: "SPT941",
  name: "<b>СПТ-941</b>",
  img: "/heatmeters/SPT941.png",
  imgAlt: "vist",
  description: [
    {
      isPreview: true,
      header: null,
      text: "Тепловычислитель СПТ941 (мод. 941.20) предназначен для автоматизации учета теплопотребления в открытых и закрытых водяных системах. Тепловычислитель рассчитан на работу в составе теплосчетчиков, обслуживающих один теплообменный контур с тремя трубопроводами.",
      list: null,
      table: null
    },
    {
      header: null,
      text: "Функциональные возможности:",
      list: {
        type: "dots",
        items: [
          "Поддержка одиннадцати схем учета.",
          "Подключаемые датчики:",
          "3 преобразователя расхода с импульсным выходом частотой до 1000 Гц,",
          "3 преобразователя давления с выходным сигналом 4 - 20 мА,",
          "3 преобразователя температуры с характеристиками 100П, Pt100, 100M.",
          "Архивирование средних и суммарных значений измеряемых и вычисляемых параметров с привязкой к расчетному дню и часу.",
          "Архивирование изменений настроечной базы данных.",
          "Архивирование нештатных ситуаций и диагностических сообщений.",
          "16 независимых счетчиков-таймеров событий с настраиваемыми алгоритмами обработки."
        ]
      },
      table: null
    },
  ]
};

//****************************************************************************************** СПТ-943

const SPT943 = {
  id: "SPT943",
  name: "<b>СПТ-943</b>",
  img: "/heatmeters/SPT943.png",
  imgAlt: "vist",
  description: [
    {
      isPreview: true,
      header: null,
      text: "Тепловычислитель СПТ943.1 - двухканальный прибор, предназначенный для автоматизации учета теплопотребления. Рассчитан на работу в составе теплосчетчиков для открытых и закрытых систем водяного теплоснабжения.",
      list: null,
      table: null
    },

    {
      header: null,
      text: "Функциональные возможности:",
      list: {
        type: "dots",
        items: [
          "Обслуживание двух независимых тепловых нагрузок, для каждой из которых может быть выбрана любая из двенадцати схем учета с тремя преобразователями расхода, двумя преобразователями давления и двумя или тремя преобразователями температуры.",
          "Архивирование средних и суммарных значений измеряемых и вычисляемых параметров с привязкой к расчетному дню и часу.",
          "Ведение архивов изменений параметров настроечной базы данных и нештатных ситуаций.",
          "Возможность измерения температуры холодной воды и температуры наружного воздуха",
          "Расширенная система диагностики",
          "Выбор алгоритмов обработки нештатных ситуаций",
          "Формирование двухпозиционного выходного сигнала по результатам диагностики.",
          "Последовательный (RS232C-совместимый) и оптический (IEC1107) порты для обмена с внешними устройствами."
        ]
      },
      table: null
    },
    {
      header: "Подключаемые датчики:",
      text: null,
      list: {
        type: "dots",
        items: [
          "шесть термопреобразователей сопротивления 100 П;",
          "четыре преобразователя давления с выходным сигналом 4 - 20 мА;",
          "шесть преобразователей расхода с числоимпульсным выходным сигналом частотой до 1000 Гц. Возможность питания расходомеров, подобных SONO-2500СТ, непосредственно от тепловычислителя."

        ]
      },
      table: null
    }
  ]
};

//******************************************************************************************ВКТ-4

const VKT4 = {
  id: "VKT4",
  name: "<b>ВКТ-4</b>",
  img: "/heatmeters/VKT4.png",
  imgAlt: "vist",
  description: [
    {
      isPreview: true,
      header: null,
      text: "Вычислители предназначены для работы в составе теплосчетчиков, обеспечивающих измерение параметров теплоносителя и тепловой энергии в водяных системах теплопотребления различных конфигураций.",
      list: null,
      table: null
    },
    {
      header: null,
      text: "Вычислители предназначены для работы с измерительными преобразователями:",
      list: {
        type: "dots",
        items: [
          "расхода (объема) теплоносителя, имеющими выходной импульсный сигнал, формируемый пассивной или активной с параметрами ТТЛ-логики выходно йцепью;",
          "температуры — термопреобразователям исопротивления типа ТСМ или ТСП с номинальной статической характеристикой 100М; 100П; Pt100; 500Пили Pt500 поГОСТ6651;",
          "давления с выходным сигналом постоянного тока в диапазоне (4 –20) мА. ",
        ]
      },
      table: null
    },

    {
      header: "Вычислители обеспечивают преобразование и вывод на индикатор посредством интерфейса RS232C на внешнее устройство следующей информации:",
      text: null,
      list: {
        type: "dots",
        items: [
          "количество теплоты (тепловойэнергии); ",
          "объем и объемный расход теплоносителя;",
          "массатеплоносителя",
          "температура теплоносителя;",
          "разность температур и потребленный объем (масса) теплоносителя;",
          "время действия нештатных ситуаций с указанием идентифицирующих кодов; ",
          "часовые, суточные и с нарастающим итогом значения указанных выше параметров"
        ]
      },
      table: null
    }
  ]
};

//******************************************************************************************

const SKM2 = {
  id: "SKM2",
  name: "<b>СКМ-2</b>",
  img: "/heatmeters/SKM2.png",
  imgAlt: "vist",
  description: [
    {
      isPreview: true,
      header: null,
      text: "Универсальный многоканальный теплосчетчик СКМ-2 предназначен для измерения тепловой энергии в системах водяного теплоснабжения, для измерения объемного и массового расхода теплоносителя, воды — горячей и холодной, в том числе питьевой, а также отображения времени наработки, текущего времени, текущих, итоговых и аварийных значений физических величин, хранения в энергозависимой памяти архивов измерений.",
      list: null,
      table: null
    },
    {
      header: null,
      text: "Область применения счетчиков тепла и воды (тепловычислителей) СКМ-2: источники теплоты, предприятия тепловых сетей, тепловые пункты, объекты потребления (здания) промышленного, коммунального и бытового назначения, узлы технического и коммерческого учета воды, в том числе сточных вод.",
      list: null,
      table: null
    },
    {
      header: null,
      text: "Теплосчетчик и счетчик воды СКМ-2 может измерять тепловую энергию, расход и другие параметры жидкости одновременно в двух независимых системах теплоснабжения.",
      list: null,
      table: null
    },
    {
      header: null,
      text: "Теплосчетчики СКМ-2 являются составными и состоят из вычислителя, преобразователей расхода с выходным импульсным сигналом, термопреобразователей сопротивления Pt100 (100П) или Pt500 (500П), преобразователей давления с выходным ток овым сигналом.",
      list: null,
      table: null
    },
  ]
};
//******************************************************************************************ТМК-Н120

const TMKN120 = {
  id: "TMKN120",
  name: "<b>ТМК-Н120</b>",
  img: "/heatmeters/TMKN120.png",
  imgAlt: "vist",
  description: [
    {
      isPreview: true,
      header: null,
      text: "Вычислители предназначены для работы в составе теплосчетчиков при измерении и регистрации параметров теплоносителя и тепловой энергии в водяных системах теплоснабжения различной конфигурации. Вычислители обеспечивают измерение параметров теплоносителя, а также учет тепловой энергии по данным об измеренных параметрах теплоносителя. Область применения: узлы коммерческого учета для водяных систем теплоснабжения на различных объектах теплоэнергетического комплекса и промышленных предприятиях, в жилищно-коммунальном хозяйстве, а также автоматизированные системы сбора и контроля технологических параметров.",
      list: null,
      table: null
    },
    {
      header: "Особенности тепловычислителя ТМК-Н120:",
      text: null,
      list: {
        type: "dots",
        items: [
          "Широкий выбор схем измерения;",
          "Возможность подключения до 3 преобразователей расхода (электромагнитных, вихревых, ультразвуковых) или счетчиков воды (дальность линии связи до 300 м);",
          "Возможность подключения до 2 термопреобразователей сопротивления с характеристиками 100 Ом или 500 Ом (дальность линии связи до 300 м);",
          "Возможность подключения до 2 преобразователей давления с унифицированным выходным сигналом постоянного тока 0-5,0-20, 4-20 мА (дальность линии связи до 300 м);",
          "Возможность настройки, контроля параметров и реакций на нештатные ситуации;",
          "Наличие журнала оператора и нештатных ситуаций (до 2000 записей);",
          "Просмотр всех архивов и текущих параметров на ЖКИ;",
          "Возможность объединения в информационную сеть для передачи и дистанционного снятия архивных и текущих данных. 2 независимых порта для передачи данных;",
          "Межповерочный интервал 4 года."
        ]
      },
      table: null
    }
  ]
};

//******************************************************************************************ТВ7(Т-34) 

const TV7 = {
  id: "TV7",
  name: "<b>ТВ7(Т-34)</b>",
  img: "/heatmeters/tv7.png",
  imgAlt: "vist",
  description: [
    {
      isPreview: true,
      header: null,
      text: "Теплосчётчик Т-34 предназначен для измерений и регистрации параметров теплоносителя и количества теплоты (тепловой энергии) в водяных системах теплоcнабжения. Принцип действия теплосчётчиков основан на преобразовании вычислителем сигналов, поступающих от измерительных преобразователей, в информацию об измеряемых параметрах теплоносителя с последующим вычислением, на основании известных зависимостей, количества теплоты.",
      list: null,
      table: null
    },
    {
      header: null,
      text: "Они являются комбинированными средствами измерений, состоящими из функциональных блоков (составных частей) - средств измерений утвержденного типа: тепловычислителя, преобразователей расхода (расходомеров, счетчиков), термопреобразователей сопротивления и их комплектов, преобразователей давления. Для считывания текущих, настроечных и архивных параметров используются мобильное приложение «ТТМ» (Android) и ПО «Архиватор» (Windows XP и выше).",
      list: null,
      table: null
    },
    {
      header: null,
      text: "«ТЕРМОТРОНИК Т34» - это теплосчётчик на базе тепловычислителя ТВ7",
      list: null,
      table: null
    }
  ]
};

//******************************************************************************************ВКТ-9

const VKT9 = {
  id: "VKT9",
  name: "<b>ВКТ-9</b>",
  img: "/heatmeters/VKT9.png",
  imgAlt: "vist",
  description: [
    {
      isPreview: true,
      header: null,
      text: "Теплосчетчики ВКТ9 предназначены для измерений и регистрации параметров теплоносителя (температуры, давления, расхода), количества (объема, массы) теплоносителя и тепловой энергии в водяных системах теплопотребления, а также температуры окружающего воздуха. Теплосчетчики могут быть применены на объектах теплоэнергетического, про-мышленного и коммунально-бытового комплекса в составе узлов учета, информационно-измерительных систем и измерительных комплексов.",
      list: null,
      table: null
    },
    {
      header: "Теплосчетчики обеспечивают представление текущих, часовых, суточных, ме-сячных и нарастающим итогом показаний на встроенное табло и посредством ин-терфейсов RS232, USB и RS485 (опция по заказу) на внешнее устройство следу-ющих величин:",
      text: null,
      list: {
        type: "dots",
        items: [
          "текущее время и дата;",
          "время работы и остановки счета количества теплоносителя и тепловой энергии;",
          "тепловая энергия и мощность;",
          "масса и объем теплоносителя;",
          "объемный и массовый расход теплоносителя;",
          "температура и разность температур теплоносителя;",
          "избыточное давление теплоносителя;",
          "температура холодной воды и воздуха."

        ]
      },
      table: null
    }
  ]
};

//**************************************************************************************СЕ-102 

const KARAT = {
  id: "KARAT",
  name: "<b>Карат</b>",
  img: "/heatmeters/karat.png",
  imgAlt: "vist",
  description: [
    {
      isPreview: true,
      header: "Прибор предназначен для коммерческого и технологического учета энергетических ресурсов в системах отопления, горячего водоснабжения, холодного водоснабжения, электроснабжения, в которых они проводят измерение, преобразование и вычисление следующих параметров:",
      text: null,
      list: {
        type: "dots",
        items: [
          "измерение и преобразование сигналов измерительных преобразователей температуры в значения температуры;",
          "измерение и преобразование сигналов измерительных преобразователей давления в значения давления;",
          "измерение и преобразование сигналов измерительных преобразователей расхода воды и водосчетчиков в значения объема теплоносителя;",
          "вычисление значений потребленной тепловой энергии и массы теплоносителя в системах теплоснабжения, теплоносителем в которых является вода;",
          "вычисление значений многотарифного потребления электроэнергии."

        ]
      },
      table: null
    },
    {
      header: "Область применения вычислителя КАРАТ -307-6V6T6P:",
      text: null,
      list: {
        type: "dots",
        items: [
          "Узлы учета тепловой энергии, теплоносителя и электрической энергии в индивидуальных и центральных тепловых пунктах,",
          " информационно-измерительные системы учета, контроля и управления энергетическими ресурсами на объектах жилищно-коммунального хозяйства и промышленности."
        ]
      },
      table: null
    }
  ]
};

//**************************************************************************************СЕ-102 

const SE102Table = {
  columns: ["Наименование параметра", "Значение параметра"],
  rows: [
    { items: ["R5", "для установки на рейку"] },
    { items: ["номинальное напряжение", "4 (230В)"] },
    { items: ["Базовый (максимальный) ток", "5 (60) А"] },
    { items: ["A", "RS485 (оптопорт)"] },
    { items: ["Расшифровка маркировки", "Энергомера CE 102M"] },
    { items: ["Производитель", "Россия."] },
    { items: ["Размеры", "89 мм х 110 мм х 72,5 мм."] },
    { items: ["Вес брутто", "0.5 кг"] }
  ]
};

const SE102 = {
  id: "SE102",
  name: "<b>СЕ-102</b>",
  img: "/heatmeters/CE102.png",
  imgAlt: "vist",
  description: [
    {
      isPreview: true,
      header: null,
      text: "СЕ-102 предназначен для измерения и учета потребления электрической энергии в однофазных цепях переменного тока в бытовых, общественных и производственных помещениях. Позволяет вести учет энергии по четырем тарифам (запрограммирован на 2 тарифа). Имеет электронный счетный механизм с жидкокристаллической индикацией, устанавливается на дин-рейку.",
      list: null,
      table: null,
    },
    {
      header: null,
      text: null,
      list: null,
      table: SE102Table,
    },
  ]
};

//****************************************************************************************** СПГ-761

const SPG761 = {
  id: "SPG761",
  name: "<b>СПГ-761</b>",
  img: "/heatmeters/SPG761.png",
  imgAlt: "vist",
  description: [
    {
      isPreview: true,
      header: null,
      text: "Корректор СПГ761.2 предназначен для измерения электрических сигналов, соответствующих параметрам природного газа, и последующего вычисления расхода и объема газа, приведенных к стандартным условиям (Тc=20 С, Рc=0,101325 МПа). Корректор применяется в составе измерительных комплексов (систем) и обеспечивают комплексное решение широкого круга задач:",
      list: {
        type: "dots",
        items: [
          "коммерческий учет потребления и отпуска природного газа;",
          "контроль технологических параметров потока газа;",
          "организация систем диспетчеризации и контроля потребления газа."

        ]
      },
      table: null
    },
    {
      header: "Функциональные возможности:",
      text: null,
      list: {
        type: "dots",
        items: [
          "Корректор СПГ761.2 рассчитан на работу совместно с датчиками расхода, объема, перепада давления, давления и температуры газа, а также, при необходимости, с датчиками плотности, влажности и удельной теплоты сгорания.",
          "Корректор может обслуживать до двенадцати трубопроводов. "

        ]
      },
      table: null
    },
    {
      header: "Непосредственно к прибору могут быть подключены:",
      text: null,
      list: {
        type: "dots",
        items: [
          "восемь преобразователей с выходными сигналами тока 0-5, 0-20 или 4-20 мА;",
          "четыре преобразователя с выходным импульсным или частотным сигналом 0-5 кГц;",
          "четыре термопреобразователя сопротивления с характеристикой 50П, Pt50, 100П, Pt100, 50М, 100М."

        ]
      },
      table: null
    }
  ]
};

//******************************************************************************************ЕК-260

const EK260 = {
  id: "EK260",
  name: "<b>ЕК-260</b>",
  img: "/heatmeters/EK260.png",
  imgAlt: "vist",
  description: [
    {
      isPreview: true,
      header: null,
      text: "Корректор объема газа ЕК260 предназначен для приведения рабочего объёма газа, прошедшего через счётчик, к стандартным условиям (давление газа — 760 мм. рт.ст., температура газа +20 °С) путём вычисления коэффициента сжимаемости газа по ГОСТ 30319.2-96 и коэффициента коррекции с использованием измеренных значений давления, температуры газа и введённых параметров газа.",
      list: null,
    },
    {
      header: null,
      text: "Выполняемые функции:",
      list: {
        type: "dots",
        items: [
          "Вычисление приведённого к стандартным условиям расхода и объёма газа",
          "Просмотр на дисплее текущих измеряемых и рассчитываемых параметров, данных архива",
          "Программирование и считывание информации с корректора осуществляется с помощью 6-ти кнопочной клавиатуры и 2-х строчного цифробуквенного жидкокристаллического дисплея",
          "Формирование архива по рабочему и стандартному объему, давлению, температуре газа, коэффициенту сжимаемости и коэффициенту коррекции за последние 9 месяцев при измерительном периоде 60 минут",
          "Запись значений в архив происходит по истечении измерительного периода, а также в случае возникновения аварийной ситуации (превышение предельных значений измеряемых параметров)",
          "В случае выхода давления или температуры за пределы установленных значений это записывается в журнал событий с указанием даты и времени",
          "Максимальный объём записей в журнале событий — 250. Если в настройках корректора производятся изменения (изменение параметров газа, подстановочных значений и т.д.), то это автоматически фиксируется в журнале изменений. Максимальное число записей — 200",
          "Возможность интеграции в систему с дистанционной передачей данных с помощью интерфейса постоянного подключения RS232 (RS485) или оптического интерфейса",
          "Четыре цифровых выхода могут быть запрограммированы для передачи значений объёмов газа в виде импульсов, и/или передачи сообщений об ошибках"
        ]
      },
      table: null
    },
  ]
};
//******************************************************************************************ЕК-88

const EK88 = {
  id: "EK88",
  name: "<b>ЕК-88</b>",
  img: "/heatmeters/EK88.png",
  imgAlt: "vist",
  description: [
    {
      isPreview: true,
      header: null,
      text: "Электронный корректор объема газа ЕК-88/К предназначен для коммерческого учета рабочего и приведенного к стандартным условиям объема природного газа и других неагрессивных, сухих и очищенных, одно- и многокомпонентных газов в напорных газопроводах газо-распределительных пунктов и станций, теплоэнергетических установок и других технологических объектов в газовой и других отраслях промышленности. Предназначен для установки на счетчик газа (турбинного или ротационного типа). Осуществляет регистрацию низкочастотных импульсов счетчика газа, пропорциональных объему газа прошедшего через счетчик; вычисление коэффициента сжимаемости газа, коэффициента коррекции и приведение рабочего объема газа к его стандартному значению.",
      list: null,
      table: null
    },
    {
      header: "Выполняемые функции",
      text: null,
      list: {
        type: "dots",
        items: [
          "вычисление приведенного к нормальным условиям расхода и объема газа;",
          "отображение на дисплее ЕК-88/К информации о текущих значениях измеряемых и рассчитываемых параметров (объем, давление, температура и т.д.);",
          "отображение по вызову теку-щих значений показаний датчиков, а также приведенного расхода и объема и значений всех введенных и вычисленных параметров;",
          "дистанционная передача с помощью дополнительного модема через стандартный интерфейс RS-232 всех вычисленных, введенных и хранящихся в памяти корректора параметров по запросу или заданной программе;",
          "представление отчетов о нештатных ситуациях, авариях и сбоев в работе;",
          "почасовое архивирование основных параметров (рабочий и стандартный объемы, давление, температура) за последние 6 месяцев;",
          "диагностика работоспособности функциональных блоков;",
          "отображение значений из-меренных параметров с указанием времени и даты;",
          "отображение суточного потребления и максимальных расходов газа текущего и прошедшего месяца;",
          "вывод технологических данных на принтер и на компьютер;",
          "ввод и изменение исходных условий и данных (процедура настройки), периодический опрос и расчет всех параметров потока газа."
        ]
      },
      table: null
    },
  ]
};

//**************************************************************************************Пульсар 

const PULSARTable = {
  columns: ["Технические данные", "Значение параметра"],
  rows: [
    { items: ["Число входных каналов", "4"] },
    { items: ["Тип импульсных датчиков", "герконовый, транзисторный, активный (потенциальный)"] },
    { items: ["Минимальная длительность импульса, мс", "10"] },
    { items: ["Частота импульсов, Гц,", "не более 100 (по требованию заказчика - до 2000)"] },
    { items: ["Температура окружающей среды, °С", " 	от +5 до +50 (по отдельному заказу от -40 до +70)"] },
    { items: ["Степень защиты корпуса", "IP20"] },
    { items: ["Глубина архива", "1080 часов, 180 суток, 24 месяца"] },
    { items: ["Точность хода внутренних часов, секунд/сутки", "5"] },
    { items: ["Габаритные размеры, мм", "54х97х58"] },
    { items: ["Обмен информацией c внешними устройствами", "интерфейс Ethernet"] },
    { items: ["Период работы (учет импульсов) от встроенного элемента питания, лет", "не менее 6"] },
    { items: ["Напряжение внешнего питания, необходимое для передачи данных", "5-20В"] },
    { items: ["SMS-оповещение в случае отключения", " 	нет"] },
    { items: ["Межповерочный интервал, лет", "6"] },

  ]
};

const PULSAR = {
  id: "PULSAR",
  name: "<b>Пульсар Ethernet 4-канальный</b>",
  img: "/heatmeters/pulsarEthernet.png",
  imgAlt: "vist",
  description: [
    {
      isPreview: true,
      header: null,
      text:
        "Пульсар Ethernet 4-канальный - Учет потребления холодной и горячей воды, газа, электроэнергии совместно со счетчиками воды, газа, электроэнергии, имеющими импульсный (телеметрический) выход, дистанционный мониторинг потребления энергоресурсов, другие учетные операции. Счетчик обеспечивает сохранение во встроенной энергонезависимой памяти архива па­раметров потребления воды, газа с последующей возможностью считывания через Ethernet. Тип счетчиков импульсов-регистраторов «Пульсар» зарегистрирован в Государственном реестре средств измерений РФ свидетельство №41129. Счётчик соответствует требованиям ТР ТС 020/2011, 004/2011. Декларация о соответствии: ТС N RU Д-RU.АЯ46.В.71534.",
      list: null,
      table: null
    },
    {
      header: null,
      text: null,
      list: null,
      table: PULSARTable
    },
  ]
};

//************************************************************************************** Пульсар GPRS 

const PULSARGPRSTable = {
  columns: ["Технические данные", "Значение параметра"],
  rows: [
    { items: ["Число входных каналов", "2"] },
    { items: ["Тип импульсных датчиков", "герконовый, транзисторный, активный (потенциальный)"] },
    { items: ["Минимальная длительность импульса, мс", "10"] },
    { items: ["Частота импульсов, Гц,", "50"] },
    { items: ["Температура окружающей среды, °С", "от -10 до +50 (по отдельному заказу от -40 до +70)"] },
    { items: ["Степень защиты корпуса", "IP54, возможно IP 68"] },
    { items: ["Глубина архива", "1080 часов, 180 суток, 24 месяца"] },
    { items: ["Точность хода внутренних часов, секунд/сутки", "5"] },
    { items: ["Габаритные размеры, мм", "115х115х55"] },
    { items: ["Обмен информацией c внешними устройствами", "GSM/GPRS передача данных"] },
    { items: ["Период работы (учет импульсов) от встроенного элемента питания, лет", "не менее 6"] },
    { items: ["Напряжение внешнего питания, необходимое для передачи данных", "7-20В, либо от литиевых батарей"] },
    { items: ["Межповерочный интервал, лет", "6"] },

  ]
};

const PULSARGPRS = {
  id: "PULSARGPRS",
  name: "<b>Пульсар GPRS</b>",
  img: "/heatmeters/pulsarGPRS.png",
  imgAlt: "vist",
  description: [
    {
      isPreview: true,
      header: null,
      text: "Учет потребления холодной и горячей воды, газа, электроэнергии совместно со счетчиками воды, газа, электроэнергии, имеющими импульсный (телеметрический) выход, дистанционный мониторинг потребления энергоресурсов. Устройство сохраняет в энергонезависимой памяти архивные данные расхода с последующей возможностью передачи через интерфейс UART либо через модем GSM в режиме GPRS или CSD. Для конфигурирования прибора необходимо подключить внешний источник питания и конвертер USB-UART. Программное обеспечение TestAll доступно для скачивания на сайте производителя.",
      list: null,
      table: null
    },
    {
      header: null,
      text: null,
      list: null,
      table: PULSARGPRSTable
    },
  ]
};

//**************************************************************************************Данфос ECL210 - ECL Comfort 21 

const DANFOS = {
  id: "DANFOS",
  name: "<b>Данфос ECL210 - ECL Comfort 210</b>",
  img: "/heatmeters/danfos.png",
  imgAlt: "ECL 210",
    description:
        [
            {
                "isPreview": true,
                "header": "",
                "text": "ECL Comfort 210 – это электронный регулятор температуры с погодной компенсацией семейства регуляторов ECL Comfort, предназначенных для использования в системах централизованного теплоснабжения, центрального отопления и охлаждения. Экономия энергии достигается за счет правильного регулирования температуры подачи в системах теплоснабжения и охлаждения. Предусмотрена возможность регулирования до трех контуров. С помощью функции погодной компенсации в регуляторах ECL Comfort производится измерение температуры наружного воздуха и, соответственно, регулирование температуры подачи в систему теплоснабжения. Система теплоснабжения с погодной компенсацией повышает уровень комфорта и обеспечивает экономию энергии.",
                "list": null,
                "table": null
            },
            {
                "isPreview": false,
                "header": "",
                "text": "Настройка регулятора ECL Comfort 210 для выбранного приложения производится с помощью ключа приложения ECL.",
                "list": null,
                "table": null
            },
            {
                "isPreview": false,
                "header": "",
                "text": "Регулятор ECL Comfort 210 разработан для обеспечения комфортной температуры, оптимального энергопотребления, простой установки с помощью ключа приложения ECL (по технологии Plug-and-Play) и удобства в пользовании. Уменьшение энергопотребления достигается за счет погодной компенсации, регулировки температуры в соответствии с графиком, оптимизации, а также за счет ограничения температуры обратки, ограничения расхода и мощности. В регуляторе заложены такие функциональные возможности, как регистрация данных и подача аварийных сигналов.",
                "list": null,
                "table": null
            },
            {
                "isPreview": false,
                "header": "",
                "text": "Легкость управления регулятором ECL Comfort 210 обеспечивается диском (многофункциональной кнопкой) или блоком дистанционного управления (БДУ). Поворотная кнопка и дисплей с подсветкой помогают пользователю переходить по текстовому меню на выбранном языке.",
                "list": null,
                "table": null
            },
            {
                "isPreview": false,
                "header": "",
                "text": "В регуляторе ECL Comfort 210 среди прочего имеется электронный выход для управления клапаном с электроприводом, релейный выход для управления циркуляционным насосом / предохранительным клапаном, а также аварийный выход.",
                "list": null,
                "table": null
            },
            {
                "isPreview": false,
                "header": "",
                "text": "Предусмотрена возможность подключения шести температурных датчиков Pt 1000. Кроме того, при загрузке приложения производится настройка конфигурации двух входов. Предусмотрена возможность настройки конфигурации входа температурного датчика Pt 1000, аналогового входа (0 – 10 В) или цифрового входа.",
                "list": null,
                "table": null
            },
            {
                "isPreview": false,
                "header": "",
                "text": "Конструкция корпуса предусматривает возможность монтажа на стене и DIN-рейке. Выпускается вариант исполнения регулятора ECL Comfort 210B без дисплея и поворотной кнопки. Такой регулятор можно использовать для монтажа внутри щита, а управление им осуществляется с помощью БДУ ECA 30 / 31, который можно разместить на его фронтальной панели.",
                "list": null,
                "table": null
            },
            {
                "isPreview": false,
                "header": "",
                "text": "Регулятор ECL Comfort 210 представляет собой автономный регулятор, который связывается с БДУ и другими регуляторами ECL Comfort 210 / 310 через коммуникационную шину ECL 485.",
                "list": null,
                "table": null
            },
            {
                "isPreview": false,
                "header": "Блок дистанционного управления (БДУ):",
                "text": "БДУ ECA 30 и ECA 31 используются для регулирования температуры воздуха в помещении и переключения регулятора ECL Comfort 210. Дисплей оснащен подсветкой. БДУ соединены с регуляторами ECL кабелем с 2-мя витыми парами для связи и подачи питания (коммуникационной шиной ECL 485).",
                "list": null,
                "table": null
            },
            {
                "isPreview": false,
                "header": "",
                "text": "В ECA 30 / 31 встроен датчик комнатной температуры. Вместо встроенного температурного датчика можно подключить внешний датчик комнатной температуры. Кроме того, ECA 31 имеет встроенный датчик относительной влажности, сигнал которого используется в соответствующих приложениях. К коммуникационной шине ECL 485 можно подключить до двух БДУ. Один БДУ может контролировать максимум 10 регуляторов ECL Comfort (в системе \u00ABведущий-ведомый\u00BB).",
                "list": null,
                "table": null
            },
            {
                "isPreview": false,
                "header": "Ключи приложения ECL:",
                "text": "Различные ключи приложения ECL облегчают запуск разнообразных приложений в регуляторе ECL Comfort 210. С помощью ключа приложения ECL в регулятор ECL Comfort 210 загружается требуемое приложение, которое содержит информацию о приложении (на дисплее отображаются простые схематические изображения), языках и заводских настройках. Ключи приложений ECL для регулятора ECL Comfort 210 можно также использовать в регуляторе ECL Comfort 310.",
                "list": null,
                "table": null
            },
            {
                "isPreview": false,
                "header": null,
                "text": "На параметры приложений, которые хранятся в памяти регулятора, прерывание подачи питания влияния не оказывает.",
                "list": null,
                "table": null
            }
        ]
};

//**************************************************************************************Данфос ECL210 - ECL Comfort 21 
//**************************************************************************************CE 301
const CE301 = {
    id: "CE301",
    name: "<b>СЕ 301</b>",
    img: "/heatmeters/CE301.png",
    imgAlt: "CE 301",
    description:
        [
            {
                "isPreview": true,
                "header": "CE 301 ТРЕХФАЗНЫЙ МНОГОТАРИФНЫЙ СЧЕТЧИК АКТИВНОЙ ЭНЕРГИИ.",
                "text": "",
                "list": null,
                "table": null
            },
            {
                "isPreview": true,
                "header": "НАЗНАЧЕНИЕ",
                "text": "Счетчик является трехфазным, трансформаторного или непосредственного включения, предназначен для измерения активной электрической энергии, мощности, частоты, углов между векторами фазных напряжений и векторами фазных токов и напряжений, среднеквадратического значения напряжения, силы тока.",
                "list": null,
                "table": null
            },
            {
                "isPreview": false,
                "header": "ОБЛАСТЬ ПРИМЕНЕНИЯ",
                "text": "Счетчик может использоваться в АСКУЭ для передачи измеренных или вычисленных параметров на диспетчерский пункт по контролю, учету и распределению электрической энергии. Счетчик может использоваться автономно (локально), вне АСКУЭ",
                "list": null,
                "table": null
            },
            {
                "isPreview": false,
                "header": "ФУНКЦИОНАЛЬНЫЕ ВОЗМОЖНОСТИ",
                "text": null,
                "list": {
                    "type": "dots",
                    "items": [
                        {
                            "text": "Учет электроэнергии в прямом и обратном направлениях.",
                            "sublist": null
                        },
                        {
                            "text": "Фиксация и хранение почасовых профилей нагрузки 255 суток.",
                            "sublist": null
                        },
                        {
                            "text": "Наличие электронной пломбы крышки клеммной колодки.",
                            "sublist": null
                        },
                        {
                            "text": "Исполнения с реле сигнализации (для управления внешним коммутационным аппаратом). ",
                            "sublist": null
                        },
                        {
                            "text": "Измерение и отображение на ЖКИ текущих значений тока, напряжения, частоты, мощности.",
                            "sublist": null
                        },
                        {
                            "text": "Замена батареи без вскрытия корпуса и проведения внеплановой поверки прибора.",
                            "sublist": null
                        },
                        {
                            "text": "Питание прибора как от фазного напряжения (наличие фазы),как и от линейного (обрыв нуля).",
                            "sublist": null
                        },
                        {
                            "text": "Сигнализация отклонения от лимитов по мощности и потреблению, фиксация максимального значения мощности для каждого тарифа в течение месяца и контроль превышения лимита для выдачи счетчиком команды на срабатывание внешнего реле.",
                            "sublist": null
                        },
                        {
                            "text": " Учет и вывод на индикацию:",
                            "sublist": {
                                "type": "dots",
                                "items": [
                                    {
                                        "text": "количества потребленной активной электроэнергии суммарно и раздельно по  тарифам на конец месяца и за 2 предыдущих месяцев;",
                                        "sublist": null
                                    },
                                    {
                                        "text": "количества потребленной активной электроэнергии суммарно и раздельно по  тарифам на конец суток за последние 29 суток.",
                                        "sublist": null
                                    }
                                ]
                            }
                        },
                        {
                            "text": "Защита памяти от несанкционированных изменений с помощью кнопок или по интерфейсу (два пароля для двух уровней доступа).",
                            "sublist": null
                        },
                        {
                            "text": "Измерение отдельно по каждой фазе:",
                            "sublist": {
                                "type": "dots",
                                "items": [
                                    {
                                        "text": "активной энергии",
                                        "sublist": null
                                    },
                                    {
                                        "text": "текущего значения тока;",
                                        "sublist": null
                                    },
                                    {
                                        "text": "текущего значения напряжения;",
                                        "sublist": null
                                    },
                                    {
                                        "text": "текущего значения частоты сети;",
                                        "sublist": null
                                    },
                                    {
                                        "text": "текущего значения мощности;",
                                        "sublist": null
                                    },
                                    {
                                        "text": "угла сдвига между фазами;",
                                        "sublist": null
                                    },
                                    {
                                        "text": "угла между векторами тока и напряжения фазы;",
                                        "sublist": null
                                    },
                                    {
                                        "text": "коэффициента активной мощности фазы.",
                                        "sublist": null
                                    }
                                ]
                            }
                        },
                        {
                            "text": "Фиксация в журнале событий:",
                            "sublist": {
                                "type": "dots",
                                "items": [
                                    {
                                        "text": "100 корректировок времени;",
                                        "sublist": null
                                    },
                                    {
                                        "text": "100 изменений в настройке прибора;",
                                        "sublist": null
                                    },
                                    {
                                        "text": "50 состояний электронной пломбы;",
                                        "sublist": null
                                    },
                                    {
                                        "text": "100 событий состояния реле;",
                                        "sublist": null
                                    },
                                    {
                                        "text": "200 выходов за пределы допустимых значений фазных напряжений.",
                                        "sublist": null
                                    }
                                ]
                            }
                        }
                    ]
                },
                "table": null
            },
            {
                "isPreview": false,
                "header": "Технические характеристики:",
                "text": null,
                "list": null,
                "table": {
                    "columns": [
                        "Показатели",
                        "Величины"
                    ],
                    "rows": [
                        {
                            "items": [
                                "Класс точности по активной энергии",
                                "0,5S; 1"
                            ],
                            "isGroup": false,
                            "isGroupItem": false
                        },
                        {
                            "items": [
                                "Номинальное напряжение, В",
                                "3x230/400"
                            ],
                            "isGroup": false,
                            "isGroupItem": false
                        },
                        {
                            "items": [
                                "Базовый (максимальный) ток, А",
                                "5 (10); 5 (60); 5 (100)"
                            ],
                            "isGroup": false,
                            "isGroupItem": false
                        },
                        {
                            "items": [
                                "Частота измерительной сети, Гц",
                                "50\u00B12,5"
                            ],
                            "isGroup": false,
                            "isGroupItem": false
                        },
                        {
                            "items": [
                                "Число тарифов",
                                "4"
                            ],
                            "isGroup": false,
                            "isGroupItem": false
                        },
                        {
                            "items": [
                                "Время усреднения профилей нагрузки, мин",
                                "1; 2; 3; 4; 5; 6; 10; 12; 15; 20; 30; 60"
                            ],
                            "isGroup": false,
                            "isGroupItem": false
                        },
                        {
                            "items": [
                                "Глубина хранения профиля (при времени усреднения 60 мин.), сутки",
                                "255"
                            ],
                            "isGroup": false,
                            "isGroupItem": false
                        },
                        {
                            "items": [
                                "Количество датчиков тока, шт",
                                "3"
                            ],
                            "isGroup": false,
                            "isGroupItem": false
                        },
                        {
                            "items": [
                                "Диапазон рабочих температур, \u00B0С",
                                "от минус 40 до плюс 60"
                            ],
                            "isGroup": false,
                            "isGroupItem": false
                        },
                        {
                            "items": [
                                "Габаритные размеры (ВхШхГ), не более, мм",
                                "113 x 143 х 72,5 (укороченная крышка); 151,5 x 143 х 72,5"
                            ],
                            "isGroup": false,
                            "isGroupItem": false
                        },
                        {
                            "items": [
                                "Масса, не более, кг",
                                "3"
                            ],
                            "isGroup": false,
                            "isGroupItem": false
                        },
                        {
                            "items": [
                                "Степень защиты по ГОСТ 14254-96",
                                "IP50"
                            ],
                            "isGroup": false,
                            "isGroupItem": false
                        }
                    ]
                }
            }
        ]
};
//**************************************************************************************CE 301

//**************************************************************************************DANFOSS_ECL310
const DANFOSS_ECL310 = {
    id: "DANFOSS_ECL310",
    name: "<b>Данфосс ECL310</b>",
    img: "/heatmeters/Danfoss_ECL310.png",
    imgAlt: "Данфосс ECL310",
    description:
        [
            {
                "isPreview": true,
                "header": "Электронный регулятор ECL Comfort 310 ",
                "text": "ECL Comfort 310 \u2014 это электронный регулятор, предназначенный для регулирования температуры в сложных многоконтурных схемах систем тепло- и холодоснабжения при помощи погодной компенсации, подразумевающая использование датчиков температур наружного воздуха, воздуха в помещении, поверхностных и погружных датчиков температуры теплоносителя.",
                "list": null,
                "table": null
            },
            {
                "isPreview": false,
                "header": "ECL Comfort 310 имеет ряд особенностей:",
                "text": null,
                "list": {
                    "type": "dots",
                    "items": [
                        {
                            "text": "Оснащение портами Ethernet и Modbus;",
                            "sublist": null
                        },
                        {
                            "text": "Возможность подключения теплосчетчиков через встроенный M-Bus;",
                            "sublist": null
                        },
                        {
                            "text": "Простота настройки за счет использования ключей управления.",
                            "sublist": null
                        }
                    ]
                },
                "table": null
            },
            {
                "isPreview": false,
                "header": "",
                "text": "Регулятор имеет тиристорные выходы для электроприводов регулирующих клапанов (с трехпозиционным управлением), релейные выходы для управления насосами и выходы для аварийной сигнализации. К ECL 310 можно подключить до 6-и датчиков температуры Pt1000.",
                "list": null,
                "table": null
            },
            {
                "isPreview": false,
                "header": null,
                "text": "К ECL Comfort 310 необходимо отдельно заказывать клеммную панель, после чего регулятор можно смонтировать на DIN-рейке, стене или в шкафу автоматизации.",
                "list": null,
                "table": null
            },
            {
                "isPreview": false,
                "header": "",
                "text": "Управление и настройка регулятора ECL Comfort 310 осуществляется при помощи ключей А2** и А3**, предназначенных для разных схем теплоснабжения.",
                "list": null,
                "table": null
            },
            {
                "isPreview": false,
                "header": "Электронные регуляторы ECL Comfort 310 представлены в нескольких исполнениях:",
                "text": null,
                "list": {
                    "type": "dots",
                    "items": [
                        {
                            "text": "ECL Comfort 310 230 В с дисплеем и дисковым управлением для монтажа на DIN-рейке или стене;",
                            "sublist": null
                        },
                        {
                            "text": "ECL Comfort 310 24 В с дисплеем и дисковым управлением для монтажа на DIN-рейке или стене;",
                            "sublist": null
                        },
                        {
                            "text": "ECL Comfort 310B 230В без дисплея для монтажа в шкафу автоматизации. Для управления данным исполнением регулятора необходим блок дистанционного управления с дисплеем и дисковым управлением ECA 30, заказываемый отдельно, для его монтажа на корпусе шкафа автоматизации.",
                            "sublist": null
                        }
                    ]
                },
                "table": null
            },
            {
                "isPreview": false,
                "header": "Характеристики",
                "text": null,
                "list": null,
                "table": {
                    "columns": [
                        "",
                        ""
                    ],
                    "rows": [
                        {
                            "items": [
                                "Вес нетто ",
                                "0.48 kg "
                            ],
                            "isGroup": false,
                            "isGroupItem": false
                        },
                        {
                            "items": [
                                "Влажность окружающей среды [% RH] [Max] ",
                                "65 % RH "
                            ],
                            "isGroup": false,
                            "isGroupItem": false
                        },
                        {
                            "items": [
                                "Группа продуктов ",
                                "Электронные регуляторы "
                            ],
                            "isGroup": false,
                            "isGroupItem": false
                        },
                        {
                            "items": [
                                "Диапазон напряжения питания [В] пер. тока ",
                                "230 V "
                            ],
                            "isGroup": false,
                            "isGroupItem": false
                        },
                        {
                            "items": [
                                "Диапазон напряжения питания [В] пер. тока [Max] ",
                                "244 V "
                            ],
                            "isGroup": false,
                            "isGroupItem": false
                        },
                        {
                            "items": [
                                "Диапазон напряжения питания [В] пер. тока [Min] ",
                                "207 V "
                            ],
                            "isGroup": false,
                            "isGroupItem": false
                        },
                        {
                            "items": [
                                "Европейский Товарный Номер ",
                                "5710104013244 "
                            ],
                            "isGroup": false,
                            "isGroupItem": false
                        },
                        {
                            "items": [
                                "Интерфейсы для передачи данных ",
                                "Шина ECL 485 (без гальванической изоляции), M-Bus, Modbus (с гальванической изоляцией) "
                            ],
                            "isGroup": false,
                            "isGroupItem": false
                        },
                        {
                            "items": [
                                "Класс защиты корпуса ",
                                "IP41 "
                            ],
                            "isGroup": false,
                            "isGroupItem": false
                        },
                        {
                            "items": [
                                "Кол-во входов ",
                                "10 pc "
                            ],
                            "isGroup": false,
                            "isGroupItem": false
                        },
                        {
                            "items": [
                                "Кол-во выходов для управления трехпозиционным электроприводом ",
                                "3 "
                            ],
                            "isGroup": false,
                            "isGroupItem": false
                        },
                        {
                            "items": [
                                "Кол-во контуров ГВС ",
                                "2 "
                            ],
                            "isGroup": false,
                            "isGroupItem": false
                        },
                        {
                            "items": [
                                "Кол-во контуров ГВС с баком-аккумулятором ",
                                "1 "
                            ],
                            "isGroup": false,
                            "isGroupItem": false
                        },
                        {
                            "items": [
                                "Кол-во контуров отопления ",
                                "3 "
                            ],
                            "isGroup": false,
                            "isGroupItem": false
                        },
                        {
                            "items": [
                                "Кол-во периодов комфортной температуры в день ",
                                "3 "
                            ],
                            "isGroup": false,
                            "isGroupItem": false
                        },
                        {
                            "items": [
                                "Кол-во релейных выходов ",
                                "6 "
                            ],
                            "isGroup": false,
                            "isGroupItem": false
                        },
                        {
                            "items": [
                                "Кол-во цифровых входов ",
                                "4 "
                            ],
                            "isGroup": false,
                            "isGroupItem": false
                        },
                        {
                            "items": [
                                "Количество насосов ",
                                "5 "
                            ],
                            "isGroup": false,
                            "isGroupItem": false
                        },
                        {
                            "items": [
                                "Максимальная суммарная длина кабелей датчиков [м] ",
                                "200 mm "
                            ],
                            "isGroup": false,
                            "isGroupItem": false
                        },
                        {
                            "items": [
                                "Масса брутто ",
                                "0.68 kg "
                            ],
                            "isGroup": false,
                            "isGroupItem": false
                        },
                        {
                            "items": [
                                "Минимальный период резервирования времени и даты ",
                                "72 h "
                            ],
                            "isGroup": false,
                            "isGroupItem": false
                        },
                        {
                            "items": [
                                "Название производителя ",
                                "Danfoss "
                            ],
                            "isGroup": false,
                            "isGroupItem": false
                        },
                        {
                            "items": [
                                "Напряжение на релейном выходе [В], перем. ток ",
                                "230 V "
                            ],
                            "isGroup": false,
                            "isGroupItem": false
                        },
                        {
                            "items": [
                                "Настройка отопительного графика для контура отопления ",
                                "6 точек, Наклон "
                            ],
                            "isGroup": false,
                            "isGroupItem": false
                        },
                        {
                            "items": [
                                "Номинальная емкостная нагрузка на релейных выходах [A] ",
                                "4 A "
                            ],
                            "isGroup": false,
                            "isGroupItem": false
                        },
                        {
                            "items": [
                                "Номинальная индуктивная нагрузка на релейных выходах [A] ",
                                "2 A "
                            ],
                            "isGroup": false,
                            "isGroupItem": false
                        },
                        {
                            "items": [
                                "Номинальная нагрузка на тирристорных выходах [ВА] ",
                                "15 VA "
                            ],
                            "isGroup": false,
                            "isGroupItem": false
                        },
                        {
                            "items": [
                                "Область применения ",
                                "В зависимости от выбранного ключа программирования "
                            ],
                            "isGroup": false,
                            "isGroupItem": false
                        },
                        {
                            "items": [
                                "Общие функции ",
                                "Аварийные функции, Тренировка циркуляционного насоса, Тренировка регулирующего клапана, Возможность внешнего управления с блокировкой автоматики, Защита от замерзания, Программа праздничных дней, Подключение ведущий/ведомый, Защита двигателя, Возможность дистанционного управления, Видимая регистрация температуры "
                            ],
                            "isGroup": false,
                            "isGroupItem": false
                        },
                        {
                            "items": [
                                "Описание ",
                                "ECL COMFORT 310/230 В "
                            ],
                            "isGroup": false,
                            "isGroupItem": false
                        },
                        {
                            "items": [
                                "Потребляемая мощность [Вт] ",
                                "5 W "
                            ],
                            "isGroup": false,
                            "isGroupItem": false
                        },
                        {
                            "items": [
                                "Способ ввода пользовательских данных ",
                                "Дисплей, Поворотная кнопка "
                            ],
                            "isGroup": false,
                            "isGroupItem": false
                        },
                        {
                            "items": [
                                "Стандарт сертификации ",
                                "2007, Директива LVD 2006/95/EC, EN 60730 "
                            ],
                            "isGroup": false,
                            "isGroupItem": false
                        },
                        {
                            "items": [
                                "Страна ",
                                "Дания "
                            ],
                            "isGroup": false,
                            "isGroupItem": false
                        },
                        {
                            "items": [
                                "Температура окружающей среды [\u00B0C] [Max] ",
                                "55 \u00B0C "
                            ],
                            "isGroup": false,
                            "isGroupItem": false
                        },
                        {
                            "items": [
                                "Температура окружающей среды [\u00B0C] [Min] ",
                                "0 \u00B0C "
                            ],
                            "isGroup": false,
                            "isGroupItem": false
                        },
                        {
                            "items": [
                                "Температура хранения [\u00B0C] [Max] ",
                                "70 \u00B0C "
                            ],
                            "isGroup": false,
                            "isGroupItem": false
                        },
                        {
                            "items": [
                                "Температура хранения [\u00B0C] [Min] ",
                                "-40 \u00B0C "
                            ],
                            "isGroup": false,
                            "isGroupItem": false
                        },
                        {
                            "items": [
                                "Тип ",
                                "ECL Comfort 310 "
                            ],
                            "isGroup": false,
                            "isGroupItem": false
                        },
                        {
                            "items": [
                                "Тип датчиков температуры ",
                                "Pt 1000 "
                            ],
                            "isGroup": false,
                            "isGroupItem": false
                        },
                        {
                            "items": [
                                "Тип дисплея ",
                                "Точечная матрица ЖК-дисплея "
                            ],
                            "isGroup": false,
                            "isGroupItem": false
                        },
                        {
                            "items": [
                                "Тип таймера ",
                                "Неделя "
                            ],
                            "isGroup": false,
                            "isGroupItem": false
                        },
                        {
                            "items": [
                                "Тип цифровых входов ",
                                "Возможно использование подтягивающего резистора 12 В "
                            ],
                            "isGroup": false,
                            "isGroupItem": false
                        },
                        {
                            "items": [
                                "Функции ГВС ",
                                "Антибактериальная программа, Автонастройка, Влияние температуры обратного теплоносителя "
                            ],
                            "isGroup": false,
                            "isGroupItem": false
                        },
                        {
                            "items": [
                                "Частота напряжения питания [Гц] ",
                                "50 Hz "
                            ],
                            "isGroup": false,
                            "isGroupItem": false
                        }
                    ]
                }
            }
        ]
};
//**************************************************************************************DANFOSS_ECL310
//**************************************************************************************GVC2010 
const GVC2010 = {
    id: "GVC2010",
    name: "<b>GVC 2010</b>",
    img: "/heatmeters/GVC-2010.png",
    imgAlt: "GVC-2010",
    description:
        [
            {
                "isPreview": true,
                "header": null,
                "text": "Корректоры объема газа GVC 2010 (далее корректоры) предназначены для измерения и преобразования выходных электрических сигналов преобразователей в значения измеряемых параметров природного газа и вычислений объема природного газа, приведенного к стандартным условиям - Тс= 20 \u00B0С (293,15 К), Рс=0,101325 МПа.",
                "list": null,
                "table": null
            },
            {
                "isPreview": false,
                "header": "Описание",
                "text": "Принцип действия корректоров заключается в преобразовании сигналов, поступающих от измерительных преобразователей температуры, давления и объемного расхода природного газа, в значения измеряемых величин с последующим определением объемного расхода и объема природного газа, приведенных к стандартным условиям в соответствии с ГОСТ Р 8.740-2011. Расчет коэффициента сжимаемости природного газа осуществляется в соответствии с методом NX 19 мод. или уравнением состояния GERG 91 мод. по ГОСТ 30319.2-96 для следующих диапазонов изменения параметров газа: абсолютного давления от 0,05 до 6,3 МПа, температуры от минус 20 до плюс 50 \u00B0С, плотности газа в стандартных условиях от 0,68 до 0,7 кг/м3.",
                "list": null,
                "table": null
            },
            {
                "isPreview": false,
                "header": "Корректоры используются в составе узлов учета природного газа со следующими преобразователями:",
                "text": null,
                "list": {
                    "type": "dots",
                    "items": [
                        {
                            "text": "преобразователи расхода (счетчики газа) с импульсным выходным сигналом низкой частоты 0 - 0,4 Гц или высокой частоты 0 - 5 кГц;",
                            "sublist": null
                        },
                        {
                            "text": "преобразователи давления и перепада давления с выходным сигналом постоянного тока 4 - 20 мА;",
                            "sublist": null
                        },
                        {
                            "text": "термопреобразователи сопротивления с номинальной статической характеристикой Pt-100;",
                            "sublist": null
                        },
                        {
                            "text": "преобразователи температуры с выходным сигналом постоянного тока 4 - 20 мА. При использовании стандартных сужающих устройств объем газа вычисляется в соответствии с ГОСТ 8.586.5-2005 \u00ABИзмерение расхода и количества жидкостей и газов с помощью стандартных сужающих устройств. Методика выполнения измерений\u00BB. Возможно подключение от 1 до 3 диффманометров одновременно для измерения перепада.",
                            "sublist": null
                        },
                        {
                            "text": "Отображение информации осуществляется с помощью двухстрочного алфавитноцифрового ЖКИ-дисплея. Корректоры обеспечивают индикацию следующих параметров:",
                            "sublist": null
                        },
                        {
                            "text": "объём газа, приведённый к стандартным условиям, м3;",
                            "sublist": null
                        },
                        {
                            "text": "объём газа, измеренный в рабочих условиях, м3;",
                            "sublist": null
                        },
                        {
                            "text": "объёмный расход, приведённый к стандартным условиям, м3/ч;",
                            "sublist": null
                        },
                        {
                            "text": "максимальный объемный расход, приведенный к стандартным условиям, м3/ч;",
                            "sublist": null
                        },
                        {
                            "text": "давление газа, МПа (бар);",
                            "sublist": null
                        },
                        {
                            "text": "перепад давления газа, МПа (мбар);",
                            "sublist": null
                        },
                        {
                            "text": "температура газа, \u00B0С;",
                            "sublist": null
                        },
                        {
                            "text": "коэффициент коррекции;",
                            "sublist": null
                        },
                        {
                            "text": "коэффициент сжимаемости;",
                            "sublist": null
                        },
                        {
                            "text": "суммарная энергия, МВт-ч;",
                            "sublist": null
                        },
                        {
                            "text": "коэффициент преобразования счетчика газа, имп/м3;",
                            "sublist": null
                        },
                        {
                            "text": "диапазоны измерения давления и температуры, МПа, \u00B0С;",
                            "sublist": null
                        },
                        {
                            "text": "стандартное давление и температура, МПа, \u00B0С;",
                            "sublist": null
                        },
                        {
                            "text": "сигналы тревог (неисправности и превышение пределов давления и температуры).",
                            "sublist": null
                        }
                    ]
                },
                "table": null
            },
            {
                "isPreview": false,
                "header": null,
                "text": "Корректоры имеют четыре независимых токовых выхода и три независимых релейных выхода для дистанционной передачи информации об измеряемых параметрах и сигналах тревоги. Корректоры имеют возможность подключения модема.",
                "list": null,
                "table": null
            },
            {
                "isPreview": false,
                "header": null,
                "text": "Корректоры выполнены в алюминиевом корпусе, который можно устанавливать на стене или на любой ровной поверхности. Конструкция корпуса обеспечивает степень защиты IP54 по ГОСТ 14254-96.",
                "list": null,
                "table": null
            }
        ]
};
//**************************************************************************************GVC2010
//**************************************************************************************MULTICAL66
const MULTICAL66 = {
    id: "MULTICAL66",
    name: "<b>MULTICAL 66</b>",
    img: "/heatmeters/multical_66.png",
    imgAlt: "MULTICAL 66",
    description:
        [
            {
                "isPreview": true,
                "header": "",
                "text": "MULTICAL\u00AE типа 66 CDE представляет собой счетчик энергии с широким диапазоном применения. Он обладает большой точностью и надежностью, по выбору пользователя может работать от батареи или от сети, и может применяться для: ",
                "list": null,
                "table": null
            },
            {
                "isPreview": false,
                "header": null,
                "text": null,
                "list": {
                    "type": "dots",
                    "items": [
                        {
                            "text": "Измерения энергии охлаждения в водяных системах ",
                            "sublist": null
                        },
                        {
                            "text": "Двунаправленного измерения тепловой энергии и энергии охлаждения",
                            "sublist": null
                        },
                        {
                            "text": "Отслеживания утечек в системах горячегои холодного водоснабжения (ГВС и ХВС)",
                            "sublist": null
                        },
                        {
                            "text": "Ограничения мощности и расхода припомощи 3х ходового клапана",
                            "sublist": null
                        },
                        {
                            "text": "Архивации данных",
                            "sublist": null
                        },
                        {
                            "text": "Измерения энергии в открытых системах",
                            "sublist": null
                        }
                    ]
                },
                "table": null
            },
            {
                "isPreview": false,
                "header": "",
                "text": "Обозначение MULTICAL\u00AE типа 66 CDE является общим для трех версий поставки прибора: 66 C, 66 D и 66 E, каждая из которых имеет свою конкретную область применения.",
                "list": null,
                "table": null
            },
            {
                "isPreview": false,
                "header": "",
                "text": "MULTICAL\u00AE типа 66 C применяется для измерения, расчета и регистрации тепловой энергии или энергии охлаждения в любых водяных системах. MULTICAL\u00AE типа 66 C имеет ряд функций, относящихся к системам отопления/охлаждения:",
                "list": null,
                "table": null
            },
            {
                "isPreview": false,
                "header": "",
                "text": "MULTICAL\u00AE типа 66 D применяется для измерения разности значений теплоэнергии в системах горячего водоснабжения многоквартирных зданий или частных домов. Получаемая на бойлерной путем нагревания холодной воды при помощи централизованного теплоснабжения или сжигания природного газа горячая вода подается затем в жилые дома.",
                "list": null,
                "table": null
            },
            {
                "isPreview": false,
                "header": "",
                "text": "MULTICAL\u00AE типа 66 E применяется для измерения теплоэнергии в закрытых системах, где предъявляются особые требования к показаниям дисплея,регистрации данных и распечатке данных за отчетный период.",
                "list": null,
                "table": null
            },
            {
                "isPreview": false,
                "header": null,
                "text": "Конструкция прибора MULTICAL\u00AE типа 66 CDE позволяет расширять его функциональные возможности благодаря наличию программируемых функций и возможности монтажа в составе прибора сменных модулей. Это обеспечивает пригодность счетчика в широком диапазоне применений. Конструкция прибора позволяет также осуществлять модернизацию уже смонтированных счетчиков CDE при помощи программного обеспечения METERTOOL.",
                "list": null,
                "table": null
            }
        ]
};
//**************************************************************************************MULTICAL66
//**************************************************************************************MULTICAL601
const MULTICAL601 = {
    id: "MULTICAL601",
    name: "<b>MULTICAL 601</b>",
    img: "/heatmeters/multical601.png",
    imgAlt: "MULTICAL 601",
    description:
        [
            {
                "isPreview": true,
                "header": null,
                "text": "MULTICAL 601 – это многофункциональный прибор для учета тепловой энергии и (или) энергии охлаждения в открытых и закрытых системах. ",
                "list": null,
                "table": null
            },
            {
                "isPreview": false,
                "header": "Возможности тепловычислителя MULTICAL 601:",
                "text": null,
                "list": {
                    "type": "dots",
                    "items": [
                        {
                            "text": "Точное измерение тепловой энергии и энергии охлаждения при расходах от 0,6 до 3000 м.куб./ч;",
                            "sublist": null
                        },
                        {
                            "text": "Pt100, 2-проводное подключение, и Pt500, 2- и 4-проводное подключение;",
                            "sublist": null
                        },
                        {
                            "text": "Питание 24 VAC, 230 VAC или от батареи со сроком службы до 10 лет;",
                            "sublist": null
                        },
                        {
                            "text": "Все регистры сохраняются 460 суток, 36 месяцев и 15 лет;",
                            "sublist": null
                        },
                        {
                            "text": "Контроль утечек в системах ЦТ и ГВС/ХВС Соответствует EN 1434:2004 класс C и Директиве по низкому напряжению;",
                            "sublist": null
                        },
                        {
                            "text": "Место для 2 дополнительных модулей:",
                            "sublist": {
                                "type": "dots",
                                "items": [
                                    {
                                        "text": "Модуль верха: Часы реального времени, импульсные выходы, PQ ограничитель",
                                        "sublist": null
                                    },
                                    {
                                        "text": "Модуль основания: M-Bus, маршрутизатор RF, LonWork, выходы 0/4\u202620 mA и импульсные входы для счетчиков электроэнергии и воды.",
                                        "sublist": null
                                    }
                                ]
                            }
                        }
                    ]
                },
                "table": null
            },
            {
                "isPreview": false,
                "header": "Схемы питания: ",
                "text": null,
                "list": {
                    "type": "dots",
                    "items": [
                        {
                            "text": "от литиевой батареи (не менее 10 лет бесперебойной работы)",
                            "sublist": null
                        },
                        {
                            "text": "от сетевого источника питания 230(\u002B15/-30%)В ",
                            "sublist": null
                        },
                        {
                            "text": "от сетевого источника питания 24 В",
                            "sublist": null
                        }
                    ]
                },
                "table": null
            },
            {
                "isPreview": false,
                "header": "Датчики температуры:",
                "text": null,
                "list": {
                    "type": "dots",
                    "items": [
                        {
                            "text": "Тип 67-А Pt100 EN 60 751, 2-проводное подключение",
                            "sublist": null
                        },
                        {
                            "text": "Тип 67-B\u002B67-D EN 60 751, 4-проводное подключение",
                            "sublist": null
                        },
                        {
                            "text": "Тип 67-C EN 60 751, 2-проводное подключение",
                            "sublist": null
                        }
                    ]
                },
                "table": null
            },
            {
                "isPreview": false,
                "header": "Типы расходомеров:",
                "text": null,
                "list": {
                    "type": "dots",
                    "items": [
                        {
                            "text": "ULTRAFLOW",
                            "sublist": null
                        },
                        {
                            "text": "Электронные счетчики с вых. активных имп. 24 V",
                            "sublist": null
                        },
                        {
                            "text": "Механические счетчики с электронным считыванием",
                            "sublist": null
                        },
                        {
                            "text": "Механические счетчики с герконом",
                            "sublist": null
                        }
                    ]
                },
                "table": null
            }
        ]
};
//**************************************************************************************MULTICAL601
//**************************************************************************************SA94
const SA94 = {
    id: "SA94",
    name: "<b>SA 94</b>",
    img: "/heatmeters/SA-94.png",
    imgAlt: "SA 94",
    description:
        [
            {
                "isPreview": true,
                "header": "",
                "text": "Теплосчетчики микропроцессорные\u00A0SA-94/2\u00A0предназначены для использования при измерении, регистрации и регулировании тепловых параметров в\u00A0 открытых системах теплоснабжения с установкой двух датчиков расхода.",
                "list": null,
                "table": null
            },
            {
                "isPreview": false,
                "header": "",
                "text": "Теплосчетчик имеет возможность максимальной адаптации к системе теплоснабжения потребителя путем переключения диапазона измеряемых расходов, выбора соответствия токовых или частотных выходных сигналов измеряемым параметрам и др.",
                "list": null,
                "table": null
            },
            {
                "isPreview": false,
                "header": "",
                "text": "Теплосчетчик осуществляет автоматическую самодиагностику и автокалибровку, фиксирует нарушение работы системы теплоснабжения и собственных узлов, а также время отключения питания прибора от сети, что препятствует несанкционированному вмешательству в процесс учета тепловой энергии.",
                "list": null,
                "table": null
            },
            {
                "isPreview": false,
                "header": "",
                "text": "Теплосчетчик фиксирует во внутренней памяти часовые значения параметров системы теплоснабжения за последний месяц и суточные значения параметров за последний год работы прибора. Время хранения статической информации не ограничено.Для подключения к ЭВМ,\u00A0модему\u00A0или специальному адаптеру для снятия накопленной информации, теплосчетчик имеет выход стандартного последовательного интерфейса RS232 и/или RS422/RS485.",
                "list": null,
                "table": null
            },
            {
                "isPreview": false,
                "header": "",
                "text": "Конструктивно теплосчетчик выполнен в пылевлагозащищенном корпусе, в настенном исполнении. Степень защиты -\u00A0IP65\u00A0по ГОСТ 14254-96.",
                "list": null,
                "table": null
            },
            {
                "isPreview": false,
                "header": "",
                "text": "Теплосчетчик соответствует правилам учета тепла и ГОСТ Р 51649-2000,\u00A0имеет\u00A0сертификат\u00A0об утверждении типа средств измерения РФ,\u00A0разрешение\u00A0на применение Федеральной службы по экологическому, технологическому и атомному надзору и санитарно-эпидемиологическоезаключение\u00A0Государственной санитарно-эпидемиологической службы РФ.",
                "list": null,
                "table": null
            },
            {
                "isPreview": false,
                "header": "",
                "text": "Теплосчетчик измеряет, вычисляет и фиксирует во внутренней памяти следующие параметры системы теплоснабжения:",
                "list": null,
                "table": null
            },
            {
                "isPreview": false,
                "header": null,
                "text": null,
                "list": {
                    "type": "dots",
                    "items": [
                        {
                            "text": "расход теплоносителя в трубопроводах в м3/ч, (т/ч)",
                            "sublist": null
                        },
                        {
                            "text": "суммарное нарастающим итогом потребление тепловой энергии в МВт/ч, (Гкал)",
                            "sublist": null
                        },
                        {
                            "text": "суммарное нарастающим итогом количество теплоносителя, протекающего по трубопроводам в м3(т)",
                            "sublist": null
                        },
                        {
                            "text": "тепловую мощность в МВт (Гкал/ч)",
                            "sublist": null
                        },
                        {
                            "text": "температуру теплоносителя в подающем и обратном трубопроводах, разность температур в трубопроводах",
                            "sublist": null
                        },
                        {
                            "text": "среднечасовые и суточные значения вышеперечисленных параметров теплоносителя",
                            "sublist": null
                        },
                        {
                            "text": "календарь с указанием года, месяца, числа, часа, минут и секунд",
                            "sublist": null
                        },
                        {
                            "text": "время начала и окончания отключения прибора от сети, нарушений в работе прибора или системы теплоснабжения",
                            "sublist": null
                        },
                        {
                            "text": "время работы прибора в рабочем режиме",
                            "sublist": null
                        }
                    ]
                },
                "table": null
            },
            {
                "isPreview": false,
                "header": "В комплект теплосчетчика входят:",
                "text": null,
                "list": {
                    "type": "dots",
                    "items": [
                        {
                            "text": "первичные преобразователи ПРН (2)",
                            "sublist": null
                        },
                        {
                            "text": "измерительно-вычеслительный блок",
                            "sublist": null
                        },
                        {
                            "text": "два или три термопреобразователя сопротивления типа 100П или Pt100 по заказу потребителя",
                            "sublist": null
                        },
                        {
                            "text": "комплект заменяемых монтажных и установочных элементов",
                            "sublist": null
                        }
                    ]
                },
                "table": null
            },
            {
                "isPreview": false,
                "header": "Основные технические характеристики:",
                "text": "",
                "list": null,
                "table": null
            },
            {
                "isPreview": false,
                "header": null,
                "text": null,
                "list": null,
                "table": {
                    "columns": [
                        "",
                        "В\u00A0или\u00A0С"
                    ],
                    "rows": [
                        {
                            "items": [
                                "Ряд диаметров условного прохода, мм",
                                "10, 15, 25, 40, 50, 80, 100, 150, 200, 300, 400;"
                            ],
                            "isGroup": false,
                            "isGroupItem": false
                        },
                        {
                            "items": [
                                "Диапазон измеряемых скоростей потока среды, м/с",
                                "от 0,016 до 10,00;"
                            ],
                            "isGroup": false,
                            "isGroupItem": false
                        },
                        {
                            "items": [
                                "Количество поддиапазонов скоростей (для одного Ду)",
                                "11;"
                            ],
                            "isGroup": false,
                            "isGroupItem": false
                        },
                        {
                            "items": [
                                "Динамический диапазон измерения расхода",
                                "25;"
                            ],
                            "isGroup": false,
                            "isGroupItem": false
                        },
                        {
                            "items": [
                                "Диапазон температур теплоносителя в прямом трубопроводе,\u00A0оС",
                                "от 20 до 150;"
                            ],
                            "isGroup": false,
                            "isGroupItem": false
                        },
                        {
                            "items": [
                                "Диапазон температур теплоносителя в обратном трубопроводе,\u00A0оС",
                                "от 5 до 140;"
                            ],
                            "isGroup": false,
                            "isGroupItem": false
                        },
                        {
                            "items": [
                                "Диапазон разности температур теплоносителя в прямом и обратном трубопроводах,\u00A0оС",
                                "от 3 до 145;"
                            ],
                            "isGroup": false,
                            "isGroupItem": false
                        },
                        {
                            "items": [
                                "Диапазон входных и выходных электрических сигналов постоянного тока, мА",
                                "0 – 5; 0 – 20; 4 – 20;"
                            ],
                            "isGroup": false,
                            "isGroupItem": false
                        },
                        {
                            "items": [
                                "Диапазон выходных электрических частотных сигналов,\u00A0 Гц\u00A0",
                                "0 – 2000;"
                            ],
                            "isGroup": false,
                            "isGroupItem": false
                        },
                        {
                            "items": [
                                "Напряжение питания переменного тока, В",
                                "220 \u002B10%;\u00A0 - 15%;"
                            ],
                            "isGroup": false,
                            "isGroupItem": false
                        },
                        {
                            "items": [
                                "Потребляемая мощность, ВА",
                                "не более\u00A0 15."
                            ],
                            "isGroup": false,
                            "isGroupItem": false
                        }
                    ]
                }
            }
        ]
};
//**************************************************************************************SA94
//**************************************************************************************TEM05
const TEM05 = {
    id: "TEM05",
    name: "<b>TEM 05</b>",
    img: "/heatmeters/tem05m.png",
    imgAlt: "TEM 05",
    description:
        [
            {
                "isPreview": true,
                "header": "",
                "text": "Теплосчетчики ТЭМ-05М (далее - теплосчетчики) предназначены для измерения и регистрации тепловых параметров в закрытых и открытых системах водяного теплоснабжения.",
                "list": null,
                "table": null
            },
            {
                "isPreview": false,
                "header": null,
                "text": "Область применения: предприятия тепловых сетей, тепловые пункты, тепловые сети объектов (зданий) промышленного и бытового назначения.",
                "list": null,
                "table": null
            },
            {
                "isPreview": false,
                "header": "ОПИСАНИЕ",
                "text": "Принцип работы теплосчетчика основан на измерении расходов, объемов и температур теплоносителя в подающем и обратном трубопроводах и последующим определении тепловой энергии и мощности путем обработки результатов измерений.",
                "list": null,
                "table": null
            },
            {
                "isPreview": false,
                "header": "Теплосчетчик осуществляет:",
                "text": null,
                "list": {
                    "type": "dots",
                    "items": [
                        {
                            "text": "измерение, вычисление и индикацию:",
                            "sublist": {
                                "type": "dots",
                                "items": [
                                    {
                                        "text": "объемного расхода теплоносителя по 1 \u2014 4 каналам, в зависимости от исполнения теплосчетчика (см. таблицу 1);",
                                        "sublist": null
                                    },
                                    {
                                        "text": "температуры теплоносителя по 2 \u2014 5 каналам, в зависимости от исполнения теплосчетчика (см. таблицу 1);",
                                        "sublist": null
                                    },
                                    {
                                        "text": "времени (с указанием часов, минут, секунд) и даты (с указанием числа, месяца, года);",
                                        "sublist": null
                                    },
                                    {
                                        "text": "массового расхода теплоносителя по 1 \u2014 4 каналам, в зависимости от исполнения теплосчетчика (см. таблицу 1);",
                                        "sublist": null
                                    },
                                    {
                                        "text": "разности температур теплоносителя в прямом и обратном (трубопроводе холодного водоснабжения) трубопроводах;",
                                        "sublist": null
                                    },
                                    {
                                        "text": "потребляемой тепловой мощности по 1\u20144 каналам;",
                                        "sublist": null
                                    }
                                ]
                            }
                        },
                        {
                            "text": "\u2022\u00A0накопление, хранение и индикацию:",
                            "sublist": {
                                "type": "dots",
                                "items": [
                                    {
                                        "text": "суммарного с нарастающим итогом объема теплоносителя, протекающего по трубопроводам, на которых установлены соответствующие первичные преобразователи расхода (ППР);",
                                        "sublist": null
                                    },
                                    {
                                        "text": "суммарного с нарастающим итогом потребленного количества теплоты;",
                                        "sublist": null
                                    },
                                    {
                                        "text": "времени наработки при поданном напряжении питания;",
                                        "sublist": null
                                    },
                                    {
                                        "text": "времени работы в зоне ошибок; \u2022 преобразование:",
                                        "sublist": null
                                    },
                                    {
                                        "text": "сигналов от датчиков избыточного давления с токовым выходом (см. таблицу 1);",
                                        "sublist": null
                                    },
                                    {
                                        "text": "измеряемых параметров в выходной токовый сигнал.",
                                        "sublist": null
                                    }
                                ]
                            }
                        }
                    ]
                },
                "table": null
            },
            {
                "isPreview": false,
                "header": null,
                "text": "Теплосчетчики исполнения 1, исполнения 2, исполнения 3 обеспечивают измерение расхода в трех диапазонах для каждого диаметра условного прохода ППР (см. таблицу 2), с возможностью программного выбора требуемого диапазона по месту установки теплосчетчика.",
                "list": null,
                "table": null
            },
            {
                "isPreview": false,
                "header": null,
                "text": "Теплосчетчики исполнения 4 обеспечивают измерение расхода в одном диапазоне для каждого диаметра условного прохода ППР (см. таблицу 2). Измерение расхода в обратном трубопроводе обеспечивается при прямом и обратном направлении движения теплоносителя.",
                "list": null,
                "table": null
            },
            {
                "isPreview": false,
                "header": null,
                "text": "Теплосчетчики осуществляют вычисление и хранение как среднечасовой, так и среднесуточной статистической информации об измеряемых параметрах системы теплоснабжения, а также производят регистрацию ошибок в своей работе и работе сети теплоснабжения.",
                "list": null,
                "table": null
            },
            {
                "isPreview": false,
                "header": "Технические характеристики",
                "text": null,
                "list": null,
                "table": {
                    "columns": [
                        "",
                        ""
                    ],
                    "rows": [
                        {
                            "items": [
                                "Завод изготовитель:",
                                "СООО \u00ABАРВАС\u00BB"
                            ],
                            "isGroup": false,
                            "isGroupItem": false
                        },
                        {
                            "items": [
                                "Вес (кг):",
                                "2,5"
                            ],
                            "isGroup": false,
                            "isGroupItem": false
                        },
                        {
                            "items": [
                                "Габариты",
                                "180х182х95"
                            ],
                            "isGroup": false,
                            "isGroupItem": false
                        },
                        {
                            "items": [
                                "Уровень пылевлагозашиты:",
                                "IP55"
                            ],
                            "isGroup": false,
                            "isGroupItem": false
                        },
                        {
                            "items": [
                                "Средний срок службы (лет)",
                                "10"
                            ],
                            "isGroup": false,
                            "isGroupItem": false
                        },
                        {
                            "items": [
                                "Межповерочный интервал (мес.): ",
                                "24"
                            ],
                            "isGroup": false,
                            "isGroupItem": false
                        }
                    ]
                }
            }
        ]
};
//**************************************************************************************TEM05
//**************************************************************************************GVC2010 
const TEM106 = {
    id: "TEM106",
    name: "<b>TEM 106</b>",
    img: "/heatmeters/tem106.png",
    imgAlt: "TEM 106",
    description:
        [
            {
                "isPreview": true,
                "header": "",
                "text": "Теплосчетчик\u00A0 ТЭМ-106 многоканальный электромагнитный предназначен для измерения, индикации,регистрации, контроля, коммерческого и технологического учета значений потребленного (отпущенного) количества теплоты (тепловой энергии), теплоносителя и других параметров систем теплоснабжения и горячего водоснабжения, а также для автоматизации учета, телеметрического контроля и организации ",
                "list": null,
                "table": null
            },
            {
                "isPreview": false,
                "header": "",
                "text": "Теплосчетчик ТЭМ-106 является мультисистемным,многоканальным, составным, многофункциональным микропроцессорным счетчиком тепла со встроенным двухстрочном цифробуквенным жидкокристаллическим индикатором (ЖКИ).",
                "list": null,
                "table": null
            },
            {
                "isPreview": false,
                "header": "",
                "text": "Теплосчетчик ТЭМ-106 ведет учет потребления тепловой энергии и (или)теплоносителя в одной или нескольких системах. В каждой системе ведется учет по одной из типовых схем, реализуемых счетчиком тепла ТЭМ-106. ",
                "list": null,
                "table": null
            },
            {
                "isPreview": false,
                "header": "Области применения теплосчетчика ТЭМ-106:",
                "text": null,
                "list": {
                    "type": "dots",
                    "items": [
                        {
                            "text": "предприятия тепловых сетей, тепловые пункты жилых, общественных и производственных зданий;",
                            "sublist": null
                        },
                        {
                            "text": "центральные тепловые пункты (ЦТП), тепловые сети объектов (зданий) промышленного и бытового назначения, источники теплоты.",
                            "sublist": null
                        }
                    ]
                },
                "table": null
            },
            {
                "isPreview": false,
                "header": null,
                "text": "Теплосчетчики ТЭМ-106 могут быть использованы для создания автоматизированных систем контроля, учета и регулирования (АСУ ТП) тепловой энергии.",
                "list": null,
                "table": null
            },
            {
                "isPreview": false,
                "header": "Отличительные особенности и достоинства многоканального электромагнитного теплосчетчика ТЭМ-106:",
                "text": null,
                "list": {
                    "type": "dots",
                    "items": [
                        {
                            "text": "высокая точность измерения расхода теплоносителя;",
                            "sublist": null
                        },
                        {
                            "text": "широкий динамический диапазон измерения расхода – 1:400 (по заказу 1:1000);",
                            "sublist": null
                        },
                        {
                            "text": "возможность измерения расхода при обратном (реверсивном) движении теплоносителя;",
                            "sublist": null
                        },
                        {
                            "text": "отсутствие дополнительного гидравлического сопротивления",
                            "sublist": null
                        },
                        {
                            "text": "не требуются установка специальных сетчатых фильтров;",
                            "sublist": null
                        },
                        {
                            "text": "возможность выбора схем установки пользователем: в приборе предусмотрен выбор 12 различных теплотехнических схем установки;",
                            "sublist": null
                        },
                        {
                            "text": "возможность просмотра архива данных на индикаторе;",
                            "sublist": null
                        },
                        {
                            "text": "счетчик тепла ТЭМ-106 имеет режим самодиагностики с выводом на индикатор вычислителя символа нештатной ситуации в системе тепло или водоснабжения или технической неисправности;",
                            "sublist": null
                        },
                        {
                            "text": "малые длины прямолинейных участков для установки приборов (3Ду до и 1 Ду после первичного преобразователя расхода ППР)",
                            "sublist": null
                        },
                        {
                            "text": "гальваноразвязанный порт ввода-вывода RS-485.",
                            "sublist": null
                        }
                    ]
                },
                "table": null
            },
            {
                "isPreview": false,
                "header": "Технические характеристики",
                "text": null,
                "list": null,
                "table": {
                    "columns": [
                        "",
                        ""
                    ],
                    "rows": [
                        {
                            "items": [
                                "Завод изготовитель:",
                                "СООО \u00ABАРВАС\u00BB"
                            ],
                            "isGroup": false,
                            "isGroupItem": false
                        },
                        {
                            "items": [
                                "Вес (кг):",
                                "2"
                            ],
                            "isGroup": false,
                            "isGroupItem": false
                        },
                        {
                            "items": [
                                "Габариты",
                                "204x168x95"
                            ],
                            "isGroup": false,
                            "isGroupItem": false
                        },
                        {
                            "items": [
                                "Уровень пылевлагозашиты:",
                                "IP54"
                            ],
                            "isGroup": false,
                            "isGroupItem": false
                        },
                        {
                            "items": [
                                "Средний срок службы (лет)",
                                "10"
                            ],
                            "isGroup": false,
                            "isGroupItem": false
                        },
                        {
                            "items": [
                                "Средняя наработка на отказ (часов)",
                                "20000"
                            ],
                            "isGroup": false,
                            "isGroupItem": false
                        },
                        {
                            "items": [
                                "Межповерочный интервал (мес.): ",
                                "48"
                            ],
                            "isGroup": false,
                            "isGroupItem": false
                        }
                    ]
                }
            }
        ]
};
//**************************************************************************************GVC2010
//**************************************************************************************VIST
const VIST = {
    id: "VIST",
    name: "<b>ВИС-Т</b>",
    img: "/heatmeters/ВИС-Т.png",
    imgAlt: "ВИС-Т",
    description:
        [
            {
                "isPreview": true,
                "header": "",
                "text": "Универсальный многоканальный теплосчетчик ВИС.Т-ТС предназначен для измерения, вычисления, архивации, индикации и вывода на внешние устройства количества тепловой энергии (теплоты) и параметров теплоносителя в любых системах теплопотребления. При этом теплосчётчик может обслуживать одновременно до 3-х теплосистем произвольной конфигурации с индивидуальным набором параметров. Прибор может быть установлен как у потребителей, так и у производителей тепловой энергии, позволяя кардинальным образом сократить количество теплосчетчиков на узлах с большим числом труб. Это идеальное решение для всех случаев, в которых\u00A0прежде приходилось ставить более одного теплосчетчика.",
                "list": null,
                "table": null
            },
            {
                "isPreview": false,
                "header": null,
                "text": null,
                "list": null,
                "table": {
                    "columns": [
                        "Наименование параметра",
                        "Значения параметра"
                    ],
                    "rows": [
                        {
                            "items": [
                                "Диапазон верхних пределов измерения расхода, м3/ч",
                                "от 1 до 250"
                            ],
                            "isGroup": false,
                            "isGroupItem": false
                        },
                        {
                            "items": [
                                "Диаметр условного прохода ППР, мм",
                                "15, 25, 32, 40, 50, 80, 100, 150, 200, 300"
                            ],
                            "isGroup": false,
                            "isGroupItem": false
                        },
                        {
                            "items": [
                                "Температура измеряемой среды (теплоносителя), \u00BAC",
                                "от 0 до 150"
                            ],
                            "isGroup": false,
                            "isGroupItem": false
                        },
                        {
                            "items": [
                                "Диапазон измеряемой разности температур, \u00BAC",
                                "от 1 до 150"
                            ],
                            "isGroup": false,
                            "isGroupItem": false
                        },
                        {
                            "items": [
                                "Рабочее давление среды, МПа",
                                "2,5"
                            ],
                            "isGroup": false,
                            "isGroupItem": false
                        },
                        {
                            "items": [
                                "Требуемые прямолинейные участки трубопровода, Ду",
                                "3 до и 1 после места установки ППР"
                            ],
                            "isGroup": false,
                            "isGroupItem": false
                        },
                        {
                            "items": [
                                "Погрешность измерения объема (массы), %, в диапазоне расходов:"
                            ],
                            "isGroup": false,
                            "isGroupItem": false
                        },
                        {
                            "items": [
                                "\u00A0\u00A0\u00A00,4 (0,2; 0,1 - по заказу) - 10% от верхнего предела измерения расхода",
                                "не более 2,0"
                            ],
                            "isGroup": false,
                            "isGroupItem": false
                        },
                        {
                            "items": [
                                "\u00A0\u00A0\u00A010 - 100% от верхнего предела измерения расхода",
                                "не более 0,6 (0,2\u2014 по заказу)"
                            ],
                            "isGroup": false,
                            "isGroupItem": false
                        },
                        {
                            "items": [
                                "Погрешность измерения тепловой энергии (количества тепла), %",
                                "не более 4,0"
                            ],
                            "isGroup": false,
                            "isGroupItem": false
                        },
                        {
                            "items": [
                                "Динамический диапазон измерений расхода",
                                "1:250 (1:500, 1:1000 \u2014 по заказу)"
                            ],
                            "isGroup": false,
                            "isGroupItem": false
                        },
                        {
                            "items": [
                                "Абсолютная погрешность при измерении температуры, \u00B0C",
                                "не более 0,1"
                            ],
                            "isGroup": false,
                            "isGroupItem": false
                        },
                        {
                            "items": [
                                "Приведенная погрешность при измерении давления, %",
                                "не более 0,5"
                            ],
                            "isGroup": false,
                            "isGroupItem": false
                        },
                        {
                            "items": [
                                "Относительная погрешность при измерении времени, %",
                                "не более 0,01"
                            ],
                            "isGroup": false,
                            "isGroupItem": false
                        },
                        {
                            "items": [
                                "Потребляемая мощность от сети переменного тока 160-270В, 50Гц",
                                "от 30 до 70 ВА"
                            ],
                            "isGroup": false,
                            "isGroupItem": false
                        },
                        {
                            "items": [
                                "Архивы среднечасовых значений измеряемых параметров",
                                "до 99 суток"
                            ],
                            "isGroup": false,
                            "isGroupItem": false
                        }
                    ]
                }
            }
        ]
};
//**************************************************************************************VIST
//**************************************************************************************VKT5 
const VKT5 = {
    id: "VKT5",
    name: "<b>ВКТ-5</b>",
    img: "/heatmeters/ВКТ5.png",
    imgAlt: "ВКТ-5",
    description:
        [
            {
                "isPreview": true,
                "header": "",
                "text": "Тепловычислитель Теплоком ВКТ 5 - предназначен для работы в составе теплосчетчика, обеспечивающего учет и регулирование параметров теплоносителя и количества тепловой энергии воды и пара (перегретого, насыщенного) в открытых и закрытых системах теплоснабжения потребителей и производителей тепловой энергии.",
                "list": null,
                "table": null
            },
            {
                "isPreview": false,
                "header": "Функциональные возможности",
                "text": null,
                "list": {
                    "type": "dots",
                    "items": [
                        {
                            "text": "2-строчный алфавитно-цифровой ЖКИ с подсветкой.",
                            "sublist": null
                        },
                        {
                            "text": "8-кнопочная клавиатура.",
                            "sublist": null
                        },
                        {
                            "text": "Используемые трубопроводы свободно конфигурируются под любую схему теплопотребления (в том числе учет на источнике) под любое количество потребителей (в пределах 8). Давления и температуры могут измеряться или устанавливаться договорными, по выбору.",
                            "sublist": null
                        },
                        {
                            "text": "Имеется возможность расширения диапазона измерения расхода путем использования двух расходомеров переменного перепада на одном трубопроводе.",
                            "sublist": null
                        },
                        {
                            "text": "Работает с датчиками с выходными сигналами, пропорциональными расходу, перепаду или корню квадратному из перепада.",
                            "sublist": null
                        },
                        {
                            "text": "Работает со всеми видами теплоносителей (вода, насыщенный и перегретый пар).",
                            "sublist": null
                        },
                        {
                            "text": "Архив часовой, суточный, нарастающим итогом, нештатных ситуаций с возможностью удобного просмотра.",
                            "sublist": null
                        },
                        {
                            "text": "Отображение текущих температур, расходов, давлений.",
                            "sublist": null
                        },
                        {
                            "text": "Регистрация нештатных ситуаций в работе системы теплопотребления и выходов параметров теплоносителя за установленные допуски. При этом режим обработки информации программируется с клавиатуры.",
                            "sublist": null
                        },
                        {
                            "text": "Возможность распечатывать готовые отчеты на принтер.",
                            "sublist": null
                        },
                        {
                            "text": "Питание вычислителя обеспечивается от сети переменного тока 220 В.",
                            "sublist": null
                        },
                        {
                            "text": "При отсутствии напряжения питания вычислитель обеспечивает регистрацию времени его отсутствия и сохранение измерительной и настроечной информации.",
                            "sublist": null
                        },
                        {
                            "text": "Регистрация показаний результатов измерений.",
                            "sublist": null
                        },
                        {
                            "text": "Глубина архивации часовых и суточных параметров теплоносителя не менее 45 суток.",
                            "sublist": null
                        },
                        {
                            "text": "Срок хранения архива и параметров настройки при отключении питания не ограничен.",
                            "sublist": null
                        }
                    ]
                },
                "table": null
            },
            {
                "isPreview": false,
                "header": "Подключаемые датчики",
                "text": null,
                "list": {
                    "type": "dots",
                    "items": [
                        {
                            "text": "8 каналов измерения температуры (ТСМ/ТСП -50,100,500);",
                            "sublist": null
                        },
                        {
                            "text": "8 каналов измерения тока (0-5, 4-20, 0-20 мА);",
                            "sublist": null
                        },
                        {
                            "text": "8 каналов измерения частоты (до 1000 Гц).",
                            "sublist": null
                        }
                    ]
                },
                "table": null
            },
            {
                "isPreview": false,
                "header": "Интерфейсы",
                "text": null,
                "list": {
                    "type": "dots",
                    "items": [
                        {
                            "text": "RS232: подключение компьютера, модема, принтера, пультов для считывания архивов и переноса их на компьютер;",
                            "sublist": null
                        },
                        {
                            "text": "RS485: для объединения приборов в сеть при подключении к компьютеру;",
                            "sublist": null
                        },
                        {
                            "text": "CENTRONICS для подключения принтеров.",
                            "sublist": null
                        }
                    ]
                },
                "table": null
            },
            {
                "isPreview": false,
                "header": "Технические характеристики",
                "text": null,
                "list": null,
                "table": {
                    "columns": [
                        "",
                        ""
                    ],
                    "rows": [
                        {
                            "items": [
                                "Завод изготовитель:",
                                "ЗАО \u00ABНПФ Теплоком\u00BB"
                            ],
                            "isGroup": false,
                            "isGroupItem": false
                        },
                        {
                            "items": [
                                "Вес (кг):",
                                "1,5"
                            ],
                            "isGroup": false,
                            "isGroupItem": false
                        },
                        {
                            "items": [
                                "Габариты",
                                "225х80х180"
                            ],
                            "isGroup": false,
                            "isGroupItem": false
                        },
                        {
                            "items": [
                                "Уровень пылевлагозашиты:",
                                "IP55"
                            ],
                            "isGroup": false,
                            "isGroupItem": false
                        },
                        {
                            "items": [
                                "Средний срок службы (лет)",
                                "15"
                            ],
                            "isGroup": false,
                            "isGroupItem": false
                        },
                        {
                            "items": [
                                "Средняя наработка на отказ (часов)",
                                "80000"
                            ],
                            "isGroup": false,
                            "isGroupItem": false
                        },
                        {
                            "items": [
                                "Межповерочный интервал (мес.): ",
                                "48"
                            ],
                            "isGroup": false,
                            "isGroupItem": false
                        },
                        {
                            "items": [
                                "Гарантийный срок (мес.): ",
                                "72"
                            ],
                            "isGroup": false,
                            "isGroupItem": false
                        }
                    ]
                }
            }
        ]
};
//**************************************************************************************VKT5
//**************************************************************************************VKT7 
const VKT7 = {
    id: "VKT",
    name: "<b>ВКТ-7</b>",
    img: "/heatmeters/ВКТ7.png",
    imgAlt: "ВКТ-7",
    description:
        [
            {
                "isPreview": true,
                "header": "ВКТ-7 тепловычислитель",
                "text": "Многоканальный Вычислитель Количества Теплоты ВКТ-7-01\u202604 \u2014 тепловычислитель предназначеный для учета, регистрации, дистанционного мониторинга теплопотребления и параметров теплоносителя в двух закрытых и открытых системах водяного теплоснабжения, каждая из которых может содержать трубопроводы: подающий, обратный и ГВС, подпитки либо питьевой воды.",
                "list": null,
                "table": null
            },
            {
                "isPreview": false,
                "header": "",
                "text": "Тепловычислители ВКТ-7 могут применяться в составе теплосчетчиков ТС и измерительных систем, предназначенных для измерений параметров теплоносителя (расхода, объема, температуры, давления), количества теплоты (тепловой энергии) и теплоносителя в водяных системах теплопотребления, а также для измерений количества других измеряемых сред (например, электроэнергии или холодной воды).",
                "list": null,
                "table": null
            },
            {
                "isPreview": false,
                "header": "",
                "text": "Тепловычислитель ВКТ-7 в составе теплосчетчиков  и ТСК-8 предназначен для ведения учета, контроля, регистрации и дистанционного мониторинга потребления тепла, горячей и холодной воды двумя потребителями.",
                "list": null,
                "table": null
            },
            {
                "isPreview": false,
                "header": "",
                "text": "Тепловычислитель ВКТ-7 является энергонезависимым, безопасным в эксплуатации и сочетает в себе достоинства лучших аналогов. Благодаря идеологии \u00ABдва тепловычислителя в одном корпусе\u00BB теплосчетчики, построенные на базе ВКТ-7, наилучшим образом подходят для учета тепла на объектах жилищно-коммунальной сферы\u00A0в составе .",
                "list": null,
                "table": null
            },
            {
                "isPreview": false,
                "header": "Технические характеристики",
                "text": null,
                "list": null,
                "table": {
                    "columns": [
                        "",
                        ""
                    ],
                    "rows": [
                        {
                            "items": [
                                "Завод изготовитель:",
                                "ЗАО \u00ABНПФ Теплоком\u00BB"
                            ],
                            "isGroup": false,
                            "isGroupItem": false
                        },
                        {
                            "items": [
                                "Вес (кг):",
                                "0,75"
                            ],
                            "isGroup": false,
                            "isGroupItem": false
                        },
                        {
                            "items": [
                                "Габариты",
                                "140x100x64"
                            ],
                            "isGroup": false,
                            "isGroupItem": false
                        },
                        {
                            "items": [
                                "Уровень пылевлагозашиты:",
                                "IP54"
                            ],
                            "isGroup": false,
                            "isGroupItem": false
                        },
                        {
                            "items": [
                                "Средний срок службы (лет)",
                                "12"
                            ],
                            "isGroup": false,
                            "isGroupItem": false
                        },
                        {
                            "items": [
                                "Средняя наработка на отказ (часов)",
                                "75000"
                            ],
                            "isGroup": false,
                            "isGroupItem": false
                        },
                        {
                            "items": [
                                "Межповерочный интервал (мес.): ",
                                "48"
                            ],
                            "isGroup": false,
                            "isGroupItem": false
                        },
                        {
                            "items": [
                                "Гарантийный срок (мес.): ",
                                "72"
                            ],
                            "isGroup": false,
                            "isGroupItem": false
                        }
                    ]
                }
            }
        ]
};
//**************************************************************************************VKT7
//**************************************************************************************VTR10I
const VTR10I = {
    id: "VTR10I",
    name: "<b>ВТР-10И</b>",
    img: "/heatmeters/ВТР10И.png",
    imgAlt: "ВТР-10И",
    description:
        [
            {
                "isPreview": true,
                "header": "",
                "text": "Микропроцессорные блоки терморегулирования ВТР 10И (далее - регуляторы) предназначены для автоматического  поддержания заданного значения температуры горячей воды на выходе теплообменника, автоматического управления системой  отопления здания с целью оптимизации расходования тепловой энергии, а также для использования в составе систем управления  технологическими процессами в качестве регуляторов температуры.  Отличительной особенностью данных блоков является наличие в памяти микропроцессора набора типовых программ.  Пользователь имеет возможность задавать с клавиатуры блока номер программы, обеспечивающей выполнение требуемых функций.  Возможно использование блоков в составе контрольно-измерительных комплексов через встроенный интерфейс RS 232.",
                "list": null,
                "table": null
            },
            {
                "isPreview": false,
                "header": "Основные Функции:",
                "text": null,
                "list": {
                    "type": "dots",
                    "items": [
                        {
                            "text": "Управление одним контуром отопления",
                            "sublist": null
                        },
                        {
                            "text": "Поддержание задаваемого пользователем температурного графика отопления (температуры смешанной воды в зависимости от температуры наружного воздуха) в одном контуре отопления. ",
                            "sublist": null
                        },
                        {
                            "text": "Возможность снижения температуры смеси в заданное время по задаваемому пользователем недельному графику.",
                            "sublist": null
                        },
                        {
                            "text": "Контроль (внешние контактные датчики в количестве до 3-х, в зависимости от выбранной проектировщиком технологической схемы) и управление (автоматический ввод резервного насоса при отказе основного) работой основного и резервного насосов системы отопления.",
                            "sublist": null
                        },
                        {
                            "text": "Возможность задания пользователем аварийного состояния контактных датчиков контроля работы насосов (замкнут или разомкнут). ",
                            "sublist": null
                        },
                        {
                            "text": "Возможность задания пользователем режима \u00ABресурс\u00BB для равномерной выработки ресурса насосов. ",
                            "sublist": null
                        },
                        {
                            "text": "Контроль температуры обратной воды (защита от замораживания здания). ",
                            "sublist": null
                        },
                        {
                            "text": "Управление двумя контурами отопления",
                            "sublist": null
                        },
                        {
                            "text": "Поддержание задаваемых пользователем температурных графиков отопления (температуры смешанной воды в зависимости от температуры наружного воздуха) в двух контурах отопления. ",
                            "sublist": null
                        },
                        {
                            "text": "Возможность снижения температуры смеси в заданное время по задаваемому пользователем недельному графику для каждого контура. ",
                            "sublist": null
                        },
                        {
                            "text": "Управление работой насосов в двух контурах системы отопления (контроль по внешнему датчику отсутствует).",
                            "sublist": null
                        },
                        {
                            "text": "Контроль температуры обратной воды в каждом контуре (защита от замораживания здания).",
                            "sublist": null
                        },
                        {
                            "text": "Управление одним контуром горячего водоснабжения",
                            "sublist": null
                        },
                        {
                            "text": "Поддержание задаваемого пользователем значения температуры горячей воды в одном контуре ГВС. ",
                            "sublist": null
                        },
                        {
                            "text": "Возможность снижения температуры горячей воды или отключения ГВС с одновременным выключением циркуляционного насоса в заданное время по задаваемому пользователем недельному графику. ",
                            "sublist": null
                        },
                        {
                            "text": "Контроль (внешние контактные датчики в количестве до 3-х, в зависимости от выбранной проектировщиком технологической схемы) и управление (автоматический ввод резервного насоса при отказе основного) работой основного и резервного насосов системы ГВС.",
                            "sublist": null
                        },
                        {
                            "text": "Возможность задания пользователем аварийного состояния контактных датчиков контроля работы насосов (замкнут или разомкнут). ",
                            "sublist": null
                        },
                        {
                            "text": "Возможность задания пользователем режима \u00ABресурс\u00BB для равномерной выработки ресурса насосов, при этом раз в неделю в заданное время происходит переключение насосов. ",
                            "sublist": null
                        },
                        {
                            "text": "Возможность контроля температур сетевой (прямой) в обратной воды. ",
                            "sublist": null
                        },
                        {
                            "text": "Управление двумя контурами горячего водоснабжения",
                            "sublist": null
                        },
                        {
                            "text": "Поддержание задаваемого пользователем значения температуры горячей воды в двух контурах ГВС. ",
                            "sublist": null
                        },
                        {
                            "text": "Возможность снижения температуры горячей воды или отключения ГВС с одновременным выключением циркуляционного насоса в заданное время по задаваемому пользователем недельному графику для каждого из контуров. ",
                            "sublist": null
                        },
                        {
                            "text": "Контроль (внешний контактный датчик) и управление работой циркуляционного насоса в каждом контуре. ",
                            "sublist": null
                        },
                        {
                            "text": "Управление одним контуром отопления и одним контуром горячего водоснабжения",
                            "sublist": null
                        },
                        {
                            "text": "Поддержание задаваемого пользователем температурного графика отопления (температуры смешанной воды в зависимости от температуры наружного воздуха) в одном контуре отопления. ",
                            "sublist": null
                        },
                        {
                            "text": "Возможность снижения температуры смеси в заданное время по задаваемому пользователем недельному графику. ",
                            "sublist": null
                        },
                        {
                            "text": "Контроль (внешний контактный датчик) и управление работой насоса системы отопления. ",
                            "sublist": null
                        },
                        {
                            "text": "Контроль температуры обратной воды (защита от замораживания здания). ",
                            "sublist": null
                        },
                        {
                            "text": "Поддержание задаваемого пользователем значения температуры горячей воды в одном контуре ГВС.",
                            "sublist": null
                        },
                        {
                            "text": "Возможность снижения температуры горячей воды или отключения ГВС с одновременным выключением циркуляционного насоса в заданное время по задаваемому пользователем недельному графику. ",
                            "sublist": null
                        },
                        {
                            "text": "Контроль (внешний контактный датчик) и управление работой циркуляционного насоса ГВС.",
                            "sublist": null
                        },
                        {
                            "text": "Управление установкой приточной вентиляции",
                            "sublist": null
                        },
                        {
                            "text": "Управление исполнительным механизмом (клапаном), регулирующим подачу теплоносителя в калорифер;",
                            "sublist": null
                        },
                        {
                            "text": "Управление вентилятором и электроприводом жалюзи (задаваемая пользователем задержка на включение для прогрева калорифера, автоматическое отключение при снижении температуры обратной воды или температуры приточного воздуха ниже заданной, обеспечивающее защиту от замораживания калорифера); ",
                            "sublist": null
                        },
                        {
                            "text": "Поддержание заданной пользователем температуры приточного воздуха : ",
                            "sublist": null
                        },
                        {
                            "text": "Контроль за температурой обратной воды, обеспечивающий защиту от замораживания калорифера и ограничение температуры графиком Тобр.=f(Тнаружного воздуха), задаваемым пользователем; ",
                            "sublist": null
                        },
                        {
                            "text": "Автоматическое включение режима \u00ABЛЕТНИЙ\u00BB при температуре наружного воздуха, задаваемой пользователем.",
                            "sublist": null
                        }
                    ]
                },
                "table": null
            }
        ]
};
//**************************************************************************************VTR10I
//**************************************************************************************VTR210I
const VTR210I = {
    id: "VTR210I",
    name: "<b>ВТР-210И</b>",
    img: "/heatmeters/ВТР210И.png",
    imgAlt: "ВТР-210И",
    description:
        [
            {
                "isPreview": true,
                "header": null,
                "text": "Микропроцессорный блок терморегулирования ВТР 210И\u00A0 предназначен для автоматического поддержания заданного значения температуры горячей воды на выходе теплообменника, автоматического управления системой отопления здания с целью оптимизации расходования тепловой энергии, управления системой приточной вентиляции, а также для использования в составе систем управления технологическими процессами в качестве регуляторов температуры. ",
                "list": null,
                "table": null
            },
            {
                "isPreview": false,
                "header": null,
                "text": "Отличительной особенностью ВТР 210И является наличие в памяти микропроцессора набора типовых программ. Пользователь имеет возможность задавать с клавиатуры регулятора номер программы, обеспечивающей выполнение требуемых функций.\u00A0",
                "list": null,
                "table": null
            },
            {
                "isPreview": false,
                "header": "Мультипрограммный контроллер ВТР 210И:",
                "text": null,
                "list": {
                    "type": "dots",
                    "items": [
                        {
                            "text": "10 программ, задаваемых пользователем с клавиатуры контролера, в зависимости от функционального назначения;",
                            "sublist": null
                        },
                        {
                            "text": "2 контура регулирования;",
                            "sublist": null
                        },
                        {
                            "text": "автоматическая настройка коэффициентов регулирования;",
                            "sublist": null
                        },
                        {
                            "text": "8 релейных выходов для управления основным и резервным насосами, а так же регулирующим клапаном в каждом из контуров;",
                            "sublist": null
                        },
                        {
                            "text": "дополнительный релейный выход для подключения аварийной сигнализации(отказ насосов, отказ датчиков температуры, выход регулируемых и контролируемых температур за заданные пределы);",
                            "sublist": null
                        },
                        {
                            "text": "6 каналов измерения температуры для датчиков Pt500, Pt1000 с автоматическим определением температурной характеристики;",
                            "sublist": null
                        },
                        {
                            "text": "4 входа для подключения контактных датчиков контроля работы насосов;",
                            "sublist": null
                        },
                        {
                            "text": "2 аналоговых входа для подключения датчиков давления (перепада давления) с токовым сигналом 4-20 мА;",
                            "sublist": null
                        },
                        {
                            "text": "энергонезависимый архив всех измеряемых температур (3250 значений с задаваемым интервалом записи от 1 до 30 мин);",
                            "sublist": null
                        },
                        {
                            "text": "интерфейс RS485, RS232;",
                            "sublist": null
                        },
                        {
                            "text": "габаритные размеры 130х90х65.",
                            "sublist": null
                        }
                    ]
                },
                "table": null
            },
            {
                "isPreview": false,
                "header": null,
                "text": null,
                "list": null,
                "table": {
                    "columns": [
                        "Тип контура регулирования ",
                        "Основные функции "
                    ],
                    "rows": [
                        {
                            "items": [
                                "ОТП ",
                                "Поддержание задаваемого пользователем температурного графика отопления, с количеством контрольных точек от двух до восьми.Возможность снижения температуры смеси в заданное время по задаваемому пользователем недельному графику.Возможность задания режима включения - отключения контура отопления в зависимости от значения температуры наружного воздуха. Контроль и управление (автоматический ввод резервного насоса при отказе основного) работой основного и резервного насосов системы отопления. Возможность задания пользователем аварийного состояния контактных датчиков контроля работы насосов (замкнут или разомкнут). Возможность задания пользователем режима \u00ABресурс\u00BB для равномерной выработки ресурса насосов. Ограничение температуры обратной воды в соответствии с задаваемым графиком.\u00A0 "
                            ],
                            "isGroup": false,
                            "isGroupItem": false
                        },
                        {
                            "items": [
                                "ГВС ",
                                "Управление контуром горячего водоснабженияПоддержание задаваемого пользователем значения температуры горячей воды в контуре ГВС.Возможность снижения температуры горячей воды или отключения ГВС с одновременным выключением циркуляционного насоса в заданное время по задаваемому пользователем недельному графику. Контроль (внешние контактные датчики в количестве до 2-х, в зависимости от выбранной проектировщиком технологической схемы) и управление (автоматический ввод резервного насоса при отказе основного) работой основного и резервного насосов системы ГВС. Возможность задания пользователем аварийного состояния контактных датчиков контроля работы насосов (замкнут или разомкнут). Защита насосов от \u00ABсухого\u00BB хода.Возможность задания пользователем режима \u00ABресурс\u00BB для равномерной выработки ресурса насосов.Возможность ограничения температуры обратной воды. Возможность задания пользователем режима \u00ABдезинфекция\u00BB.\u00A0 "
                            ],
                            "isGroup": false,
                            "isGroupItem": false
                        },
                        {
                            "items": [
                                "ПДП ",
                                "Управление системой подпиткиПоддержание давления в нагреваемом контуре на заданном уровне. Контроль работы основного резервного насосов через внешний контактный датчик.Управление работой основного и резервного насосов. Защита насосов от \u00ABсухого\u00BB хода.Возможность задания пользователем аварийного состояния контактных датчиков контроля работы насосов (замкнут или разомкнут). Возможность задания пользователем режима \u00ABресурс\u00BB для равномерной выработки ресурса насосов.\u00A0 "
                            ],
                            "isGroup": false,
                            "isGroupItem": false
                        },
                        {
                            "items": [
                                "АВР ",
                                "Управление основным и резервным насосамиКонтроль работы основного резервного насосов через внешний контактный датчик.Управление работой основного и резервного насосов. Защита насосов от \u00ABсухого\u00BB хода.Возможность задания пользователем аварийного состояния контактных датчиков контроля работы насосов (замкнут или разомкнут). Возможность задания пользователем режима \u00ABресурс\u00BB для равномерной выработки ресурса насосов."
                            ],
                            "isGroup": false,
                            "isGroupItem": false
                        },
                        {
                            "items": [
                                "ВЕНТ ",
                                "Управление установкой приточной вентиляции "
                            ],
                            "isGroup": false,
                            "isGroupItem": false
                        }
                    ]
                }
            },
            {
                "isPreview": false,
                "header": "Технические характеристики",
                "text": null,
                "list": null,
                "table": {
                    "columns": [
                        "",
                        ""
                    ],
                    "rows": [
                        {
                            "items": [
                                "Завод изготовитель:",
                                "ООО \u00ABВогезэнерго\u00BB"
                            ],
                            "isGroup": false,
                            "isGroupItem": false
                        },
                        {
                            "items": [
                                "Вес (кг):",
                                "0,8"
                            ],
                            "isGroup": false,
                            "isGroupItem": false
                        },
                        {
                            "items": [
                                "Габариты",
                                "138x90x65"
                            ],
                            "isGroup": false,
                            "isGroupItem": false
                        },
                        {
                            "items": [
                                "Уровень пылевлагозашиты:",
                                "IP20"
                            ],
                            "isGroup": false,
                            "isGroupItem": false
                        },
                        {
                            "items": [
                                "Средний срок службы (лет)",
                                "10"
                            ],
                            "isGroup": false,
                            "isGroupItem": false
                        }
                    ]
                }
            }
        ]
};
//**************************************************************************************VTR210I
//**************************************************************************************VTE1
const VTE1 = {
    id: "VTE1",
    name: "<b>ВТЭ-1</b>",
    img: "/heatmeters/ВТЭ-1.png",
    imgAlt: "ВТЭ-1",
    description:
        [
            {
                "isPreview": true,
                "header": "",
                "text": "Тепловычислитель ВТЭ-1 предназначен для измерения и учета\u00A0тепловой энергии (количества теплоты), параметров и расхода (объема)\u00A0теплоносителя в системах теплоснабжения в\u00A0составе \u00A0Для параметров воды, а так же электричества.",
                "list": null,
                "table": null
            },
            {
                "isPreview": false,
                "header": " ",
                "text": "",
                "list": null,
                "table": null
            },
            {
                "isPreview": false,
                "header": "Модификации вычислителей ВТЭ-1:ВТЭ-1К1",
                "text": null,
                "list": {
                    "type": "dots",
                    "items": [
                        {
                            "text": "подключение до 3 шт. счетчиков воды",
                            "sublist": null
                        },
                        {
                            "text": "вход импульсов от электросчетчика",
                            "sublist": null
                        },
                        {
                            "text": "дополнительный \u00A0термопреобразователь для ГВС",
                            "sublist": null
                        },
                        {
                            "text": "интерфейс \u00A0RS 232",
                            "sublist": null
                        }
                    ]
                },
                "table": null
            },
            {
                "isPreview": false,
                "header": "ВТЭ-1К1М",
                "text": null,
                "list": {
                    "type": "dots",
                    "items": [
                        {
                            "text": "подключение до 3 шт. счетчиков воды",
                            "sublist": null
                        },
                        {
                            "text": "доп. термопреобра-зователь для ГВС",
                            "sublist": null
                        },
                        {
                            "text": "интерфейс RS 232",
                            "sublist": null
                        },
                        {
                            "text": "наличие сетевого протокола \u00A0ModBus RTU",
                            "sublist": null
                        },
                        {
                            "text": "отсутствуют вход для импульсов от электросчетчика и функция ограничения учета объема горячей воды в зависимости от ее температуры",
                            "sublist": null
                        }
                    ]
                },
                "table": null
            },
            {
                "isPreview": false,
                "header": "ВТЭ-1К2",
                "text": null,
                "list": {
                    "type": "dots",
                    "items": [
                        {
                            "text": "подключение до 3 шт. счетчиков воды",
                            "sublist": null
                        },
                        {
                            "text": "вход импульсов от электросчетчика",
                            "sublist": null
                        },
                        {
                            "text": "дополнительный \u00A0термопреобразователь для ГВС",
                            "sublist": null
                        },
                        {
                            "text": "интерфейс RS 485",
                            "sublist": null
                        }
                    ]
                },
                "table": null
            },
            {
                "isPreview": false,
                "header": "ВТЭ-1К2М",
                "text": null,
                "list": {
                    "type": "dots",
                    "items": [
                        {
                            "text": "подключение до 3 шт. счетчиков воды",
                            "sublist": null
                        },
                        {
                            "text": "доп. термопреобра-зователь для ГВС",
                            "sublist": null
                        },
                        {
                            "text": "интерфейс RS 485",
                            "sublist": null
                        },
                        {
                            "text": "наличие сетевого протокола \u00A0ModBus RTU",
                            "sublist": null
                        },
                        {
                            "text": "отсутствуют вход для импульсов от электросчетчика и функция ограничения учета объема горячей воды в зависимости от ее температуры",
                            "sublist": null
                        }
                    ]
                },
                "table": null
            },
            {
                "isPreview": false,
                "header": "ВТЭ-1К3",
                "text": null,
                "list": {
                    "type": "dots",
                    "items": [
                        {
                            "text": "подключение до 4 шт. \u00A0счетчиков воды",
                            "sublist": null
                        },
                        {
                            "text": "дополнительный \u00A0термопреобразователь \u00A0 для ГВС",
                            "sublist": null
                        },
                        {
                            "text": "интерфейс RS 485",
                            "sublist": null
                        }
                    ]
                },
                "table": null
            },
            {
                "isPreview": false,
                "header": "ВТЭ-1П140/141",
                "text": null,
                "list": {
                    "type": "dots",
                    "items": [
                        {
                            "text": "две независимые системы теплоснабжения",
                            "sublist": null
                        },
                        {
                            "text": "подключение до 6 шт. счетчиков воды",
                            "sublist": null
                        },
                        {
                            "text": "6 шт. \u00A0термопреобразователей",
                            "sublist": null
                        },
                        {
                            "text": "4 шт. \u00A0датчиков \u00A0давления с токовым \u00A0выходом",
                            "sublist": null
                        },
                        {
                            "text": "печать архивных данных на принтер",
                            "sublist": null
                        },
                        {
                            "text": "автоматическое переключение \u00A0температуры \u00A0холодной воды для открытых систем в зависимости от времени \u00A0года",
                            "sublist": null
                        },
                        {
                            "text": "интерфейс RS 232, RS 485",
                            "sublist": null
                        },
                        {
                            "text": "наличие сетевого протокола \u00A0ModBus RTU",
                            "sublist": null
                        }
                    ]
                },
                "table": null
            },
            {
                "isPreview": false,
                "header": "ВТЭ-1П150/151",
                "text": null,
                "list": {
                    "type": "dots",
                    "items": [
                        {
                            "text": "одна системы теплоснабжения",
                            "sublist": null
                        },
                        {
                            "text": "подключение до 3 шт. счетчиков воды",
                            "sublist": null
                        },
                        {
                            "text": "3 шт. \u00A0термопреобразователей",
                            "sublist": null
                        },
                        {
                            "text": "2 шт. \u00A0датчиков \u00A0давления с токовым \u00A0выходом",
                            "sublist": null
                        },
                        {
                            "text": "печать архивных данных на принтер",
                            "sublist": null
                        },
                        {
                            "text": "автоматическое переключение \u00A0температуры \u00A0холодной воды для открытых систем в зависимости от времени \u00A0года",
                            "sublist": null
                        },
                        {
                            "text": "интерфейс RS 232, RS 485",
                            "sublist": null
                        },
                        {
                            "text": "наличие сетевого протокола \u00A0ModBus RTU",
                            "sublist": null
                        }
                    ]
                },
                "table": null
            },
            {
                "isPreview": false,
                "header": "Технические характеристики",
                "text": null,
                "list": null,
                "table": {
                    "columns": [
                        "",
                        ""
                    ],
                    "rows": [
                        {
                            "items": [
                                "Завод изготовитель:",
                                "ЗАО \u00ABТепловодомер\u00BB"
                            ],
                            "isGroup": false,
                            "isGroupItem": false
                        },
                        {
                            "items": [
                                "Вес (кг):",
                                "0,4"
                            ],
                            "isGroup": false,
                            "isGroupItem": false
                        },
                        {
                            "items": [
                                "Габариты",
                                "90x115x50"
                            ],
                            "isGroup": false,
                            "isGroupItem": false
                        },
                        {
                            "items": [
                                "Средний срок службы (лет)",
                                "12"
                            ],
                            "isGroup": false,
                            "isGroupItem": false
                        },
                        {
                            "items": [
                                "Межповерочный интервал (мес.): ",
                                "48"
                            ],
                            "isGroup": false,
                            "isGroupItem": false
                        },
                        {
                            "items": [
                                "Гарантийный срок (мес.): ",
                                "10"
                            ],
                            "isGroup": false,
                            "isGroupItem": false
                        }
                    ]
                }
            }
        ]
};
//**************************************************************************************VTE1
//**************************************************************************************DELTAM
const DELTAM = {
    id: "DELTAM",
    name: "<b>Дельта-М</b>",
    img: "/heatmeters/Дельта-М.png",
    imgAlt: "Дельта-М",
    description:
        [
            {
                "isPreview": true,
                "header": "Дельта-М прибор контроля жесткости воды",
                "text": "Прибор контроля изменения жесткости сетевой воды \u00ABДельта-М\u00BB дает возможность автоматически выявлять утечки в водоводяных подогревателях в режиме реального времени по изменению физико-химических свойств воды при условии, что давление в контуре нагреваемой (сырой) воды больше давления в контуре греющей (сетевой) воды. В случае изменения жесткости выше установленного значения, прибор формирует аварийный сигнал (на передней панели блока загорается красный светодиод) и передает аварийный сигнал в систему диспетчеризации. Прибор имеет ПЗУ (постоянное запоминающее устройство), позволяющее хранить информацию о параметрах воды (температура, жесткость) в течение 2-х лет, привязанных к календарному времени.",
                "list": null,
                "table": null
            },
            {
                "isPreview": false,
                "header": "Технические характеристики прибора контроля жесткости воды Дельта-М",
                "text": null,
                "list": null,
                "table": {
                    "columns": [
                        "Наименование",
                        "Значение"
                    ],
                    "rows": [
                        {
                            "items": [
                                "Основные функции",
                                "\u2014 автоматический контроль изменения жёсткости сетевой воды на выходе из теплового пункта в процессе его эксплуатации\u2014 формирования аварийных сигналов при изменении жесткости выше установленного порога"
                            ],
                            "isGroup": false,
                            "isGroupItem": false
                        },
                        {
                            "items": [
                                "Диапазон контролируемой жесткости",
                                "50-1000\u00A0 мкг-экв/л"
                            ],
                            "isGroup": false,
                            "isGroupItem": false
                        },
                        {
                            "items": [
                                "Порог регистрации изменения жесткости",
                                "20\u00A0мкг-экв/л"
                            ],
                            "isGroup": false,
                            "isGroupItem": false
                        },
                        {
                            "items": [
                                "Время выхода на рабочий режим",
                                "не более 48 часов"
                            ],
                            "isGroup": false,
                            "isGroupItem": false
                        },
                        {
                            "items": [
                                "Мощность, потребляемая устройством",
                                "не более 10 ВА"
                            ],
                            "isGroup": false,
                            "isGroupItem": false
                        },
                        {
                            "items": [
                                "Напряжение питания (частота 50 Гц)",
                                "220 В \u00B110%"
                            ],
                            "isGroup": false,
                            "isGroupItem": false
                        },
                        {
                            "items": [
                                "Габаритные размеры, мм",
                                "электронный блок \u2014 181х256х111датчик ДЖ-4 \u2014\u00A0\u00D828х47"
                            ],
                            "isGroup": false,
                            "isGroupItem": false
                        },
                        {
                            "items": [
                                "Масса",
                                "\u00A0не более 5 кг"
                            ],
                            "isGroup": false,
                            "isGroupItem": false
                        }
                    ]
                }
            }
        ]
};
//**************************************************************************************DELTAM
//**************************************************************************************IM2300
const IM2300 = {
    id: "IM2300",
    name: "<b>ИМ-2300</b>",
    img: "/heatmeters/ИМ-2300ТМ.png",
    imgAlt: "ИМ-2300",
    description:
        [
            {
                "isPreview": true,
                "header": null,
                "text": "Теплосчетчик ИМ2300 предназначен для измерений, контроля и регистрации объемного расхода, объема, давления, температуры, количества тепловой энергии в закрытых и открытых системах водяного теплоснабжения и в системах парового теплоснабжения в соответствии с \u00ABПравилами коммерческого учета тепловой энергии, теплоносителя\u00BB (2013 г.).",
                "list": null,
                "table": null
            },
            {
                "isPreview": false,
                "header": null,
                "text": "Теплосчетчик ИМ2300 обеспечивает непрерывный круглосуточный автоматический режим сбора параметров по каналам измерения объемного расхода, объема, температуры, давления и расчет параметров теплоносителя и тепловой энергии. ",
                "list": null,
                "table": null
            },
            {
                "isPreview": false,
                "header": null,
                "text": "Теплосчетчик ведет учет времени работы, регистрацию во внутреннем архиве теплосчетчика и индикацию текущих параметров на встроенном табло, передачу текущих и архивных параметров на верхний уровень (персональный компьютер – ПК) по его запросу, просмотр архивных и текущих параметров и формирование отчетных документов на персональном компьютере в табличном и графическом форматах по инициативе обслуживающего персонала. Глубина архива среднечасовой информации составляет не менее 100 суток. ",
                "list": null,
                "table": null
            },
            {
                "isPreview": false,
                "header": "В архиве теплосчетчика регистрируются следующие интервалы времени: ",
                "text": null,
                "list": {
                    "type": "dots",
                    "items": [
                        {
                            "text": "время штатной работы теплосчетчика, ч;",
                            "sublist": null
                        },
                        {
                            "text": "интервал времени, в котором расход теплоносителя был меньше минимального значения, указанного в паспорте прибора, ч;",
                            "sublist": null
                        },
                        {
                            "text": "интервал времени, в котором расход теплоносителя был больше максимально допустимого значения, указанного в паспорте прибора, ч;",
                            "sublist": null
                        },
                        {
                            "text": "интервал времени, в котором разность температур была меньше допустимого значения, указанного в паспорте прибора, ч;",
                            "sublist": null
                        },
                        {
                            "text": "время действия нештатных ситуаций;",
                            "sublist": null
                        },
                        {
                            "text": "интервал времени, в котором питание теплосчетчика или расходомеров было отключено, ч.",
                            "sublist": null
                        }
                    ]
                },
                "table": null
            },
            {
                "isPreview": false,
                "header": "Область применения:",
                "text": null,
                "list": {
                    "type": "dots",
                    "items": [
                        {
                            "text": "предприятия тепловых сетей, тепловые пункты, ",
                            "sublist": null
                        },
                        {
                            "text": "тепловые сети объектов (зданий) промышленного и бытового назначения.",
                            "sublist": null
                        }
                    ]
                },
                "table": null
            },
            {
                "isPreview": false,
                "header": null,
                "text": "Интервал между поверками теплосчетчиков – 4 года.",
                "list": null,
                "table": null
            }
        ]
};
//**************************************************************************************IM2300
//**************************************************************************************IRVIKON_VT200
const IRVIKON_VT200 = {
    id: "IRVIKON_VT200",
    name: "<b>Ирвикон ВТ200</b>",
    img: "/heatmeters/Ирвикон_ВТ200.png",
    imgAlt: "Ирвикон ВТ200",
    description:
        [
            {
                "isPreview": true,
                "header": "ИРВИКОН ТС-200 теплосчетчик ультразвуковой",
                "text": "Теплосчетчик\u00A0ультразвуковой ИРВИКОН ТС-200\u00A0разработан для измерения, регистрации и коммерческого учета тепловой энергии в открытых и закрытых системах теплоснабжения промышленных и бытовых зданиях и сооружениях. Данный теплосчетчик также может регистрировать параметры потребления тепла и воды без измерения количества тепловой энергии, а так же измерять температуру воздуха.",
                "list": null,
                "table": null
            },
            {
                "isPreview": false,
                "header": "",
                "text": "В состав прибора могут входить до 4-х датчиков расхода, до 4-х датчиков температуры и 2 датчика давления. В качестве датчиков расхода используются ультразвуковые или турбинные и крыльчатые преобразователи. Теплосчетчик ИРВИКОН автоматически осуществляет диагностику, фиксируя в архиве нарушения в работе собственных узлов, а также выход измеряемых параметров\u00A0 за допустимые пределы. Прибор обеспечивает архивирование часовых значений параметров за 45 суток, суточных за 1,5 года, месячных за 5 лет. Срок хранения информации при выключенном питании \u2014 до 10 лет.",
                "list": null,
                "table": null
            },
            {
                "isPreview": false,
                "header": "Функциональные особенности теплосчетчиков ИРВИКОН ТС-200",
                "text": null,
                "list": {
                    "type": "dots",
                    "items": [
                        {
                            "text": "измерение объема, массы, расхода, температуры и давления теплоносителя",
                            "sublist": null
                        },
                        {
                            "text": "регистрация количества теплоэнергии, массы, объема, средней температуры, средней разности температур и среднего давления",
                            "sublist": null
                        },
                        {
                            "text": "индикация показаний текущих и архивных параметров и их вывод на компьютер или принтер",
                            "sublist": null
                        },
                        {
                            "text": "архивация почасовых, посуточных и помесячных данных",
                            "sublist": null
                        },
                        {
                            "text": "проверка соответствия параметров допускаемым диапазонам",
                            "sublist": null
                        },
                        {
                            "text": "защита от несанкционированного доступа",
                            "sublist": null
                        },
                        {
                            "text": "подключение теплосчетчиков в сеть",
                            "sublist": null
                        }
                    ]
                },
                "table": null
            },
            {
                "isPreview": false,
                "header": "Состав теплосчетчика ИРВИКОН ТС-200",
                "text": null,
                "list": {
                    "type": "dots",
                    "items": [
                        {
                            "text": "тепловычислитель ИРВИКОН ВТ-200",
                            "sublist": null
                        },
                        {
                            "text": "преобразователи расхода (объема) теплоносителя",
                            "sublist": null
                        },
                        {
                            "text": "преобразователи температуры",
                            "sublist": null
                        },
                        {
                            "text": " преобразователи давления",
                            "sublist": null
                        }
                    ]
                },
                "table": null
            },
            {
                "isPreview": false,
                "header": "",
                "text": "ИРВИКОН ТС-200 производится в 4-х исполнениях в зависимости от количества каналов измерения. Возможность многоканального использования счетчика обеспечивается за счет использования блока приема и передачи цифровых данных.",
                "list": null,
                "table": null
            },
            {
                "isPreview": false,
                "header": "Технические параметры эксплуатации теплосчетчика ИРВИКОН ТС-200",
                "text": null,
                "list": null,
                "table": {
                    "columns": [
                        "Наименование параметра",
                        "Значение\u00A0"
                    ],
                    "rows": [
                        {
                            "items": [
                                "Диапазон измерения температур теплоносителя",
                                "0\u2026\u002B160\u00B0С"
                            ],
                            "isGroup": false,
                            "isGroupItem": false
                        },
                        {
                            "items": [
                                "Диапазон измерения температур газообразных сред",
                                "-60\u2026\u002B100\u00B0С"
                            ],
                            "isGroup": false,
                            "isGroupItem": false
                        },
                        {
                            "items": [
                                "Диапазон измерения разности температур теплоносителя",
                                "\u002B1\u2026\u002B155\u00B0С"
                            ],
                            "isGroup": false,
                            "isGroupItem": false
                        },
                        {
                            "items": [
                                "Межповерочный интервал",
                                "4 года"
                            ],
                            "isGroup": false,
                            "isGroupItem": false
                        },
                        {
                            "items": [
                                "Средний срок службы прибора",
                                "не менее 12 лет"
                            ],
                            "isGroup": false,
                            "isGroupItem": false
                        },
                        {
                            "items": [
                                "Габаритные размеры тепловычислителя",
                                "130х160х65 мм или 180х180х65 мм"
                            ],
                            "isGroup": false,
                            "isGroupItem": false
                        },
                        {
                            "items": [
                                "Масса тепловычислителя",
                                "не более 1,5 кг"
                            ],
                            "isGroup": false,
                            "isGroupItem": false
                        }
                    ]
                }
            }
        ]
};
//**************************************************************************************IRVIKON_VT200
//**************************************************************************************KM5 
const KM5 = {
    id: "GVC2010",
    name: "<b>КМ-5</b>",
    img: "/heatmeters/КМ-5.png",
    imgAlt: "КМ-5",
    description:
        [
            {
                "isPreview": true,
                "header": "",
                "text": "Теплосчётчики КМ-5 предназначены для измерений и учёта тепловой энергии, объёмного и массового расхода, объёма, массы и параметров теплоносителя в открытых, закрытых и тупиковых водяных системах теплоснабжения (далее соответственно ОВСТ, ЗВСТ и ТВСТ), а также в системах циркуляционного и тупикового горячего и холодного водоснабжения (далее ГВС и ХВС соответственно). ",
                "list": null,
                "table": null
            },
            {
                "isPreview": false,
                "header": "",
                "text": "Область применения счетчика КМ 5: коммерческий и технологический учёт, диспетчерский, технологический и технический контроль на источниках тепловой энергии и у потребителей для трубопроводов, внутренний диаметр которых не более 300 мм. ",
                "list": null,
                "table": null
            },
            {
                "isPreview": false,
                "header": "Теплосчетчик КМ 5 ",
                "text": "Электромагнитные теплосчетчики КМ 5 производят вычисление тепловой мощности и тепловой энергии на основе данных об объемном расходе и объеме теплоносителя, температур на прямом и обратном трубопроводе с учетом изменения теплоемкости теплоносителя при изменении разности температур на входе и выходе. ",
                "list": null,
                "table": null
            },
            {
                "isPreview": false,
                "header": "Принцип действия: электромагнитный.",
                "text": " Типоразмеры преобразователей расхода: от DN=15 мм до DN=300 мм. Область применения: для измерения, учета и регистрации количества теплоты, а также объема, массы, объемного и массового расхода и других параметров теплоносителя в одной или нескольких контролируемых системах одновременно. ",
                "list": null,
                "table": null
            },
            {
                "isPreview": false,
                "header": "Особенности приборов:",
                "text": null,
                "list": {
                    "type": "dots",
                    "items": [
                        {
                            "text": "Широкий динамический диапазон измерения расходов: Gmax/Gmin=1000.",
                            "sublist": null
                        },
                        {
                            "text": "Малая длина прямых участков трубопроводов (3DN-1DN).",
                            "sublist": null
                        },
                        {
                            "text": "Типоразмеры первичных преобразователей расхода от DN=15 мм до DN=300 мм.",
                            "sublist": null
                        },
                        {
                            "text": "В теплосчетчике КМ-5 имеется датчик пустой трубы, благодаря которому при отсутствии теплоносителя в трубопроводе обнуляется текущий результат измерения расхода.",
                            "sublist": null
                        },
                        {
                            "text": "Измерение реверсивных потоков в автоматическом режиме.",
                            "sublist": null
                        },
                        {
                            "text": "Контроль температуры наружного воздуха.",
                            "sublist": null
                        },
                        {
                            "text": "В программном обеспечении теплосчетчиков и счетчиков-расходомеров установлена процедура автокалибровки, которая позволяет поддерживать метрологические характеристики на протяжении межповерочного интервала, равного 4-м годам.",
                            "sublist": null
                        },
                        {
                            "text": "Приборы независимо от класса точности удовлетворяют требованиям лучших классов: 1-го по рекомендации международной Организации Законодательной Метрологии (МР75) и класса С по ГОСТ 51649-2000. Теплосчетчики КМ-5 по нормам погрешности измерения расхода соответствуют требованиям российских и международных стандартов.",
                            "sublist": null
                        },
                        {
                            "text": "Теплосчетчики КМ 5 и счетчики-расходомеры снабжены интерфейсами RS-232, RS-485 для вывода информации на принтер, модем, персональный компьютер или другие устройства.",
                            "sublist": null
                        },
                        {
                            "text": "Глубина архивации среднечасовых параметров \u2014 42 дня, а среднесуточных \u2014 12 месяцев, что позволяет в случае возникновения спорных ситуаций между поставщиком и потребителем энергоресурсов иметь объективную информацию о характеристиках системы тепловодоснабжения.",
                            "sublist": null
                        }
                    ]
                },
                "table": null
            },
            {
                "isPreview": false,
                "header": null,
                "text": "В состав счетчика КМ-5 входят штатные преобразователи расхода и (или) объёма, термометры (датчики температуры) и (или) их комплекты утверждённых типов (таблица 7) и вычислительные устройства. В составе КМ-5 могут применяться также датчики давления и преобразователи объёма с импульсным выходным сигналом",
                "list": null,
                "table": null
            },
            {
                "isPreview": false,
                "header": "Технические характеристики",
                "text": null,
                "list": null,
                "table": {
                    "columns": [
                        "",
                        ""
                    ],
                    "rows": [
                        {
                            "items": [
                                "Завод изготовитель:",
                                "\u00ABТБН Энергосервис\u00BB"
                            ],
                            "isGroup": false,
                            "isGroupItem": false
                        },
                        {
                            "items": [
                                "Вес (кг):",
                                "1"
                            ],
                            "isGroup": false,
                            "isGroupItem": false
                        },
                        {
                            "items": [
                                "Габариты",
                                "100x100x80"
                            ],
                            "isGroup": false,
                            "isGroupItem": false
                        },
                        {
                            "items": [
                                "Уровень пылевлагозашиты:",
                                "IP65"
                            ],
                            "isGroup": false,
                            "isGroupItem": false
                        },
                        {
                            "items": [
                                "Средний срок службы (лет)",
                                "12"
                            ],
                            "isGroup": false,
                            "isGroupItem": false
                        },
                        {
                            "items": [
                                "Средняя наработка на отказ (часов)",
                                "75000"
                            ],
                            "isGroup": false,
                            "isGroupItem": false
                        },
                        {
                            "items": [
                                "Межповерочный интервал (мес.): ",
                                "48"
                            ],
                            "isGroup": false,
                            "isGroupItem": false
                        },
                        {
                            "items": [
                                "Гарантийный срок (мес.): ",
                                "18"
                            ],
                            "isGroup": false,
                            "isGroupItem": false
                        }
                    ]
                }
            }
        ]
};
//**************************************************************************************KM5
//**************************************************************************************LOGGER_PROMODEM
const LOGGER_PROMODEM = {
    id: "LOGGER_PROMODEM",
    name: "<b>Логер Промодем</b>",
    img: "/heatmeters/Логер Промодем.png",
    imgAlt: "Логер Промодем",
    description:
        [
            {
                "isPreview": true,
                "header": "",
                "text": "Логгеры PROMODEM (далее - логгер) предназначены для измерений и преобразований аналоговых электрических сигналов (сопротивление, сила и напряжение постоянного тока, количество импульсов) поступающих от первичных измерительных преобразователей (далее -ПИП), в значения физических величин с последующей обработкой, представлением, регистрацией, хранением и передачей измерительной информации.",
                "list": null,
                "table": null
            },
            {
                "isPreview": false,
                "header": "Описание",
                "text": "Принцип действия логгеров основан на измерении и аналого-цифровом преобразовании электрических выходных сигналов от ПИП и их последующей обработке.",
                "list": null,
                "table": null
            },
            {
                "isPreview": false,
                "header": "Конструктивно логгеры представляют собой микропроцессорное устройство, состоящее",
                "text": "из:",
                "list": null,
                "table": null
            },
            {
                "isPreview": false,
                "header": "- \u00A0\u00A0\u00A0микроконтроллера;",
                "text": "- \u00A0\u00A0\u00A0АЦП;",
                "list": null,
                "table": null
            },
            {
                "isPreview": false,
                "header": "- \u00A0\u00A0\u00A0часов;",
                "text": "- \u00A0\u00A0\u00A0запоминающего устройства;",
                "list": null,
                "table": null
            },
            {
                "isPreview": false,
                "header": "- \u00A0\u00A0\u00A0последовательного асинхронного интерфейса RS-485 или RS-232;",
                "text": "- \u00A0\u00A0\u00A0абонентской радиостанции, поддерживающей стандарты:",
                "list": null,
                "table": null
            },
            {
                "isPreview": false,
                "header": "- \u00A0\u00A0\u00A0GSM и Bluetooth;",
                "text": "- \u00A0\u00A0\u00A03G (UMTC);",
                "list": null,
                "table": null
            },
            {
                "isPreview": false,
                "header": "- \u00A0\u00A0\u00A0LTE (NB-Iot);",
                "text": "- \u00A0\u00A0\u00A0Wi-Fi.",
                "list": null,
                "table": null
            },
            {
                "isPreview": false,
                "header": "",
                "text": "Передача информации во внешние цепи осуществляется по стандартным интерфейсам типа RS-232, RS-485, а также по беспроводным каналам связи, таким как GSM и Bluetooth, 3G (UMTC), LTE (NB-Iot), Wi-Fi.",
                "list": null,
                "table": null
            },
            {
                "isPreview": false,
                "header": null,
                "text": "Логгеры обеспечивают измерение, преобразование и представление в виде значений измеряемой физической величины, аналоговые сигналы от ПИП следующих видов:",
                "list": null,
                "table": null
            },
            {
                "isPreview": false,
                "header": "- \u00A0\u00A0\u00A0ПИП с выходными аналоговыми сигналами силы и напряжения постоянного тока по ГОСТ 26.011-80;",
                "text": "- \u00A0\u00A0\u00A0термопреобразователи сопротивления (ТС) с номинальной статической характеристикой преобразования (НСХ) по ГОСТ 6651-2009;",
                "list": null,
                "table": null
            },
            {
                "isPreview": false,
                "header": "- \u00A0\u00A0\u00A0термоэлектрические преобразователи (ТП) с НСХ по ГОСТ Р 8.585-2001;",
                "text": "- \u00A0\u00A0\u00A0ПИП с импульсными выходами.",
                "list": null,
                "table": null
            }
        ]
};
//**************************************************************************************LOGGER_PROMODEM
//**************************************************************************************MAGICA
const MAGICA = {
    id: "MAGICA",
    name: "<b>Магика</b>",
    img: "/heatmeters/Магика1.png",
    imgAlt: "Магика",
    description:
        [
            {
                "isPreview": true,
                "header": "Назначение",
                "text": "Теплосчетчики - регистраторы \u0022МАГИКА\u0022 (далее - теплосчетчики) предназначены для измерений и регистрации количества теплоты, объемного и массового расхода воды, объема, массы, температуры, давления воды на узлах учета в системах водяного теплоснабжения на источнике и у потребителя теплоты, а также горячего и холодного водоснабжения.",
                "list": null,
                "table": null
            },
            {
                "isPreview": false,
                "header": "Описание",
                "text": "Теплосчётчики являются составными изделиями и состоят из следующих блоков: электронного блока с электромагнитными преобразователями расхода (ЭПР), регистраторов расхода, расходомеров и/или тахометрических водосчетчиков, термопреобразователей сопротивления с НСХ 100П или Pt100, датчиков давления с унифицированным аналоговым выходным сигналом 4-20 мА. Типы применяемых в составе теплосчётчиков расходомеров, водосчётчиков, термопреобразователей сопротивления, датчиков давления приведены в табл.1, 2, 3. ЭПР являются составной частью электромагнитного расходомерного канала (ЭРК) электронных блоков теплосчетчика, отдельно не поверяются, не имеют собственного паспорта и калибруются и поверяются только совместно с электронным блоком теплосчетчика или регистратора.",
                "list": null,
                "table": null
            },
            {
                "isPreview": false,
                "header": "",
                "text": "Принцип работы теплосчетчика состоит в измерении объемного и массового расхода, объема, массы, температуры и давления воды в трубопроводной системе (ТС) с последующим расчетом количества теплоты и других параметров. В зависимости от исполнения теплосчетчик может обслуживать от 1-го до 3-х трубопроводных систем. В состав каждой ТС может входить от 1-го до 3-х трубопроводов. Для каждой ТС архивируются нарастающим итогом нормированные по погрешности измерения значения количества теплоты, объемов, масс, давлений, средних или средневзвешенных температур, а так же значения времени нормальной работы и времени различных неисправностей, выявленных средствами диагностики работы теплоосчетчика. В составе ЭРК имеются технические и программные средства для автоматического определения направления движения потока воды и ситуации \u0022сухая труба\u0022, когда уровень воды находится ниже уровня электродов. Для каждой ТС регистрируются ситуации, когда значения объемного расхода в любом трубопроводе, измеренные ЭРК, будут больше максимального или меньше минимального допустимых значений. Для каждой пары подающий и обратный трубопровод диагностируются в ситуации, когда разность температур будет меньше минимально допустимого значения.",
                "list": null,
                "table": null
            },
            {
                "isPreview": false,
                "header": null,
                "text": "Информация из архива может быть просмотрена на индикаторе теплосчетчика за любой день и час или считана через цифровые интерфейсы теплосчетчика. Суточная информация хранится в архиве от 6 месяцев до 12 месяцев, а часовая информация - от 45 суток до 90 суток в зависимости от модификации прибора и количества трубопроводов, параметры которых контролируются теплосчетчиком. Срок хранения архивной информации при выключенном питании до 8 лет.",
                "list": null,
                "table": null
            },
            {
                "isPreview": false,
                "header": null,
                "text": "В зависимости от комплектности поставки и версии встроенного программного обеспечения, теплосчетчики выпускаются в следующих исполнениях:",
                "list": null,
                "table": null
            },
            {
                "isPreview": false,
                "header": null,
                "text": null,
                "list": {
                    "type": "dots",
                    "items": [
                        {
                            "text": "К - для измерения параметров теплоносителя и количества теплоты в одной системе теплоснабжения или водоснабжения, содержащей не более двух трубопроводов, например, для квартир и небольших домов;",
                            "sublist": null
                        },
                        {
                            "text": "А и Д - для измерения параметров теплоносителя и количества теплоты в одной системе теплоснабжения или водоснабжения, содержащей до трех трубопроводов;",
                            "sublist": null
                        },
                        {
                            "text": "Е - для одновременного измерения тепловой энергии в двух закрытых и/или открытых системах теплоснабжения, содержащих до 3-х трубопроводов в каждой системе;",
                            "sublist": null
                        },
                        {
                            "text": "Р и Т - составные теплосчетчики для одновременного измерения тепловой энергии в двух или трех закрытых и/или открытых системах теплоснабжения, содержащих до 3-х трубопроводов в каждой системе.",
                            "sublist": null
                        }
                    ]
                },
                "table": null
            },
            {
                "isPreview": false,
                "header": null,
                "text": "Регистраторы расхода исп. РИ и имеют импульсные выходы с передачей весовых импульсов, пропорциональных объемному расходу и последовательный интерфейс для передачи цифровых значений объемного расхода. Регистраторы расхода исп. РС имеют последовательный интерфейс для передачи цифровых значений объемного расхода, а также измерительные каналы для подключения термометров сопротивления и датчиков давления.",
                "list": null,
                "table": null
            },
            {
                "isPreview": false,
                "header": null,
                "text": "Вывод измеренной и накопленной информации из теплосчетчиков осуществляется по стандартным интерфейсам RS-232 или RS-485. Через внешний модем теплосчетчика обеспечивается передача текущей и архивной информации в переносной архиватор, компьютер, модемы сотовых телефонных каналов связи или Интернет.",
                "list": null,
                "table": null
            },
            {
                "isPreview": false,
                "header": null,
                "text": null,
                "list": null,
                "table": {
                    "columns": [
                        "Наименование характеристики",
                        "Значение параметра"
                    ],
                    "rows": [
                        {
                            "items": [
                                "Степень защиты от воды и пыли ЭПР по ГОСТ 14254-96, не ниже",
                                "IP64"
                            ],
                            "isGroup": false,
                            "isGroupItem": false
                        },
                        {
                            "items": [
                                "Степень защиты от воды и пыли электронных блоков по ГОСТ 14254-96, не ниже",
                                "IP40"
                            ],
                            "isGroup": false,
                            "isGroupItem": false
                        },
                        {
                            "items": [
                                "Масса электронного блока, кг",
                                "4"
                            ],
                            "isGroup": false,
                            "isGroupItem": false
                        },
                        {
                            "items": [
                                "Средняя наработка ЭБ на отказ, часов, не менее",
                                "80000"
                            ],
                            "isGroup": false,
                            "isGroupItem": false
                        },
                        {
                            "items": [
                                "Средний срок службы, лет, не менее",
                                "12"
                            ],
                            "isGroup": false,
                            "isGroupItem": false
                        }
                    ]
                }
            }
        ]
};
//**************************************************************************************MAGICA
//**************************************************************************************MERCURY203
const MERCURY203 = {
    id: "MERCURY203",
    name: "<b>Меркурий 203</b>",
    img: "/heatmeters/Меркурий 203.png",
    imgAlt: "Меркурий 203",
    description:
        [
            {
                "isPreview": true,
                "header": "Меркурий 203.2Т",
                "text": "Счетчики предназначены для однонаправленного многотарифного учета активной и реактивной электрической энергии и мощности, а также измерения параметров электрической сети в двухпроводных сетях переменного тока с последующим хранением накопленной информации, формированием событий и передачей информации в центры сбора данных систем АСКУЭ.",
                "list": null,
                "table": null
            },
            {
                "isPreview": false,
                "header": null,
                "text": "Счетчики предназначены для эксплуатации внутри закрытых помещений и в местах, имеющих защиту от влияния окружающей среды (в шкафах, в щитках).",
                "list": null,
                "table": null
            },
            {
                "isPreview": false,
                "header": "Особенности:",
                "text": null,
                "list": {
                    "type": "dots",
                    "items": [
                        {
                            "text": "Измерение, учёт, хранение, вывод на ЖКИ и передача по интерфейсам активной и реактивной электроэнергии раздельно по каждому тарифу и сумму по всем тарифам за следующие периоды времени: ",
                            "sublist": {
                                "type": "dots",
                                "items": [
                                    {
                                        "text": "энергия всего от сброса показаний;",
                                        "sublist": null
                                    },
                                    {
                                        "text": "энергия на начало текущих суток и на начало суток шести предыдущих месяцев;",
                                        "sublist": null
                                    },
                                    {
                                        "text": "энергия на начало текущего месяца на начало месяца четырех предыдущих лет",
                                        "sublist": null
                                    }
                                ]
                            }
                        },
                        {
                            "text": "Тарификатор с возможностью задания отдельного расписания для каждого дня недели по 4 тарифам в 16 временных зонах суток.Каждый месяц года программируется на индивидуальное тарифное расписание. Минимальный интервал действия тарифа в пределах суток 1 минута",
                            "sublist": null
                        },
                        {
                            "text": "Учёт технических потерь в линиях электропередач и силовых трансформаторах",
                            "sublist": null
                        },
                        {
                            "text": "Измерение параметров электрической сети: ",
                            "sublist": {
                                "type": "dots",
                                "items": [
                                    {
                                        "text": "мгновенные значения активной, реактивной и полной мощности с указанием направления вектора полной мощности;",
                                        "sublist": null
                                    },
                                    {
                                        "text": "действующие значения тока и напряжения,",
                                        "sublist": null
                                    },
                                    {
                                        "text": "частота сети;",
                                        "sublist": null
                                    },
                                    {
                                        "text": "коэффициент мощности;",
                                        "sublist": null
                                    }
                                ]
                            }
                        },
                        {
                            "text": "Профиль мощности с периодом интегрирования 30 минут и глубиной хранения 6 месяцев",
                            "sublist": null
                        },
                        {
                            "text": "Фиксация утренних и вечерних максимумов активной и реактивной мощности на заданном интервале от 1 до 3600 секунд с ежемесячным расписанием",
                            "sublist": null
                        },
                        {
                            "text": "Ведение журналов событий, включая события показателей качества электроэнергии",
                            "sublist": null
                        },
                        {
                            "text": "Сменные модули интерфейсов: GSM, NBIoT, PLC, RF, Wi-Fi, LoRa",
                            "sublist": null
                        },
                        {
                            "text": "Наличие многофункционального гальванически развязанного импульсного выхода, в том числе с функцией управления нагрузкой",
                            "sublist": null
                        },
                        {
                            "text": "Автоматическая самодиагностика с индикацией ошибок",
                            "sublist": null
                        },
                        {
                            "text": "Наличие встроенного реле",
                            "sublist": null
                        },
                        {
                            "text": "Две энергонезависимые электронные пломбы",
                            "sublist": null
                        },
                        {
                            "text": "Запись несанкционированных воздействий в нестираемые журналы событий",
                            "sublist": null
                        }
                    ]
                },
                "table": null
            },
            {
                "isPreview": false,
                "header": "Технические характеристики",
                "text": null,
                "list": null,
                "table": {
                    "columns": [
                        "",
                        ""
                    ],
                    "rows": [
                        {
                            "items": [
                                "Активная / полная потребляемая мощность цепью напряжения счетчика при номинальном напряжении, Вт/В*А",
                                "2 / 10"
                            ],
                            "isGroup": false,
                            "isGroupItem": false
                        },
                        {
                            "items": [
                                "Полная мощность, потребляемая каждой цепью тока, не более, В*А",
                                "0,1"
                            ],
                            "isGroup": false,
                            "isGroupItem": false
                        },
                        {
                            "items": [
                                "Дополнительная активная / полная потребляемая мощность цепью напряжения счетчика при номинальном напряжении, при наличии интерфейса PLC, Вт/В*А",
                                "2 / 6"
                            ],
                            "isGroup": false,
                            "isGroupItem": false
                        },
                        {
                            "items": [
                                "Дополнительная активная / полная потребляемая мощность цепью напряжения счетчика при номинальном напряжении, при наличии интерфейса GSM, Вт/В*А",
                                "4 / 5"
                            ],
                            "isGroup": false,
                            "isGroupItem": false
                        },
                        {
                            "items": [
                                "Количество тарифов",
                                "4"
                            ],
                            "isGroup": false,
                            "isGroupItem": false
                        },
                        {
                            "items": [
                                "Сохранность данных при перерывах питания, не менее, лет",
                                "10"
                            ],
                            "isGroup": false,
                            "isGroupItem": false
                        },
                        {
                            "items": [
                                "Межповерочный интервал, лет",
                                "16"
                            ],
                            "isGroup": false,
                            "isGroupItem": false
                        },
                        {
                            "items": [
                                "Гарантийный срок эксплуатации, лет",
                                "3"
                            ],
                            "isGroup": false,
                            "isGroupItem": false
                        },
                        {
                            "items": [
                                "Наработка на отказ, не менее, ч",
                                "220 000"
                            ],
                            "isGroup": false,
                            "isGroupItem": false
                        },
                        {
                            "items": [
                                "Диапазон рабочих температур, \u00B0С",
                                "от -45 до \u002B70"
                            ],
                            "isGroup": false,
                            "isGroupItem": false
                        },
                        {
                            "items": [
                                "Масса, не более, кг",
                                "0,95"
                            ],
                            "isGroup": false,
                            "isGroupItem": false
                        },
                        {
                            "items": [
                                "Габариты (ДхШхВ), мм",
                                "150x73x210"
                            ],
                            "isGroup": false,
                            "isGroupItem": false
                        }
                    ]
                }
            },
            {
                "isPreview": false,
                "header": "Метрологические характеристики",
                "text": null,
                "list": null,
                "table": {
                    "columns": [
                        "",
                        ""
                    ],
                    "rows": [
                        {
                            "items": [
                                "Класс точности счетчиков (актив. / реактив.):\u00A0",
                                "1/2"
                            ],
                            "isGroup": false,
                            "isGroupItem": false
                        },
                        {
                            "items": [
                                "Номинальное напряжение, В:\u00A0",
                                "230"
                            ],
                            "isGroup": false,
                            "isGroupItem": false
                        },
                        {
                            "items": [
                                "Базовый / максимальный ток, А:\u00A0",
                                "5/60; 10/100"
                            ],
                            "isGroup": false,
                            "isGroupItem": false
                        },
                        {
                            "items": [
                                "Максимальный ток в течение 10 мс:\u00A0",
                                "30*I макс"
                            ],
                            "isGroup": false,
                            "isGroupItem": false
                        },
                        {
                            "items": [
                                "Чувствительность при измерении активной энергии, А:\u00A0",
                                ""
                            ],
                            "isGroup": false,
                            "isGroupItem": false
                        },
                        {
                            "items": [
                                "для счетчиков с базовым током 5 А:\u00A0",
                                "0,02"
                            ],
                            "isGroup": false,
                            "isGroupItem": false
                        },
                        {
                            "items": [
                                "для счетчиков с базовым током 10 А:\u00A0",
                                "0,04"
                            ],
                            "isGroup": false,
                            "isGroupItem": false
                        }
                    ]
                }
            }
        ]
};
//**************************************************************************************MERCURY203
//**************************************************************************************MERCURY230_ART
const MERCURY230_ART = {
    id: "MERCURY230_ART",
    name: "<b>Меркурий 230 АРТ</b>",
    img: "/heatmeters/Меркурий 230_art.png",
    imgAlt: "Меркурий 230 АРТ",
    description:
        [
            {
                "isPreview": true,
                "header": "Меркурий 230 ART",
                "text": "Счетчики предназначены для однонаправленного многотарифного учета активной и реактивной электрической энергии и мощности, а также измерения параметров электрической сети в трехфазных трех- или четырехпроводных сетях переменного тока с последующим хранением накопленной информации, формированием событий и передачей информации в центры сбора данных систем АСКуЭ.",
                "list": null,
                "table": null
            },
            {
                "isPreview": false,
                "header": null,
                "text": "Счетчики предназначены для эксплуатации внутри закрытых помещений и могут быть использованы в местах, имеющих дополнительную защиту от влияния окружающей среды (установлены в помещении, в шкафу, в щитке).",
                "list": null,
                "table": null
            },
            {
                "isPreview": false,
                "header": "Особенности:",
                "text": null,
                "list": {
                    "type": "dots",
                    "items": [
                        {
                            "text": "Измерение, учёт, хранение, вывод на ЖКИ и передача по интерфейсам активной и реактивной электроэнергии раздельно по каждому тарифу и сумму по всем тарифам за следующие периоды времени: ",
                            "sublist": {
                                "type": "dots",
                                "items": [
                                    {
                                        "text": "энергия всего от сброса показаний;",
                                        "sublist": null
                                    },
                                    {
                                        "text": "энергия на начало текущих и предыдущих суток;",
                                        "sublist": null
                                    },
                                    {
                                        "text": "энергия на начало текущего и 11 предыдущих месяцев;",
                                        "sublist": null
                                    },
                                    {
                                        "text": "энергия на начало текущего и предыдущего года;",
                                        "sublist": null
                                    },
                                    {
                                        "text": "расход за текущие и предыдущие сутки;",
                                        "sublist": null
                                    },
                                    {
                                        "text": "расход за текущий и 11 предыдущих месяцев.",
                                        "sublist": null
                                    }
                                ]
                            }
                        },
                        {
                            "text": "Тарификатор с возможностью задания отдельного расписания для каждого дня недели по 4 тарифам в 16 временных зонах суток.Каждый месяц года программируется на индивидуальное тарифное расписание. Минимальный интервал действия тарифа в пределах суток 1 минута",
                            "sublist": null
                        },
                        {
                            "text": "Функция пофазного многотарифного учета",
                            "sublist": null
                        },
                        {
                            "text": "Учёт технических потерь в линиях электропередач и силовых трансформаторах",
                            "sublist": null
                        },
                        {
                            "text": "Измерение параметров электрической сети: ",
                            "sublist": {
                                "type": "dots",
                                "items": [
                                    {
                                        "text": "мгновенные значения активной, реактивной и полной мощности по каждой фазе и по сумме фаз с указанием направления вектора полной мощности;",
                                        "sublist": null
                                    },
                                    {
                                        "text": "действующие значения фазных токов и напряжений;",
                                        "sublist": null
                                    },
                                    {
                                        "text": "значения углов между фазными напряжениями;",
                                        "sublist": null
                                    },
                                    {
                                        "text": "частота сети;",
                                        "sublist": null
                                    },
                                    {
                                        "text": "коэффициенты мощности по каждой фазе и по сумме фаз.",
                                        "sublist": null
                                    }
                                ]
                            }
                        },
                        {
                            "text": "Профиль мощности и профиль мощности технических потерь с произвольным временем усреднения от 1 до 45 минут. Глубина хранения 85 суток для времени усреднения 30 минут",
                            "sublist": null
                        },
                        {
                            "text": "Фиксация утренних и вечерних максимумов активной и реактивной мощности на заданном интервале с ежемесячным расписанием",
                            "sublist": null
                        },
                        {
                            "text": "Ведение журналов событий, включая события показателей качества электроэнергии",
                            "sublist": null
                        },
                        {
                            "text": "Возможность подключения резервного питания",
                            "sublist": null
                        },
                        {
                            "text": "Наличие многофункциональных импульсных выходов, в том числе с функцией управления нагрузкой",
                            "sublist": null
                        },
                        {
                            "text": "Автоматическая самодиагностика с индикацией ошибок",
                            "sublist": null
                        },
                        {
                            "text": "Энергонезависимая электронная пломба",
                            "sublist": null
                        },
                        {
                            "text": "Запись несанкционированных воздействий в нестираемые журналы событий",
                            "sublist": null
                        }
                    ]
                },
                "table": null
            },
            {
                "isPreview": false,
                "header": "Технические характеристики",
                "text": null,
                "list": null,
                "table": {
                    "columns": [
                        "",
                        ""
                    ],
                    "rows": [
                        {
                            "items": [
                                "Активная / полная потребляемая мощность в каждой цепи напряжения счетчика при номинальном напряжении, Вт/В*А",
                                "2/10"
                            ],
                            "isGroup": false,
                            "isGroupItem": false
                        },
                        {
                            "items": [
                                "Полная мощность, потребляемая каждой цепью тока, не более, В*А",
                                "0,1"
                            ],
                            "isGroup": false,
                            "isGroupItem": false
                        },
                        {
                            "items": [
                                "Диапазон питающих напряжений входа резервного питания и питания интерфейсов RS-485, CAN, В",
                                "5,5 - 12"
                            ],
                            "isGroup": false,
                            "isGroupItem": false
                        },
                        {
                            "items": [
                                "Средний ток потребления от источника внешнего питания интерфейсов RS-485, CAN, мА",
                                "30"
                            ],
                            "isGroup": false,
                            "isGroupItem": false
                        },
                        {
                            "items": [
                                "Средний ток потребления от источника резервного питания, мА",
                                "150"
                            ],
                            "isGroup": false,
                            "isGroupItem": false
                        },
                        {
                            "items": [
                                "Количество тарифов",
                                "4"
                            ],
                            "isGroup": false,
                            "isGroupItem": false
                        },
                        {
                            "items": [
                                "Сохранность данных при перерывах питания, не менее, лет",
                                "10"
                            ],
                            "isGroup": false,
                            "isGroupItem": false
                        },
                        {
                            "items": [
                                "Межповерочный интервал, лет",
                                "10"
                            ],
                            "isGroup": false,
                            "isGroupItem": false
                        },
                        {
                            "items": [
                                "Гарантийный срок эксплуатации, лет",
                                "3"
                            ],
                            "isGroup": false,
                            "isGroupItem": false
                        },
                        {
                            "items": [
                                "Наработка на отказ, не менее, ч",
                                "150 000"
                            ],
                            "isGroup": false,
                            "isGroupItem": false
                        },
                        {
                            "items": [
                                "Диапазон рабочих температур, \u00B0С",
                                "от -40 до \u002B55"
                            ],
                            "isGroup": false,
                            "isGroupItem": false
                        },
                        {
                            "items": [
                                "Масса, не более, кг",
                                "1,5"
                            ],
                            "isGroup": false,
                            "isGroupItem": false
                        },
                        {
                            "items": [
                                "Габариты (ДхШхВ), мм",
                                "170x74x258"
                            ],
                            "isGroup": false,
                            "isGroupItem": false
                        }
                    ]
                }
            },
            {
                "isPreview": false,
                "header": "Метрологические характеристики",
                "text": null,
                "list": null,
                "table": {
                    "columns": [
                        "",
                        ""
                    ],
                    "rows": [
                        {
                            "items": [
                                "Класс точности счетчиков (актив. / реактив.):\u00A0",
                                ""
                            ],
                            "isGroup": false,
                            "isGroupItem": false
                        },
                        {
                            "items": [
                                "\u2022 трансформаторного включения:\u00A0",
                                "0,5S / 1"
                            ],
                            "isGroup": false,
                            "isGroupItem": false
                        },
                        {
                            "items": [
                                "\u2022 прямого включения:\u00A0",
                                "1/2"
                            ],
                            "isGroup": false,
                            "isGroupItem": false
                        },
                        {
                            "items": [
                                "Номинальное напряжение, В:\u00A0",
                                ""
                            ],
                            "isGroup": false,
                            "isGroupItem": false
                        },
                        {
                            "items": [
                                "\u2022 трансформаторного включения:\u00A0",
                                "3*57,7/100"
                            ],
                            "isGroup": false,
                            "isGroupItem": false
                        },
                        {
                            "items": [
                                "\u2022 прямого включения:\u00A0",
                                "3*230/400"
                            ],
                            "isGroup": false,
                            "isGroupItem": false
                        },
                        {
                            "items": [
                                "Базовый / максимальный ток, А:\u00A0",
                                ""
                            ],
                            "isGroup": false,
                            "isGroupItem": false
                        },
                        {
                            "items": [
                                "\u2022 трансформаторного включения:\u00A0",
                                "5/7,5"
                            ],
                            "isGroup": false,
                            "isGroupItem": false
                        },
                        {
                            "items": [
                                "\u2022 прямого включения:\u00A0",
                                "5/60; 10/100"
                            ],
                            "isGroup": false,
                            "isGroupItem": false
                        },
                        {
                            "items": [
                                "Макс. ток для счетчиков прямого включения в течение 10 мс:\u00A0",
                                "30*I макс"
                            ],
                            "isGroup": false,
                            "isGroupItem": false
                        },
                        {
                            "items": [
                                "Максимальный ток для счетчиков трансформаторного включения в течение 0,5 с:\u00A0",
                                "20*I макс"
                            ],
                            "isGroup": false,
                            "isGroupItem": false
                        },
                        {
                            "items": [
                                "Чувствительность при измерении активной энергии, А:\u00A0",
                                ""
                            ],
                            "isGroup": false,
                            "isGroupItem": false
                        },
                        {
                            "items": [
                                "\u2022 трансформаторного включения:\u00A0",
                                "0,005"
                            ],
                            "isGroup": false,
                            "isGroupItem": false
                        },
                        {
                            "items": [
                                "\u2022 прямого включения:\u00A0",
                                "0,02; 0,04"
                            ],
                            "isGroup": false,
                            "isGroupItem": false
                        }
                    ]
                }
            }
        ]
};
//**************************************************************************************MERCURY230_ART
//**************************************************************************************MERCURY234
const MERCURY234 = {
    id: "MERCURY234",
    name: "<b>Меркурий 234</b>",
    img: "/heatmeters/Меркурий 234.png",
    imgAlt: "Меркурий 234",
    description:
        [
            {
                "isPreview": true,
                "header": "",
                "text": "Счетчики предназначены для одно- или двунаправленного многотарифного учета активной и реактивной электрической энергии и мощности, а также измерения параметров электрической сети в трехфазных трех- или четырехпроводных сетях переменного тока с последующим хранением накопленной информации, формированием событий и передачей информации в центры сбора данных АИИС КУЭ. Обмен данными по интерфейсам связи выполняется по протоколу СПОДЭС (IEC62056 DLMS/COSEM) или протоколу \u00ABМеркурий\u00BB. Счетчики совместимы с ПО \u00ABТеплоинформ\u00BB",
                "list": null,
                "table": null
            },
            {
                "isPreview": false,
                "header": null,
                "text": "Счетчики предназначены для эксплуатации внутри закрытых помещений и в местах, имеющих защиту от влияния окружающей среды (в шкафах, в щитках).",
                "list": null,
                "table": null
            },
            {
                "isPreview": false,
                "header": "Технические характеристики",
                "text": null,
                "list": null,
                "table": {
                    "columns": [
                        "",
                        ""
                    ],
                    "rows": [
                        {
                            "items": [
                                "Активная / полная потребляемая мощность в каждой цепи напряжения счетчика при номинальном напряжении, Вт/В*А",
                                "1,5 / 9"
                            ],
                            "isGroup": false,
                            "isGroupItem": false
                        },
                        {
                            "items": [
                                "Полная мощность, потребляемая каждой цепью тока, не более, В*А",
                                "0,1"
                            ],
                            "isGroup": false,
                            "isGroupItem": false
                        },
                        {
                            "items": [
                                "Дополнительная потребляемая активная / полная мощность для счетчиков со встроенным модемом, Вт/В*А",
                                "6 / 30"
                            ],
                            "isGroup": false,
                            "isGroupItem": false
                        },
                        {
                            "items": [
                                "Количество тарифов",
                                "4"
                            ],
                            "isGroup": false,
                            "isGroupItem": false
                        },
                        {
                            "items": [
                                "Сохранность данных при перерывах питания, не менее, лет",
                                "10"
                            ],
                            "isGroup": false,
                            "isGroupItem": false
                        },
                        {
                            "items": [
                                "Межповерочный интервал, лет",
                                "16"
                            ],
                            "isGroup": false,
                            "isGroupItem": false
                        },
                        {
                            "items": [
                                "Гарантийный срок эксплуатации, лет",
                                "5"
                            ],
                            "isGroup": false,
                            "isGroupItem": false
                        },
                        {
                            "items": [
                                "Наработка на отказ, не менее, ч",
                                "320 000"
                            ],
                            "isGroup": false,
                            "isGroupItem": false
                        },
                        {
                            "items": [
                                "Диапазон рабочих температур, \u00B0С",
                                "от -45 до \u002B70"
                            ],
                            "isGroup": false,
                            "isGroupItem": false
                        },
                        {
                            "items": [
                                "Масса, не более, кг",
                                "1,6"
                            ],
                            "isGroup": false,
                            "isGroupItem": false
                        },
                        {
                            "items": [
                                "Габариты (ДхШхВ), для корпуса без сменных модулей, мм",
                                "173,5x65x288,5"
                            ],
                            "isGroup": false,
                            "isGroupItem": false
                        }
                    ]
                }
            },
            {
                "isPreview": false,
                "header": "Метрологические характеристики",
                "text": null,
                "list": null,
                "table": {
                    "columns": [
                        "",
                        ""
                    ],
                    "rows": [
                        {
                            "items": [
                                "Класс точности счетчиков (актив. / реактив.):\u00A0",
                                ""
                            ],
                            "isGroup": false,
                            "isGroupItem": false
                        },
                        {
                            "items": [
                                "\u2022 трансформаторного включения:\u00A0",
                                "0,2S/0,5 и 0,5S/1"
                            ],
                            "isGroup": false,
                            "isGroupItem": false
                        },
                        {
                            "items": [
                                "\u2022 прямого включения:\u00A0",
                                "1/2"
                            ],
                            "isGroup": false,
                            "isGroupItem": false
                        },
                        {
                            "items": [
                                "Номинальное напряжение, В:\u00A0",
                                ""
                            ],
                            "isGroup": false,
                            "isGroupItem": false
                        },
                        {
                            "items": [
                                "\u2022 трансформаторного включения:\u00A0",
                                "3*57,7/100"
                            ],
                            "isGroup": false,
                            "isGroupItem": false
                        },
                        {
                            "items": [
                                "\u2022 прямого включения:\u00A0",
                                "3*230/400"
                            ],
                            "isGroup": false,
                            "isGroupItem": false
                        },
                        {
                            "items": [
                                "Базовый / максимальный ток, А:\u00A0",
                                ""
                            ],
                            "isGroup": false,
                            "isGroupItem": false
                        },
                        {
                            "items": [
                                "\u2022 трансформаторного включения:\u00A0",
                                "1/2; 1/10; 5/10"
                            ],
                            "isGroup": false,
                            "isGroupItem": false
                        },
                        {
                            "items": [
                                "\u2022 прямого включения:\u00A0",
                                "5/60; 5/80; 5/100"
                            ],
                            "isGroup": false,
                            "isGroupItem": false
                        },
                        {
                            "items": [
                                "Макс. ток для счетчиков прямого включения в течение 10 мс:\u00A0",
                                "30*I макс"
                            ],
                            "isGroup": false,
                            "isGroupItem": false
                        },
                        {
                            "items": [
                                "Максимальный ток для счетчиков трансформаторного включения в течение 0,5 с:\u00A0",
                                "20*I макс"
                            ],
                            "isGroup": false,
                            "isGroupItem": false
                        },
                        {
                            "items": [
                                "Чувствительность при измерении активной энергии, А:\u00A0",
                                ""
                            ],
                            "isGroup": false,
                            "isGroupItem": false
                        },
                        {
                            "items": [
                                "\u2022 трансформаторного включения:\u00A0",
                                "0,001/0,005"
                            ],
                            "isGroup": false,
                            "isGroupItem": false
                        },
                        {
                            "items": [
                                "\u2022 прямого включения:\u00A0",
                                "0,02"
                            ],
                            "isGroup": false,
                            "isGroupItem": false
                        }
                    ]
                }
            }
        ]
};
//**************************************************************************************MERCURY234
//**************************************************************************************MERCURY236
const MERCURY236 = {
    id: "MERCURY236",
    name: "<b>Меркурий 236</b>",
    img: "/heatmeters/Меркурий 236.png",
    imgAlt: "Меркурий 236",
    description:
        [
            {
                "isPreview": true,
                "header": "",
                "text": "Счетчики предназначены для однонаправленного многотарифного учета активной и реактивной электрической энергии и мощности, а также измерения параметров электрической сети в трехфазных четырехпроводных сетях переменного тока с последующим хранением накопленной информации, формированием событий и передачей информации в центры сбора данных систем АСКУЭ.",
                "list": null,
                "table": null
            },
            {
                "isPreview": false,
                "header": null,
                "text": "Счетчики предназначены для эксплуатации внутри закрытых помещений и могут быть использованы в местах, имеющих дополнительную защиту от влияния окружающей среды (установлены в помещении, в шкафу, в щитке).",
                "list": null,
                "table": null
            },
            {
                "isPreview": false,
                "header": "Технические характеристики",
                "text": null,
                "list": null,
                "table": {
                    "columns": [
                        "",
                        ""
                    ],
                    "rows": [
                        {
                            "items": [
                                "Активная / полная потребляемая мощность в каждой цепи напряжения счетчика при номинальном напряжении, Вт/В*А",
                                "1 / 9"
                            ],
                            "isGroup": false,
                            "isGroupItem": false
                        },
                        {
                            "items": [
                                "Дополнительная потребляемая активная / полная мощность для счетчиков со встроенным модемом, Вт (В*А)",
                                "1,5 / 24"
                            ],
                            "isGroup": false,
                            "isGroupItem": false
                        },
                        {
                            "items": [
                                "Полная мощность, потребляемая каждой цепью тока, не более, В*А",
                                "0,1"
                            ],
                            "isGroup": false,
                            "isGroupItem": false
                        },
                        {
                            "items": [
                                "Количество тарифов",
                                "4"
                            ],
                            "isGroup": false,
                            "isGroupItem": false
                        },
                        {
                            "items": [
                                "Сохранность данных при перерывах питания, не менее, лет",
                                "10"
                            ],
                            "isGroup": false,
                            "isGroupItem": false
                        },
                        {
                            "items": [
                                "Межповерочный интервал, лет",
                                "16"
                            ],
                            "isGroup": false,
                            "isGroupItem": false
                        },
                        {
                            "items": [
                                "Гарантийный срок эксплуатации, лет",
                                "3"
                            ],
                            "isGroup": false,
                            "isGroupItem": false
                        },
                        {
                            "items": [
                                "Наработка на отказ, не менее, ч",
                                "320 000"
                            ],
                            "isGroup": false,
                            "isGroupItem": false
                        },
                        {
                            "items": [
                                "Диапазон рабочих температур, \u00B0С",
                                "от -45 до \u002B70"
                            ],
                            "isGroup": false,
                            "isGroupItem": false
                        },
                        {
                            "items": [
                                "Масса, не более, кг",
                                "0,9"
                            ],
                            "isGroup": false,
                            "isGroupItem": false
                        },
                        {
                            "items": [
                                "Габариты (ДхШхВ), мм",
                                "157,5x71,7x154"
                            ],
                            "isGroup": false,
                            "isGroupItem": false
                        }
                    ]
                }
            },
            {
                "isPreview": false,
                "header": "Метрологические характеристики",
                "text": null,
                "list": null,
                "table": {
                    "columns": [
                        "",
                        ""
                    ],
                    "rows": [
                        {
                            "items": [
                                "Класс точности счетчиков (актив. / реактив.):\u00A0",
                                ""
                            ],
                            "isGroup": false,
                            "isGroupItem": false
                        },
                        {
                            "items": [
                                "\u2022 с номинальным / максимальным током 5 / 10 А:\u00A0",
                                "0,5S/1"
                            ],
                            "isGroup": false,
                            "isGroupItem": false
                        },
                        {
                            "items": [
                                "\u2022 с номинальным / максимальным током 5 / 60, 10 / 100 А:\u00A0",
                                "1/2"
                            ],
                            "isGroup": false,
                            "isGroupItem": false
                        },
                        {
                            "items": [
                                "Номинальное напряжение, В:\u00A0",
                                "3*230/400"
                            ],
                            "isGroup": false,
                            "isGroupItem": false
                        },
                        {
                            "items": [
                                "Базовый / максимальный ток, А:\u00A0",
                                "5/10; 5/60; 5/100"
                            ],
                            "isGroup": false,
                            "isGroupItem": false
                        },
                        {
                            "items": [
                                "Макс. ток для счетчиков с номинальным / максимальным током 5 / 60, 10 / 100 А в течение 10 мс:\u00A0",
                                "30*I макс"
                            ],
                            "isGroup": false,
                            "isGroupItem": false
                        },
                        {
                            "items": [
                                "Максимальный ток для счетчиков с номинальным / максимальным током 5 / 10 А в течение 0,5 с:\u00A0",
                                "20*I макс"
                            ],
                            "isGroup": false,
                            "isGroupItem": false
                        },
                        {
                            "items": [
                                "Чувствительность при измерении активной энергии, А:\u00A0",
                                ""
                            ],
                            "isGroup": false,
                            "isGroupItem": false
                        },
                        {
                            "items": [
                                "\u2022 трансформаторного включения:\u00A0",
                                "0,005"
                            ],
                            "isGroup": false,
                            "isGroupItem": false
                        },
                        {
                            "items": [
                                "\u2022 прямого включения:\u00A0",
                                "0,02"
                            ],
                            "isGroup": false,
                            "isGroupItem": false
                        }
                    ]
                }
            },
            {
                "isPreview": false,
                "header": null,
                "text": null,
                "list": {
                    "type": "dots",
                    "items": [
                        {
                            "text": "Многофункциональные счетчики для систем АСКУЭ в малогабаритном корпусе с креплением на DIN-рейку, аналогичные по большинству функций многофункциональным счетчикам \u00ABМеркурий 234\u00BB",
                            "sublist": null
                        },
                        {
                            "text": "Измерение, учёт, хранение, вывод на ЖКИ и передача по интерфейсам активной и реактивной электроэнергии раздельно по каждому тарифу и сумму по всем тарифам за следующие периоды времени: ",
                            "sublist": {
                                "type": "dots",
                                "items": [
                                    {
                                        "text": "энергия всего от сброса показаний;",
                                        "sublist": null
                                    },
                                    {
                                        "text": "энергия на начало текущих и 123 предыдущих суток (для счётчиков с индексом \u00ABQ\u00BB);",
                                        "sublist": null
                                    },
                                    {
                                        "text": "энергия на начало текущего и 36 предыдущих месяцев (для счётчиков с индексом \u00ABQ\u00BB);",
                                        "sublist": null
                                    },
                                    {
                                        "text": "энергия на начало текущего и предыдущего года;",
                                        "sublist": null
                                    },
                                    {
                                        "text": "расход за текущие и предыдущие сутки;",
                                        "sublist": null
                                    },
                                    {
                                        "text": "расход за текущий и 11 предыдущих месяцев.",
                                        "sublist": null
                                    }
                                ]
                            }
                        },
                        {
                            "text": "Возможность учета электроэнергии независимо от фазировки токовых цепей (учет по модулю)",
                            "sublist": null
                        },
                        {
                            "text": "Тарификатор с возможностью задания отдельного расписания для каждого дня недели по 4 тарифам в 16 временных зонах суток.Каждый месяц года программируется на индивидуальное тарифное расписание. Минимальный интервал действия тарифа в пределах суток 1 минута",
                            "sublist": null
                        },
                        {
                            "text": "Измерение параметров электрической сети: ",
                            "sublist": {
                                "type": "dots",
                                "items": [
                                    {
                                        "text": "мгновенные значения активной, реактивной и полной мощности по каждой фазе и по сумме фаз с указанием направления вектора полной мощности;",
                                        "sublist": null
                                    },
                                    {
                                        "text": "действующие значения фазных токов и напряжений;",
                                        "sublist": null
                                    },
                                    {
                                        "text": "значения углов между фазными напряжениями;",
                                        "sublist": null
                                    },
                                    {
                                        "text": "частота сети;",
                                        "sublist": null
                                    },
                                    {
                                        "text": "коэффициенты мощности по каждой фазе и по сумме фаз;",
                                        "sublist": null
                                    },
                                    {
                                        "text": "коэффициент искажения синусоидальности фазных кривых.",
                                        "sublist": null
                                    }
                                ]
                            }
                        },
                        {
                            "text": "Профиль мощности с произвольным временем усреднения от 1 до 60 минут. Глубина хранения 170 суток для времени усреднения 30 минут",
                            "sublist": null
                        },
                        {
                            "text": "Фиксация утренних и вечерних максимумов активной и реактивной мощности на заданном интервале с ежемесячным расписанием",
                            "sublist": null
                        },
                        {
                            "text": "Ведение журналов событий, включая события показателей качества электроэнергии",
                            "sublist": null
                        },
                        {
                            "text": "Наличие импульсного выхода, в том числе с функцией управления нагрузкой",
                            "sublist": null
                        },
                        {
                            "text": "Автоматическая самодиагностика с индикацией ошибок",
                            "sublist": null
                        },
                        {
                            "text": "Энергонезависимые электронные пломбы",
                            "sublist": null
                        },
                        {
                            "text": "Запись несанкционированных воздействий в нестираемые журналы событий",
                            "sublist": null
                        },
                        {
                            "text": "Многофункциональный ЖКИ c подсветкой и отображением OBIS-кодов отображаемых параметров",
                            "sublist": null
                        },
                        {
                            "text": "Индикация параметров на ЖКИ при отключенном питании",
                            "sublist": null
                        }
                    ]
                },
                "table": null
            }
        ]
};
//**************************************************************************************MERCURY236
//**************************************************************************************MKTS
const MKTS = {
    id: "MKTS",
    name: "<b>МКТС</b>",
    img: "/heatmeters/мктс.png",
    imgAlt: "МКТС",
    description:
        [
            {
                "isPreview": true,
                "header": "Описание и технические характеристики Теплосчетчиков МКТС ",
                "text": "Теплосчетчики МКТС предназначены для измерения и учета тепловой энергии, объемного и массового расхода, объема и массы, температуры и давления теплоносителя в открытых и закрытых системах водяного теплоснабжения, теплопотребления и теплоотведения; объемного и массового расхода, объема и массы, температуры и давления воды в системах водоснабжения и водоотведения. С помощью Теплосчетчика МКТС возможно измерение этих параметров в трубопроводах технологического оборудования, в том числе применяемого в пищевой промышленности (учет молока, соков, алкогольной продукции с содержанием этилового спирта до 60%, и др.). ",
                "list": null,
                "table": null
            },
            {
                "isPreview": false,
                "header": "Области применения Теплосчетчиков МКТС: ",
                "text": null,
                "list": {
                    "type": "dots",
                    "items": [
                        {
                            "text": "коммерческий и технологический учет на объектах теплоэнергетического комплекса жилищно-коммунального хозяйства и промышленных предприятий, ",
                            "sublist": null
                        },
                        {
                            "text": "информационно-измерительные системы, ",
                            "sublist": null
                        },
                        {
                            "text": "системы контроля и регулирования технологических процессов.",
                            "sublist": null
                        }
                    ]
                },
                "table": null
            },
            {
                "isPreview": false,
                "header": "",
                "text": "В зависимости от конфигурации и настройки Теплосчетчик МКТС может быть использован как теплосчетчик или как счетчик-расходомер массы и объема жидкости в одном или нескольких (до двенадцати) трубопроводах одновременно. ",
                "list": null,
                "table": null
            },
            {
                "isPreview": false,
                "header": "Основные особенности концепции: ",
                "text": null,
                "list": {
                    "type": "dots",
                    "items": [
                        {
                            "text": "Универсальность – Теплосчетчик МКТС позволяет реализовать любую из схем узлов учета систем водотеплоснабжения и потребления, приведенных в \u00ABПравилах коммерческого учета тепловой энергии, теплоносителя\u00BB, причем одновременно может обслуживаться до четырех тепловых систем.",
                            "sublist": null
                        },
                        {
                            "text": "Высокая точность измерения обеспечивается уникальными схемотехническими решениями, принципиально новой конструкцией преобразователя расхода и специальными алгоритмами обработки сигналов.",
                            "sublist": null
                        },
                        {
                            "text": "Высокая надежность достигается применением передовых технологий, еще недавно доступных только в закрытых отраслях машиностроения, и тщательным тестированием всех компонентов теплосчетчика на специальных стендах в процессе производства.",
                            "sublist": null
                        },
                        {
                            "text": "Модульность конструкции и гибкость конфигурации. Теплосчетчик МКТС построен по модульному принципу и обладает высокой гибкостью аппаратной и программной конфигурации, что позволяет строить многоканальные системы учета различной сложности, содержащие от 1 до 16 измерительных модулей (расходомеров), измеряющих расход и другие параметры теплоносителя. ",
                            "sublist": null
                        },
                        {
                            "text": "На материнской плате системного блока (СБ) МКТС предусмотрены разъемы (слоты) для подключения различных плат расширения, что позволяет оперативно наращивать конфигурацию теплосчетчика в зависимости от потребностей заказчика. ",
                            "sublist": null
                        },
                        {
                            "text": "Предельная простота монтажа и ввода в эксплуатацию обусловлены оригинальным способом подключения измерительных модулей к СБ МКТС – всего лишь одной витой парой.",
                            "sublist": null
                        },
                        {
                            "text": "По витой паре осуществляется:",
                            "sublist": null
                        },
                        {
                            "text": "обмен данными между СБ и измерительными модулями в цифровом формате;",
                            "sublist": null
                        },
                        {
                            "text": "питание всех измерительных модулей от одного общего источника, размещенного в СБ.",
                            "sublist": null
                        }
                    ]
                },
                "table": null
            }
        ]
};
//**************************************************************************************MKTS
//**************************************************************************************PLK100
const PLK100 = {
    id: "PLK100",
    name: "<b>ПЛК-100</b>",
    img: "/heatmeters/ПЛК100.png",
    imgAlt: "ПЛК-100",
    description:
        [
            {
                "isPreview": true,
                "header": "",
                "text": "Программируемый логический контроллер ПЛК100.ТЛ предназначен для создания систем автоматизированного управления технологическим оборудованием в энергетике, на ж/д транспорте, в различных областях промышленности, жилищно-коммунального и сельского хозяйства, на опасных производственных объектах (например Котлонадзора), подконтрольных органам Ростехнадзора.",
                "list": null,
                "table": null
            },
            {
                "isPreview": true,
                "header": "",
                "text": "Логика работы ПЛК100.ТЛ определяется потребителем в процессе программирования контроллера.Программирование и конфигурирование контроллера осуществляется в среде программирования Enlogic, интегрированной в ПО Телемеханика Лайт.",
                "list": null,
                "table": null
            },
            {
                "isPreview": false,
                "header": "Программируемый логический контроллер ОВЕН ПЛК 100 предназначе",
                "text": null,
                "list": {
                    "type": "dots",
                    "items": [
                        {
                            "text": "Для создания систем управления малыми и средними объектами",
                            "sublist": null
                        },
                        {
                            "text": "Построение систем диспетчеризации",
                            "sublist": null
                        },
                        {
                            "text": "Построение системы управления и диспетчеризации на базе\u00A0ОВЕН ПЛК\u00A0возможно как с помощью проводных средств – используя встроенные интерфейсы Ethernet, RS-232, RS-485, так и с помощью беспроводных средств – использую радио, GSM, ADSL модемы",
                            "sublist": null
                        }
                    ]
                },
                "table": null
            },
            {
                "isPreview": false,
                "header": "Конструктивные особенности ОВЕН ПЛК 100",
                "text": null,
                "list": {
                    "type": "dots",
                    "items": [
                        {
                            "text": "Контроллер выполнен в компактном DIN-реечном корпусе",
                            "sublist": null
                        },
                        {
                            "text": "Расширение количества точек ввода\\вывода осуществляется путем подключения внешних модулей ввода\\вывода по любому из встроенных интерфейсов",
                            "sublist": null
                        },
                        {
                            "text": "Два варианта питания 220В и 24В постоянного",
                            "sublist": null
                        }
                    ]
                },
                "table": null
            },
            {
                "isPreview": false,
                "header": "Вычислительные ресурсы ОВЕН ПЛК 100",
                "text": "В контроллере изначально заложены мощные вычислительные ресурсы при отсутствии операционной системы:",
                "list": null,
                "table": null
            },
            {
                "isPreview": false,
                "header": null,
                "text": null,
                "list": {
                    "type": "dots",
                    "items": [
                        {
                            "text": "высокопроизводительный процессор RISC архитектуры ARM9, с частотой 180МГц компании Atmel;",
                            "sublist": null
                        },
                        {
                            "text": "большой объем оперативной памяти – 8МБ;",
                            "sublist": null
                        },
                        {
                            "text": "большой объем постоянной памяти – Flash память, 4МБ;",
                            "sublist": null
                        },
                        {
                            "text": "объем энергонезависимой памяти, для хранения значений переменных – до 16КБ.",
                            "sublist": null
                        }
                    ]
                },
                "table": null
            },
            {
                "isPreview": false,
                "header": "Конкурентные преимущества ОВЕН ПЛК 10",
                "text": null,
                "list": {
                    "type": "dots",
                    "items": [
                        {
                            "text": "Отсутствие ОС, что повышает надежность работы контроллеров",
                            "sublist": null
                        },
                        {
                            "text": "Скорость работы дискретных входов – до 10КГц при использовании подмодулей счетчика",
                            "sublist": null
                        },
                        {
                            "text": "Большое количество интерфейсов на борту: Ethernet, 3 последовательных порта, USB Device для программирования контроллера, работающих независимо друг от друга",
                            "sublist": null
                        },
                        {
                            "text": "Расширенный температурный диапазон работы: от минус 20 до плюс 70 градусов Цельсия",
                            "sublist": null
                        },
                        {
                            "text": "Широкие возможности самодиагностики контроллера",
                            "sublist": null
                        },
                        {
                            "text": "Встроенный аккумулятор, позволяющий \u00ABпережидать\u00BB пропадани питания – выполнять программу при пропадании питания, и переводить выходные элементы в \u00ABбезопасное состояние\u00BB",
                            "sublist": null
                        },
                        {
                            "text": "Встроенные часы реального времени",
                            "sublist": null
                        },
                        {
                            "text": "Возможность создавать и сохранять архивы на Flash контроллера",
                            "sublist": null
                        },
                        {
                            "text": "Возможность работы по любому нестандартному протоколу по любому из портов, что позволяет подключать устройства с нестандартным протоколом (электро-, газо-, водосчетчики, считыватели штрих - кодов и т.д.) ",
                            "sublist": null
                        },
                        {
                            "text": "Набор готовых программных модулей, предоставляемых бесплатно",
                            "sublist": null
                        }
                    ]
                },
                "table": null
            }
        ]};
//**************************************************************************************PLK100
//**************************************************************************************PSCH_ZART_09
const PSCH_ZART_09 = {
    id: "PSCH_ZART_09",
    name: "<b>ПСЧ-3АРТ-09</b>",
    img: "/heatmeters/ПСЧ-3АРТ-09.png",
    imgAlt: "ПСЧ-3АРТ-09",
    description:
        [
            {
                "isPreview": true,
                "header": "НАЗНАЧЕНИЕ И ОБЛАСТЬ ПРИМЕНЕНИЯ",
                "text": "Счетчик предназначен для учета активной и реактивной электроэнергии в трех-, четырехпроводных сетях переменного тока частотой 50 Гц, дифференцированного, как по времени суток, так и по уровню потребляемой электроэнергии и мощности. ",
                "list": null,
                "table": null
            },
            {
                "isPreview": true,
                "header": "",
                "text": "Счетчик может использоваться автономно или в составе автоматизированных информационно-измерительных систем контроля и учета электроэнергии (АСКУЭ) с возможностью автоматического контроля потребления электроэнергии .",
                "list": null,
                "table": null
            },
            {
                "isPreview": false,
                "header": null,
                "text": "НОРМАТИВНО-ПРАВОВОЕ ОБЕСПЕЧЕНИЕ",
                "list": null,
                "table": null
            },
            {
                "isPreview": false,
                "header": "Соответствие ГОСТ Р 52320-2005, ГОСТ Р 52322-2005, ГОСТ Р 52323-2005, ГОСТ Р 52425-2005",
                "text": " ",
                "list": null,
                "table": null
            },
            {
                "isPreview": false,
                "header": "ТЕХНИЧЕСКИЕ ОСОБЕННОСТИ ЭЛЕКТРОСЧЕТЧИКА",
                "text": null,
                "list": {
                    "type": "dots",
                    "items": [
                        {
                            "text": "Тарифное расписание на 4 тарифа (на каждый день недели каждого месяца и праздничные дни каждого месяца).",
                            "sublist": null
                        },
                        {
                            "text": "Энергонезависимая память.",
                            "sublist": null
                        },
                        {
                            "text": "Программируемый импульсный выход на 6 режимов. ",
                            "sublist": null
                        },
                        {
                            "text": "В качестве датчика тока используется токовый трансформатор.",
                            "sublist": null
                        },
                        {
                            "text": "Возможность подключения внешнего резервного источника питания 9В для снятия показаний при отсутствии 230В.",
                            "sublist": null
                        },
                        {
                            "text": "5 журналов по 32 события.",
                            "sublist": null
                        },
                        {
                            "text": "Интерфейс связи RS-485 и оптопорт.",
                            "sublist": null
                        },
                        {
                            "text": "Допускается одновременная работа через оба порта (RS-485 и оптопорт).",
                            "sublist": null
                        },
                        {
                            "text": "Получасовой профиль активной и реактивной энергии и мощности (глубина хранения 2 месяца).",
                            "sublist": null
                        },
                        {
                            "text": "Ежесуточная самодиагностика памяти программ.",
                            "sublist": null
                        },
                        {
                            "text": "Светодиодная индикация активного и реактивного потребления.",
                            "sublist": null
                        },
                        {
                            "text": "Одна электронная пломба.",
                            "sublist": null
                        }
                    ]
                },
                "table": null
            },
            {
                "isPreview": false,
                "header": "ФУНКЦИОНАЛЬНЫЕ ВОЗМОЖНОСТИ ЭЛЕКТРОСЧЕТЧИКАСчетчик обеспечивает измерение, регистрацию и хранение в энергонезависимой памяти: ",
                "text": null,
                "list": {
                    "type": "dots",
                    "items": [
                        {
                            "text": "значения учтенной электроэнергии нарастающим итогом с момента изготовления по всем тарифам;",
                            "sublist": null
                        },
                        {
                            "text": "значения учтенной электроэнергии на начало каждого месяца по всем тарифам с глубиной хранения 24 месяца;",
                            "sublist": null
                        },
                        {
                            "text": "значения учтенной электроэнергии и максимальной мощности каждого получаса в течение двух месяцев.",
                            "sublist": null
                        },
                        {
                            "text": "времени и даты включения/отключения питания (32 события);",
                            "sublist": null
                        },
                        {
                            "text": "времени и даты открытия и закрытия канала на запись по RS 485 (32 события);",
                            "sublist": null
                        },
                        {
                            "text": "времени и даты открытия и закрытия канала на запись по оптопорту (32 события);",
                            "sublist": null
                        },
                        {
                            "text": "времени и даты до и после коррекции (32 события);",
                            "sublist": null
                        },
                        {
                            "text": "времени и даты открытия и закрытия крышки клеммной колодки (32 события);",
                            "sublist": null
                        },
                        {
                            "text": "времени и даты включения/отключения напряжений по фазам А, В, С (по 32 события).",
                            "sublist": null
                        }
                    ]
                },
                "table": null
            },
            {
                "isPreview": false,
                "header": "Электросчетчик имеет возможность перепрограммирования через интерфейс связи: ",
                "text": null,
                "list": {
                    "type": "dots",
                    "items": [
                        {
                            "text": "скорости обмена по RS-485;",
                            "sublist": null
                        },
                        {
                            "text": "группового и индивидуального пароля;",
                            "sublist": null
                        },
                        {
                            "text": "адреса; ",
                            "sublist": null
                        },
                        {
                            "text": "пароля на запись.",
                            "sublist": null
                        }
                    ]
                },
                "table": null
            },
            {
                "isPreview": false,
                "header": null,
                "text": "При трехкратном вводе неверного пароля на запись счетчик электроэнергии блокирует канал записи на 24 часа.",
                "list": null,
                "table": null
            },
            {
                "isPreview": false,
                "header": null,
                "text": "Электросчетчик формирует сигналы управления нагрузкой по различным программируемым критериям и позволяет производить включение/отключение нагрузки посредством внешнего коммутирующего устройства.",
                "list": null,
                "table": null
            },
            {
                "isPreview": false,
                "header": "",
                "text": "Счетчик электроэнергии имеет возможность считывания и перепрограммирования через интерфейс RS-485 или оптопорт следующих параметров:",
                "list": null,
                "table": null
            },
            {
                "isPreview": false,
                "header": null,
                "text": null,
                "list": {
                    "type": "dots",
                    "items": [
                        {
                            "text": "категории потребителя;",
                            "sublist": null
                        },
                        {
                            "text": "текущего времени и даты;",
                            "sublist": null
                        },
                        {
                            "text": "годового тарифного расписания (на каждый день недели или праздничный день месяца);",
                            "sublist": null
                        },
                        {
                            "text": "лимита мощности и месячного лимита энергии;",
                            "sublist": null
                        },
                        {
                            "text": "функции разрешения/запрета автоматического перехода с \u0022летнего\u0022 времени на \u0022зимнее\u0022 и наоборот;",
                            "sublist": null
                        },
                        {
                            "text": "режимов работы импульсного выхода электросчетчика: поверка, телеметрия, включение, отключение, контроль мощности, калибровка часов;",
                            "sublist": null
                        },
                        {
                            "text": "режима индикации и периода индикации в диапазоне от 6 до 60 с;",
                            "sublist": null
                        },
                        {
                            "text": "разрешения однотарифного режима работы.",
                            "sublist": null
                        }
                    ]
                },
                "table": null
            },
            {
                "isPreview": false,
                "header": "Электросчетчик обеспечивает отображение следующих параметров:",
                "text": null,
                "list": {
                    "type": "dots",
                    "items": [
                        {
                            "text": "текущего значения электроэнергии по каждому тарифу; ",
                            "sublist": null
                        },
                        {
                            "text": "суммарного значения накопленной электроэнергии; ",
                            "sublist": null
                        },
                        {
                            "text": "текущего времени; ",
                            "sublist": null
                        },
                        {
                            "text": "текущей даты; ",
                            "sublist": null
                        },
                        {
                            "text": "текущей измеряемой активной мощности; ",
                            "sublist": null
                        },
                        {
                            "text": "суммарного значения активной мощности; ",
                            "sublist": null
                        },
                        {
                            "text": "текущей измеряемой реактивной мощности;",
                            "sublist": null
                        },
                        {
                            "text": "суммарного значения реактивной мощности; ",
                            "sublist": null
                        },
                        {
                            "text": "фазного напряжения; ",
                            "sublist": null
                        },
                        {
                            "text": "фазного тока; ",
                            "sublist": null
                        },
                        {
                            "text": "частоты; ",
                            "sublist": null
                        },
                        {
                            "text": "тарифного расписания текущего месяца;",
                            "sublist": null
                        },
                        {
                            "text": "значения накопленной электроэнергии за месяц по тарифам;",
                            "sublist": null
                        },
                        {
                            "text": "потребляемой активной электроэнергии в текущем получасе; ",
                            "sublist": null
                        },
                        {
                            "text": "максимальной активной мощности в текущем получасе; ",
                            "sublist": null
                        },
                        {
                            "text": "потребляемой реактивной электроэнергии в текущем получасе;",
                            "sublist": null
                        },
                        {
                            "text": "максимальной потребляемой реактивной мощности в текущем получасе.",
                            "sublist": null
                        }
                    ]
                },
                "table": null
            },
            {
                "isPreview": false,
                "header": "ТЕХНИЧЕСКИЕ ХАРАКТЕРИСТИКИ ЭЛЕКТРОСЧЕТЧИКА",
                "text": null,
                "list": null,
                "table": {
                    "columns": [
                        "Наименование величины ",
                        "Значение"
                    ],
                    "rows": [
                        {
                            "items": [
                                "Номинальное напряжение, В ",
                                "3х57,7/100; 3х230/400;3х(120-230)/(208-400)"
                            ],
                            "isGroup": false,
                            "isGroupItem": false
                        },
                        {
                            "items": [
                                "Установленный рабочий диапазон напряжений, В ",
                                "от 0,9 до 1,1 Uном"
                            ],
                            "isGroup": false,
                            "isGroupItem": false
                        },
                        {
                            "items": [
                                "Расширенный рабочий диапазон напряжений , В ",
                                "от 0,8 до 1,15 Uном"
                            ],
                            "isGroup": false,
                            "isGroupItem": false
                        },
                        {
                            "items": [
                                "Предельный рабочий диапазон напряжений, В ",
                                "от 0 до 1,15 Uном"
                            ],
                            "isGroup": false,
                            "isGroupItem": false
                        },
                        {
                            "items": [
                                "Базовый (максимальный) ток для электросчетчиков непосредственного включения, А",
                                "5 (60) или 10 (100)"
                            ],
                            "isGroup": false,
                            "isGroupItem": false
                        },
                        {
                            "items": [
                                "Номинальный (максимальный) ток для счетчиков трансформаторного включения, А",
                                "5 (7,5) "
                            ],
                            "isGroup": false,
                            "isGroupItem": false
                        },
                        {
                            "items": [
                                "Класс точности при измерении активной (реактивной) энергии ",
                                "0,5 S или 1 (1 или 2)"
                            ],
                            "isGroup": false,
                            "isGroupItem": false
                        },
                        {
                            "items": [
                                "Частота сети, Гц ",
                                "50\u00B12,5"
                            ],
                            "isGroup": false,
                            "isGroupItem": false
                        },
                        {
                            "items": [
                                "Погрешность при измерении фазных напряжения, %",
                                "\u00B10,9"
                            ],
                            "isGroup": false,
                            "isGroupItem": false
                        },
                        {
                            "items": [
                                "Погрешность при измерении фазных токов, %:",
                                "\u00A0"
                            ],
                            "isGroup": false,
                            "isGroupItem": false
                        },
                        {
                            "items": [
                                "\u00A0\u00A0\u00A0для электросчетчиков непосредственного включения:",
                                "\u00A0"
                            ],
                            "isGroup": false,
                            "isGroupItem": false
                        },
                        {
                            "items": [
                                "\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0в диапазоне от Iб до Iмакс",
                                "\u00B15"
                            ],
                            "isGroup": false,
                            "isGroupItem": false
                        },
                        {
                            "items": [
                                "\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0в диапазоне от 0,01Iб до Iб",
                                "\u00B1 [5\u002B0.2(Iб/Ix-1)]"
                            ],
                            "isGroup": false,
                            "isGroupItem": false
                        },
                        {
                            "items": [
                                "\u00A0\u00A0\u00A0для электросчетчиков трансформаторного включения:",
                                "\u00A0"
                            ],
                            "isGroup": false,
                            "isGroupItem": false
                        },
                        {
                            "items": [
                                "\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0в диапазоне от Iном до Iмакс",
                                "\u00B12"
                            ],
                            "isGroup": false,
                            "isGroupItem": false
                        },
                        {
                            "items": [
                                "\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0в диапазоне от 0,01Iном до Iном",
                                "\u00B1 [2\u002B0.2(Iном/Ix-1)]"
                            ],
                            "isGroup": false,
                            "isGroupItem": false
                        },
                        {
                            "items": [
                                "Погрешность электросчетчиков при измерении частоты сети в рабочем диапазоне частот от 47,5 до 52,5 Гц, %",
                                "\u00B10,15"
                            ],
                            "isGroup": false,
                            "isGroupItem": false
                        },
                        {
                            "items": [
                                "Стартовый ток (чувствительность) при измерении активной (реактивной), А:",
                                "\u00A0"
                            ],
                            "isGroup": false,
                            "isGroupItem": false
                        },
                        {
                            "items": [
                                "\u00A0\u00A0\u00A0Iб (Iмакс) = 5 (50) А, класс точности 1(2)",
                                "0,02 (0,025)"
                            ],
                            "isGroup": false,
                            "isGroupItem": false
                        },
                        {
                            "items": [
                                "\u00A0\u00A0\u00A0Iб (Iмакс) = 10 (100) А, класс точности 1(2)",
                                "0,04 (0,05)"
                            ],
                            "isGroup": false,
                            "isGroupItem": false
                        },
                        {
                            "items": [
                                "\u00A0\u00A0\u00A0Iном (Iмакс) = 5 (7,5) А, класс точности 1(2)",
                                "0,01 (0,015)"
                            ],
                            "isGroup": false,
                            "isGroupItem": false
                        },
                        {
                            "items": [
                                "\u00A0\u00A0\u00A0Iном (Iмакс) = 5 (7,5) А, класс точности 0,5S (1)",
                                "0,005 (0,01)"
                            ],
                            "isGroup": false,
                            "isGroupItem": false
                        },
                        {
                            "items": [
                                "Стартовый ток (чувствительность) при измерении активной (реактивной) энергии, А, не более для :",
                                "\u00A0"
                            ],
                            "isGroup": false,
                            "isGroupItem": false
                        },
                        {
                            "items": [
                                "\u00A0\u00A0\u00A0Iб (Iмакс) - 5(60) А, класс точности 1(2)\u00A0\u00A0\u00A0Iб (Iмакс) - 10(100) А, класс точности 1(2)\u00A0\u00A0\u00A0Iном (Iмакс) - 5(7,5) А, класс точности 1(2)\u00A0\u00A0\u00A0Iном (Iмакс) - 5(7,5) А, класс точности 0,5S(1)",
                                "0,02(0,025)0,04(0,05)0,01(0,015)0,005(0,01)"
                            ],
                            "isGroup": false,
                            "isGroupItem": false
                        },
                        {
                            "items": [
                                "Количество тарифов ",
                                "4"
                            ],
                            "isGroup": false,
                            "isGroupItem": false
                        },
                        {
                            "items": [
                                "Полная мощность, потребляемая последовательной цепью электросчетчика при номинальном токе и номинальной частоте, В\u00B7А ",
                                "не более 0,1"
                            ],
                            "isGroup": false,
                            "isGroupItem": false
                        },
                        {
                            "items": [
                                "Полная (активная) мощность, потребляемая каждой цепью напряжения электросчетчика при номинальном значении напряжения и номинальном значении частоты, Вт ",
                                "не более 2 (1,5)"
                            ],
                            "isGroup": false,
                            "isGroupItem": false
                        },
                        {
                            "items": [
                                "Передаточное число телеметрических выходов в основном (поверочном) режиме, имп./кВт\u00B7ч (имп/квар\u00B7ч):",
                                ""
                            ],
                            "isGroup": false,
                            "isGroupItem": false
                        },
                        {
                            "items": [
                                "\u00A0\u00A0\u00A0Iб(Iмакс)=5(60) А и Iб (Iмакс)=10(100) А",
                                "500 (10000)"
                            ],
                            "isGroup": false,
                            "isGroupItem": false
                        },
                        {
                            "items": [
                                "\u00A0\u00A0\u00A0Iном(Iмакс)=5(7,5) А",
                                "5000 (100000)"
                            ],
                            "isGroup": false,
                            "isGroupItem": false
                        },
                        {
                            "items": [
                                "Диапазон рабочих температур, oС ",
                                "от -40 до \u002B60"
                            ],
                            "isGroup": false,
                            "isGroupItem": false
                        },
                        {
                            "items": [
                                "Средняя наработка на отказ, ч ",
                                "220000"
                            ],
                            "isGroup": false,
                            "isGroupItem": false
                        },
                        {
                            "items": [
                                "Межповерочный интервал, лет ",
                                "16"
                            ],
                            "isGroup": false,
                            "isGroupItem": false
                        },
                        {
                            "items": [
                                "Средний срок службы электросчетчика, лет ",
                                "30"
                            ],
                            "isGroup": false,
                            "isGroupItem": false
                        },
                        {
                            "items": [
                                "Масса электросчетчика, кг ",
                                "не более 1,1"
                            ],
                            "isGroup": false,
                            "isGroupItem": false
                        },
                        {
                            "items": [
                                "Габаритные размеры, мм:",
                                "240х170х70"
                            ],
                            "isGroup": false,
                            "isGroupItem": false
                        }
                    ]
                }
            }
        ]
};
//**************************************************************************************PSCH_ZART_09
//**************************************************************************************PULSAR2K
const PULSAR2K = {
    id: "PULSAR2K",
    name: "<b>Пульсар 2К</b>",
    img: "/heatmeters/Пульсар 2к.png",
    imgAlt: "Пульсар 2К",
    description:
        [
            {
                "isPreview": true,
                "header": "Счетчик импульсов - регистратор \u0022ПУЛЬСАР\u0022\u00A0\u00A02-х канальный без индикатора\u00A0предназначен для:",
                "text": null,
                "list": {
                    "type": "dots",
                    "items": [
                        {
                            "text": "коммерческого и технологического учета потребления холодной и горячей воды, газа;",
                            "sublist": null
                        },
                        {
                            "text": "работы в составе АСКУЭ \u0022Пульсар\u0022.",
                            "sublist": null
                        }
                    ]
                },
                "table": null
            },
            {
                "isPreview": false,
                "header": null,
                "text": "Счетчик является вторичным преобразователем, реализует до двух числоимпульсных каналов измерения и в качестве первичных преобразователей использует водосчетчики, счетчики газа, имеющие импульсный (телеметрический) выход",
                "list": null,
                "table": null
            },
            {
                "isPreview": false,
                "header": "Счетчик обеспечивает измерение следующей текущей информации:",
                "text": null,
                "list": {
                    "type": "dots",
                    "items": [
                        {
                            "text": "потребленный объем воды, газа нарастающим итогом по каждому каналу;",
                            "sublist": null
                        },
                        {
                            "text": "время работы прибора в часах; ",
                            "sublist": null
                        },
                        {
                            "text": "дату и время.\u00A0",
                            "sublist": null
                        }
                    ]
                },
                "table": null
            },
            {
                "isPreview": false,
                "header": "",
                "text": "Счетчик обеспечивает сохранение во встроенной энергонезависимой памяти архива параметров потребления воды, газа с последующей возможностью считывания через интерфейс RS485.   соответствует требованиям ТРТС 020/2011, 004/2011. Декларация о соответствии: ТС N RU Д-RU.АЯ46.В.71534.",
                "list": null,
                "table": null
            },
            {
                "isPreview": false,
                "header": "Основные технические характеристики",
                "text": null,
                "list": {
                    "type": "dots",
                    "items": [
                        {
                            "text": "1). Питание от встроенной литиевой батареи ER14250 3,6В (или аналогичной) обеспечивает непрерывность хода часов а также непрерывность счета импульсов;",
                            "sublist": null
                        },
                        {
                            "text": "2). Напряжение внешнего питания, необходимое для функционирования обмена по интерфейсу RS485: = 7..20 В;",
                            "sublist": null
                        },
                        {
                            "text": "3). Ток, потребляемый от внешнего источника питания: не более 10 мА;",
                            "sublist": null
                        },
                        {
                            "text": "4). Средний срок службы батареи: 10 лет;",
                            "sublist": null
                        },
                        {
                            "text": "5). Характеристики, числоимпульсных входов:",
                            "sublist": null
                        },
                        {
                            "text": "\u00A0- тип датчика (телеметрического выхода первичного прибора):\u00A0герконовый, транзисторный, либо активный (потенциальный);",
                            "sublist": null
                        },
                        {
                            "text": "\u00A0- частота выходного сигнала: не более 2000 Гц;",
                            "sublist": null
                        },
                        {
                            "text": "\u00A0- длительность импульса: не менее 0,25 мс;",
                            "sublist": null
                        },
                        {
                            "text": "\u00A0- уровень сигналов в случае использования счетчиков с активным выходом должен быть не более 3 В (уровень логического \u00220\u0022 - 0..0,4 В, уровень логической \u00221\u0022 - 2,4..3 В), сигналы большего уровня могут подключаться через пассивный делитель напряжения",
                            "sublist": null
                        },
                        {
                            "text": "6). Условия эксплуатации:",
                            "sublist": null
                        },
                        {
                            "text": "Температура окружающей среды: от минус 10 до плюс 50 \u00B0С (по специальному заказу от минус 40 до плюс 70 \u00B0С)",
                            "sublist": null
                        },
                        {
                            "text": "Вибрации частотой (5-25) Гц и амплитудой смещения до 0,1 мм",
                            "sublist": null
                        },
                        {
                            "text": "Переменное магнитное поле частотой 50 Гц напряженностью не более 400 А/м",
                            "sublist": null
                        },
                        {
                            "text": "Относительная влажность воздуха до 95% при температуре 35\u00B0С",
                            "sublist": null
                        },
                        {
                            "text": "\u00A0- Атмосферное давление от 84 до 106,7 кПа\\s",
                            "sublist": null
                        },
                        {
                            "text": "7). Степень защиты корпуса: IP65",
                            "sublist": null
                        },
                        {
                            "text": "8). Число цифровых каналов: 2;",
                            "sublist": null
                        },
                        {
                            "text": "9). Глубина архива: 1080 часов – почасового, 180 суток – посуточного, 24 месяца ",
                            "sublist": {
                                "type": "dots",
                                "items": [
                                    {
                                        "text": "помесячного",
                                        "sublist": null
                                    }
                                ]
                            }
                        },
                        {
                            "text": "10). Точность хода часов: 5 сек/сут;",
                            "sublist": null
                        },
                        {
                            "text": "11). Предел допускаемой абсолютной погрешности измерения количества импульсов: \u00B11 имп. за время счета;",
                            "sublist": null
                        },
                        {
                            "text": "12). Масса: не более - 200 г;",
                            "sublist": null
                        },
                        {
                            "text": "13). \u00A0Габаритные размеры: не более - 65х60х60 мм;",
                            "sublist": null
                        },
                        {
                            "text": "14). \u00A0Наработка на отказ: 75000 ч;",
                            "sublist": null
                        },
                        {
                            "text": "15). Срок службы: не менее - 12 лет;",
                            "sublist": null
                        },
                        {
                            "text": "16). \u00A0Межповерочный интервал: 6 лет;",
                            "sublist": null
                        },
                        {
                            "text": "17). Длина линии связи между регистратором и счётчиком с импульсным выходом в зависимости от условий прокладки кабеля: не более 1000 м;",
                            "sublist": null
                        },
                        {
                            "text": "18). \u00A0Длина линии связи между регистратором и ПК при использовании интерфейса RS485: не более - 1200 м.",
                            "sublist": null
                        }
                    ]
                },
                "table": null
            }
        ]
};
//**************************************************************************************PULSAR2K
//**************************************************************************************RADIO_PULSAR
const RADIO_PULSAR = {
    id: "RADIO_PULSAR",
    name: "<b>Радио Пульсар</b>",
    img: "/heatmeters/РадиоПульсар.png",
    imgAlt: "Радио Пульсар",
    description:
        [
            {
                "isPreview": true,
                "header": "РадиоПульсар. Квартирный модуль",
                "text": null,
                "list": {
                    "type": "dots",
                    "items": [
                        {
                            "text": "\u002BЭксплуатация в местах, где считывание данных по проводу затруднительно или невозможно",
                            "sublist": null
                        },
                        {
                            "text": "\u002BПростота монтажа и сопровождения",
                            "sublist": null
                        },
                        {
                            "text": "\u002BМинимальное энергопотребление",
                            "sublist": null
                        },
                        {
                            "text": "\u002BКонтроль состояния батареи",
                            "sublist": null
                        },
                        {
                            "text": "\u002BОбеспечение двусторонней связи",
                            "sublist": null
                        },
                        {
                            "text": "\u002BРабота с различными типами счетчиков",
                            "sublist": null
                        }
                    ]
                },
                "table": null
            },
            {
                "isPreview": false,
                "header": "",
                "text": "Двухканальный квартирный модуль РадиоПульсар оснащен двумя импульсными входами и имеет стильный современный корпус с компактными размерами (60 / 80 / 23 мм). Он выполняет подсчет импульсов поступающих от первичных преобразователей газа, преобразователей воды по радиоканалам и их передачу на шестнадцатиканальный модуль.",
                "list": null,
                "table": null
            },
            {
                "isPreview": false,
                "header": null,
                "text": "Корпус модуля выполнен с защитой IP20. Это устройство имеет автономное питание, обеспеченное встроенной литиевой батареей. Это гарантирует непрерывность процесса подсчета импульсов и передачу полученных результатов на этажные модули по радиоканалу. Модуль используется в технологических и коммерческих целях для осуществления общего контроля по потреблению газа и воды. ",
                "list": null,
                "table": null
            },
            {
                "isPreview": false,
                "header": "Характеристики",
                "text": null,
                "list": {
                    "type": "dots",
                    "items": [
                        {
                            "text": "Количество каналов модуля: 2;",
                            "sublist": null
                        },
                        {
                            "text": "Защита: IP20;",
                            "sublist": null
                        },
                        {
                            "text": "Измерение количества импульсов: 0...4000000000;",
                            "sublist": null
                        },
                        {
                            "text": "Передатчик (мощность, max, мВт): 10;",
                            "sublist": null
                        },
                        {
                            "text": "Сигнал на входе (частота, Гц, min): 25;",
                            "sublist": null
                        },
                        {
                            "text": "Передатчик (частота, МГц): 433,075\u2026434,750;",
                            "sublist": null
                        },
                        {
                            "text": "Импульс (длительность, мс, min): 20;",
                            "sublist": null
                        },
                        {
                            "text": "Питание: 3,6 В, литиевая батарея (срок службы - 6 лет);",
                            "sublist": null
                        },
                        {
                            "text": "Связь от регистратора до счетчика с импульсным выходом: 1000 м; ",
                            "sublist": null
                        },
                        {
                            "text": "Температура для эксплуатации (\u00B0С): \u002B5 / \u002B50 (по заказу \u002B5 / \u002B70); ",
                            "sublist": null
                        },
                        {
                            "text": "Габариты (мм): 60х80х23;",
                            "sublist": null
                        },
                        {
                            "text": "Наработка до отказа (час): 75000; ",
                            "sublist": null
                        },
                        {
                            "text": "Срок службы модуля (лет): 12;",
                            "sublist": null
                        },
                        {
                            "text": "Интервал между поверками (лет): 6;",
                            "sublist": null
                        },
                        {
                            "text": "Вес (max, г): 200.",
                            "sublist": null
                        }
                    ]
                },
                "table": null
            }
        ]
};
//**************************************************************************************RADIO_PULSAR
//**************************************************************************************RPT1100
const RPT1100 = {
    id: "RPT1100",
    name: "<b>РПТ-1100</b>",
    img: "/heatmeters/РПТ-1100.png",
    imgAlt: "РПТ-1100",
    description:
        [
            {
                "isPreview": true,
                "header": "",
                "text": "Тепловычислитель-регистратор РПТ-1100 (далее - РПТ) предназначен для измерений и преобразований выходных сигналов первичных измерительных преобразователей температуры, расхода и давления в значения измеряемых параметров теплоносителя, а также вычислений потребленного или отпущенного количества теплоты и теплоносителя.",
                "list": null,
                "table": null
            },
            {
                "isPreview": false,
                "header": "",
                "text": "РПТ может применяться в составе теплосчетчика для учета количества теплоносителя, а также потребленного (отпущенного) количества теплоты в закрытых и открытых водяных системах теплоснабжения и горячего водоснабжения (потребления) различных конфигураций.",
                "list": null,
                "table": null
            },
            {
                "isPreview": false,
                "header": "ОПИСАНИЕ",
                "text": "РПТ является измерительно-вычислительным устройством, выполненным на базе специализированного микропроцессора и обеспечивает:",
                "list": null,
                "table": null
            },
            {
                "isPreview": false,
                "header": null,
                "text": null,
                "list": {
                    "type": "dots",
                    "items": [
                        {
                            "text": "измерение температур и разности температур теплоносителя в подающем и обратном трубопроводах;",
                            "sublist": null
                        },
                        {
                            "text": "измерение объемного расхода и вычисление потребленного или отпущенного объема теплоносителя, массового расхода, а,также массы теплоносителя;",
                            "sublist": null
                        },
                        {
                            "text": "измерение теплового потока (мощности), количества теплоты и времени наработки;",
                            "sublist": null
                        },
                        {
                            "text": "измерение давления теплоносителя в подающем и обратном трубопроводах;",
                            "sublist": null
                        },
                        {
                            "text": "измерение и отображение на встроенном цифробуквенном жидкокристаллическом индикаторе календарной даты и времени с дискретностью 1 с;",
                            "sublist": null
                        },
                        {
                            "text": "диагностику эксплуатационных нарушений в работе РПТ;",
                            "sublist": null
                        },
                        {
                            "text": "формирование, накопление и хранение в энергонезависимой памяти архива результатов измерений и интегральных значений физических параметров.",
                            "sublist": null
                        }
                    ]
                },
                "table": null
            },
            {
                "isPreview": false,
                "header": "В архивной памяти сохраняются следующие параметры:",
                "text": null,
                "list": {
                    "type": "dots",
                    "items": [
                        {
                            "text": "просуммированные нарастающим итогом отпущенные (потребленные) количество теплоты, масса теплоносителя и время наработки РПТ, среднечасовые значения температуры и давления теплоносителя, отпущенное (потребленное) количество теплоты, масса теплоносителя и время наработки РПТ за каждый час, а также коды ошибок. Объем архива до 120 суток;",
                            "sublist": null
                        },
                        {
                            "text": "индикацию на индикаторе измеряемых и вычисляемых параметров, установок РПТ и параметров измерительных каналов и кодов ошибок;",
                            "sublist": null
                        },
                        {
                            "text": "формирование выходного аналогового сигнала постоянного тока 0...5, 0...20 или 4.. .20 мА, пропорционального одному из измеряемых или вычисляемых параметров;",
                            "sublist": null
                        },
                        {
                            "text": "передачу информации по цифровому каналу с интерфейсом RS-232C или RS-485 по запросу от ПЭВМ или HAYES-совместимого внешнего модема со скоростью 1 200 2 400, 4 800, 9 600, 19 200, 28 800, 38 400, 57 600 или 115 200 бит/с;",
                            "sublist": null
                        },
                        {
                            "text": "распечатку на ЦПУ текущей, почасовой и посуточной информации о параметрах тепло- и водоснабжения (потребления).",
                            "sublist": null
                        }
                    ]
                },
                "table": null
            },
            {
                "isPreview": false,
                "header": null,
                "text": "По заказу потребителя РПТ может быть дополнен функциями определения массы подпитки, горячего или холодного водоснабжения без расчета количества теплоты.",
                "list": null,
                "table": null
            }
        ]
};
//**************************************************************************************RPT1100
//**************************************************************************************RPT2200
const RPT2200 = {
    id: "RPT2200",
    name: "<b>РПТ-2200</b>",
    img: "/heatmeters/РПТ-2200.png",
    imgAlt: "РПТ-2200",
    description:
        [
            {
                "isPreview": true,
                "header": null,
                "text": "Регистратор-вычислитель параметров теплопотребления РПТ-2200М предназначен для сбора, обработки и представления информации от датчиков и измерительных преобразователей пункта учета потребления тепла и воды из местных и центральных систем тепло- и водоснабжения в жилищно-коммунальном хозяйстве и промышленности.",
                "list": null,
                "table": null
            },
            {
                "isPreview": false,
                "header": "",
                "text": "РПТ-2200М обладает всеми функциями тепловычислителя и может использоваться в составе комбинированных теплосчетчиков для коммерческого учета тепло- и водопотребления в закрытых и открытых системах теплоснабжения.",
                "list": null,
                "table": null
            },
            {
                "isPreview": false,
                "header": "ОПИСАНИЕРПТ-2200М обеспечивает:",
                "text": null,
                "list": {
                    "type": "dots",
                    "items": [
                        {
                            "text": "автоматическое измерение сигналов первичных преобразователей объемного расхода, давления и температуры теплоносителя в подающем и обратном трубопроводах, а также объемного расхода подпитки (для систем подключенных по независимой схеме);",
                            "sublist": null
                        },
                        {
                            "text": "отсчет календарной даты и астрономического времени; вычисление массового расхода теплоносителя в подающем и обратном трубопроводах, массового расхода подпитки, потребляемой тепловой мощности и энергии, времени наработки прибора;",
                            "sublist": null
                        },
                        {
                            "text": "диагностику состояния оборудования пункта учета и сети теплоснаюжения",
                            "sublist": null
                        },
                        {
                            "text": "накопление и хранение в энергонезависимой памяти интегральныхзначений физических параметров;",
                            "sublist": null
                        },
                        {
                            "text": "индикацию измеряемых, вычисляемых и статусных параметров на встроенном цифро-буквенном индикаторе;",
                            "sublist": null
                        },
                        {
                            "text": "распечатку на принтере или передачу в ПЭВМ текущей, почасовой и посуточной информации о параметрах тепло- и водопотребления.",
                            "sublist": null
                        }
                    ]
                },
                "table": null
            },
            {
                "isPreview": false,
                "header": "",
                "text": "Информация о параметрах тепло- и водопотребления, выводимая на печать, представляется РПТ в виде суточных сводок и периодических отчетов. Для контроля РПТ позволяет вывасти на печать текущие показания параметров.",
                "list": null,
                "table": null
            },
            {
                "isPreview": false,
                "header": null,
                "text": "Суточная сводка содержит информацию о массе теплоносителя, полученного по подающему и возвращенного по обратному трубопроводам за каждый час, среднечасовых значениях давления и температуры в подающем и обратном трубопроводах, тепловой энергии, полученной потребителем за каждый час, времени наработки прибора и его состоянии в течение каждого часа, а также интегральные значения указанных параметров, массе воды подпитки и утечки за сутки.",
                "list": null,
                "table": null
            },
            {
                "isPreview": false,
                "header": "",
                "text": "Периодический отчет формируется РПТ за заданное количество суток и содержит информацию о массе теплоносителя, полученного по подающему и возвращенного по обратному трубопроводам за каждые сутки, средесуточных значениях температуры в подающем и обратном трубопроводах, массе утечки, тепловой энергии, полученной потребителем, и времени наработки прибора в течение каждых суток, а также интегральные значения указанных параметров за заданный период времени и показания электронных интеграторов наработки, массы и тепловой энергии в начале и конце выбранного периода времени.",
                "list": null,
                "table": null
            },
            {
                "isPreview": false,
                "header": null,
                "text": "Распечатка текущих показаний включает мгновенные значения температур, давлений, объемных расходов, тепловой мощности, электронных интеграторов наработки, массы и тепловой энергии, а также параметры РПТ и узла учета.",
                "list": null,
                "table": null
            }
        ]
};
//**************************************************************************************RPT2200
//**************************************************************************************SPT961
const SPT961 = {
    id: "SPT961",
    name: "<b>СПТ 961</b>",
    img: "/heatmeters/СПТ961.png",
    imgAlt: "СПТ 961",
    description:
        [
            {
                "isPreview": true,
                "header": "Назначение и область применения",
                "text": "Тепловычислители предназначены для измерения электрических сигналов, соответствующих параметрам теплоносителя, с последующим расчетом тепловой энергии и количества теплоносителя. Модель 961.2 отличается от модели 961.1 наличием дополнительного (второго) комуникационного порта RS485, предназначенного для расширения функциональных возможностей в части увеличения числа обслуживаемых тепловых нагрузок. Тепловычислители рассчитаны на применение в составе теплосчетчиков для водяных и паровых систем теплоснабжения и иных измерительных систем, где в качестве теплоносителя используются вода, конденсат, перегретый пар либо сухой или влажный насыщенный пар. ",
                "list": null,
                "table": null
            },
            {
                "isPreview": false,
                "header": "",
                "text": "Интегрированные функциональные возможности тепловычислителя обеспечивают комплексное решение широкого круга задач: ",
                "list": null,
                "table": null
            },
            {
                "isPreview": false,
                "header": null,
                "text": null,
                "list": {
                    "type": "dots",
                    "items": [
                        {
                            "text": "коммерческий учет потребления тепловой энергии и массы воды, перегретого и насыщенного пара; ",
                            "sublist": null
                        },
                        {
                            "text": "контроль режимов теплопотребления; ",
                            "sublist": null
                        },
                        {
                            "text": "организация систем диспетчеризации и контроля потребления тепловой энергии и теплоносителя. ",
                            "sublist": null
                        }
                    ]
                },
                "table": null
            },
            {
                "isPreview": false,
                "header": "Соответствие стандартам",
                "text": "Тепловычислители соответствуют ГОСТ Р 51649, ГОСТ Р EН 1434-1, МИ 2412 и МИ 2451. ",
                "list": null,
                "table": null
            },
            {
                "isPreview": false,
                "header": "",
                "text": "В части вычисления массового расхода теплоносителя при применении метода переменного перепада давления тепловычислители соответствуют ГОСТ 8.586.(1-5) или РД 50-411, в зависимости от типа сужающего устройства: ",
                "list": null,
                "table": null
            },
            {
                "isPreview": false,
                "header": null,
                "text": null,
                "list": {
                    "type": "dots",
                    "items": [
                        {
                            "text": "диафрагма; ",
                            "sublist": null
                        },
                        {
                            "text": "износоустойчивая диафрагма; ",
                            "sublist": null
                        },
                        {
                            "text": "диафрагма с коническим входом; ",
                            "sublist": null
                        },
                        {
                            "text": "сопло ИСА1932; ",
                            "sublist": null
                        },
                        {
                            "text": "трубы Вентури. ",
                            "sublist": null
                        }
                    ]
                },
                "table": null
            },
            {
                "isPreview": false,
                "header": "Функциональные возможности",
                "text": "Тепловычислитель рассчитан на работу совместно с датчиками расхода, объема, перепада давления, давления и температуры. К тепловычислителю могут быть одновременно подключены: ",
                "list": null,
                "table": null
            },
            {
                "isPreview": false,
                "header": null,
                "text": null,
                "list": {
                    "type": "dots",
                    "items": [
                        {
                            "text": "восемь преобразователей с выходным сигналом тока 0-5, 0-20 или 4-20 мА; ",
                            "sublist": null
                        },
                        {
                            "text": "четыре преобразователя с выходным числоимпульсным или частотным сигналом 0-5 кГц; ",
                            "sublist": null
                        },
                        {
                            "text": "четыре термопреобразователя сопротивления с характеристикой 50П, 100П, 50М, 100М. ",
                            "sublist": null
                        }
                    ]
                },
                "table": null
            },
            {
                "isPreview": false,
                "header": "",
                "text": "Количество обслуживаемых трубопроводов определяется необходимостью использования тех или иных датчиков параметров теплоносителя и возможностью их физического подключения в тепловычислителю. На логическом уровне может быть описано до 12 трубопроводов, количество свободно конфигурируемых контуров теплоснабжения - до 6. ",
                "list": null,
                "table": null
            },
            {
                "isPreview": false,
                "header": "",
                "text": "Для модели 961.2 количество входов для подключения датчиков может быть увеличеноо посредством подключения к тепловычислителю одного или двух адаптеров АДС97 по дополнительному интерфейсу RS485. Адаптер АДС97 имеет 4 входа для датчиков расхода с импульсными выходными сигналами, 4 входа для датчиков различного назначения с унифицированными токовыми выходными сигналами, 4 входа для термопреобразователей сопротивления. ",
                "list": null,
                "table": null
            }
        ]
};
//**************************************************************************************SPT961
//**************************************************************************************STD 
const STD = {
    id: "STD",
    name: "<b>СТД</b>",
    img: "/heatmeters/СТД.png",
    imgAlt: "СТД",
    description:
        [
            {
                "isPreview": true,
                "header": "",
                "text": "Ультразвуковой теплосчетчик СТД (вычислитель ВТД) предназначен для измерения тепловой энергии, массы и параметров теплоносителя и регистрации теплоэнергетических параметров на узлах учета водяных систем теплоснабжения с соответствии с \u0027Правилами учета тепловой энергии и теплоносителя\u0027. ",
                "list": null,
                "table": null
            },
            {
                "isPreview": false,
                "header": "",
                "text": "В состав теплосчетчика СТД (количество и исполнения в зависимости от системы теплоснабжения) входят: ",
                "list": null,
                "table": null
            },
            {
                "isPreview": false,
                "header": null,
                "text": null,
                "list": {
                    "type": "dots",
                    "items": [
                        {
                            "text": "тепловычислитель ВТД-В;",
                            "sublist": null
                        },
                        {
                            "text": "ультразвуковые преобразователи расхода US-800;",
                            "sublist": null
                        },
                        {
                            "text": "комплекты термопреобразователей сопротивления с гильзами (типа КТПТР);",
                            "sublist": null
                        },
                        {
                            "text": "преобразователи давления (типа КРТ);",
                            "sublist": null
                        },
                        {
                            "text": "дополнительное оборудование, не являющееся средством измерения (принтер, кабели, и др).",
                            "sublist": null
                        }
                    ]
                },
                "table": null
            },
            {
                "isPreview": false,
                "header": "",
                "text": "Сигналы от преобразователей расхода, температуры, давления обрабатываются тепловычислителем ВТД-В, который обеспечивает измерение и регистрацию следующих параметров: \u2022текущие температура, давление, расход, масса, объем - по каждому узлу учета; ",
                "list": null,
                "table": null
            },
            {
                "isPreview": false,
                "header": null,
                "text": null,
                "list": {
                    "type": "dots",
                    "items": [
                        {
                            "text": "средние за каждый час и сутки температура и давление - в каждом трубопроводе;",
                            "sublist": null
                        },
                        {
                            "text": "масса (объем) учитываемой среды за каждый час, сутки, отчетный период - по каждому каналу учета;",
                            "sublist": null
                        },
                        {
                            "text": "энергия за каждый час, сутки, отчетный период;",
                            "sublist": null
                        },
                        {
                            "text": "время пуска на счет, учет перерывов питания за каждые сутки и отчетный период;",
                            "sublist": null
                        },
                        {
                            "text": "учет времени работы по каждой нештатной ситуации за отчетный период.",
                            "sublist": null
                        }
                    ]
                },
                "table": null
            },
            {
                "isPreview": false,
                "header": "",
                "text": "Текущие и архивные параметры (за 1080 часов, 63 суток) могут быть выведены на жидкокристаллический индикатор, на принтер, в персональный компьютер непосредственно или по линиям связи.  теплосчетчика СТД определяются характеристиками используемых тепловычислителей ВТД-В (обслуживание до 2-х узлов учета (отопление, ГВС) в системах тепловодоснабжения, а также для учета, дополнительно, расхода холодной воды) следующих исполнений: ",
                "list": null,
                "table": null
            },
            {
                "isPreview": false,
                "header": null,
                "text": null,
                "list": {
                    "type": "dots",
                    "items": [
                        {
                            "text": "ВТД-В (2Q2T) - возможность подключения до 2 датчиков расхода и 2 температуры;",
                            "sublist": null
                        },
                        {
                            "text": "ВТД-В (2Q2T2P) - подключение до 2 датчиков расхода, 2 температуры, 2 датчиков давления;",
                            "sublist": null
                        },
                        {
                            "text": "ВТД-В (4Q4T) - возможность подключения до 4 датчиков расхода и 4 температуры;",
                            "sublist": null
                        },
                        {
                            "text": "ВТД-В (4Q4T2P) - подключение до 4 датчиков расхода, 4 температуры, 2 датчиков давления;",
                            "sublist": null
                        },
                        {
                            "text": "ВТД-В (5Q4T2P) - для обслуживания узлов учета: отопление (под.-обр.), ГВС (2 трубопровода), учет расхода холодной воды;",
                            "sublist": null
                        },
                        {
                            "text": "ВТД-В (4Q4T4P) - Узел на источнике или 2 узла учета у потребителя.",
                            "sublist": null
                        }
                    ]
                },
                "table": null
            },
            {
                "isPreview": false,
                "header": "",
                "text": "Вычислители ВТД-В изготавливаются в пластмассовых корпусах (защита IP54). На лицевой панели устанавливается пленочная клавиатура (16 клавиш) и индикатор ЖКИ 16х2 символов (с подсветкой), обеспечивается ввод параметров настройки, вывод текущих и отчетных данных на ЖКИ, принтер, IBM PC, Notebook, накопительный пульт. ",
                "list": null,
                "table": null
            },
            {
                "isPreview": false,
                "header": "Технические характеристики теплосчетчика СТД:",
                "text": null,
                "list": null,
                "table": {
                    "columns": [
                        "Название параметра ",
                        "Значение параметра "
                    ],
                    "rows": [
                        {
                            "items": [
                                "Архивы параметров (средняя температура, давление, масса или приведенный объем, энергия за час, сутки) ",
                                "1080 часов, 63 суток по каждому каналу учета. "
                            ],
                            "isGroup": false,
                            "isGroupItem": false
                        },
                        {
                            "items": [
                                "Диаметры трубопровода ",
                                "от 15 до 1800 мм "
                            ],
                            "isGroup": false,
                            "isGroupItem": false
                        },
                        {
                            "items": [
                                "Исполнения первичных преобразователей расхода ",
                                "(Ду 15-25) муфтовый "
                            ],
                            "isGroup": false,
                            "isGroupItem": false
                        },
                        {
                            "items": [
                                "Исполнения первичных преобразователей расхода ",
                                "(Ду 32-1000) фланцевый "
                            ],
                            "isGroup": false,
                            "isGroupItem": false
                        },
                        {
                            "items": [
                                "Исполнения первичных преобразователей расхода (Ду 250-1800) ",
                                "комплекты врезки на трубопровод "
                            ],
                            "isGroup": false,
                            "isGroupItem": false
                        },
                        {
                            "items": [
                                "Длина прямолинейных участков в месте врезки (Ду 15-25) ",
                                "до ПП 0/ после ПП 0 "
                            ],
                            "isGroup": false,
                            "isGroupItem": false
                        },
                        {
                            "items": [
                                "Длина прямолинейных участков в месте врезки (Ду 32-1800) ",
                                "до ПП 10/ после ПП 3 "
                            ],
                            "isGroup": false,
                            "isGroupItem": false
                        },
                        {
                            "items": [
                                "Длина прямолинейных участков в месте врезки (Ду 100-1800 двухлучевое исполнение) ",
                                "до ПП 5/ после ПП 3 "
                            ],
                            "isGroup": false,
                            "isGroupItem": false
                        },
                        {
                            "items": [
                                "Температура теплоносителя, \u00B0С ",
                                "до \u002B150 (\u002B200 спецзаказаз) "
                            ],
                            "isGroup": false,
                            "isGroupItem": false
                        },
                        {
                            "items": [
                                "Температура окр. среды в месте врезки в трубу, \u00B0С ",
                                "от -40 до \u002B60 "
                            ],
                            "isGroup": false,
                            "isGroupItem": false
                        },
                        {
                            "items": [
                                "Температура окр. среды в месте установки электроники, \u00B0С ",
                                "от \u002B5 до \u002B50 "
                            ],
                            "isGroup": false,
                            "isGroupItem": false
                        },
                        {
                            "items": [
                                "Питание ",
                                "220 В \u002B25 / -35В, 50 Гц. "
                            ],
                            "isGroup": false,
                            "isGroupItem": false
                        }
                    ]
                }
            },
            {
                "isPreview": false,
                "header": "Технические характеристики",
                "text": null,
                "list": null,
                "table": {
                    "columns": [
                        "",
                        ""
                    ],
                    "rows": [
                        {
                            "items": [
                                "Завод изготовитель:",
                                "ООО НПФ \u00ABДИНФО\u00BB"
                            ],
                            "isGroup": false,
                            "isGroupItem": false
                        },
                        {
                            "items": [
                                "Вес (кг):",
                                "0,5"
                            ],
                            "isGroup": false,
                            "isGroupItem": false
                        },
                        {
                            "items": [
                                "Габариты",
                                "120x130x57"
                            ],
                            "isGroup": false,
                            "isGroupItem": false
                        },
                        {
                            "items": [
                                "Уровень пылевлагозашиты:",
                                "IP54"
                            ],
                            "isGroup": false,
                            "isGroupItem": false
                        },
                        {
                            "items": [
                                "Средний срок службы (лет)",
                                "12"
                            ],
                            "isGroup": false,
                            "isGroupItem": false
                        },
                        {
                            "items": [
                                "Средняя наработка на отказ (часов)",
                                "80000"
                            ],
                            "isGroup": false,
                            "isGroupItem": false
                        },
                        {
                            "items": [
                                "Межповерочный интервал (мес.): ",
                                "48"
                            ],
                            "isGroup": false,
                            "isGroupItem": false
                        }
                    ]
                }
            }
        ]
};
//**************************************************************************************STD
//**************************************************************************************SET4_TM
const SET4_TM = {
    id: "SET4_TM",
    name: "<b>СЭТ-4 ТМ</b>",
    img: "/heatmeters/СЭТ-4тм.png",
    imgAlt: "СЭТ-4 ТМ",
    description:
        [
            {
                "isPreview": true,
                "header": "НАЗНАЧЕНИЕ И ОБЛАСТЬ ПРИМЕНЕНИЯ",
                "text": "Счетчики СЭТ-4ТМ предназначены для измерения и многотарифного учета активной и реактивной электроэнергии (в том числе и с учетом потерь), ведения массивов профиля мощности нагрузки с программируемым временем интегрирования (в том числе и с учетом потерь), фиксации максимумов мощности, измерения параметров трехфазной сети и параметров качества электроэнергии.  перетоков.  х- и четырехпроводных сетях переменного тока с напряжением 3?(57,7-115)/(100-200) В или 3?(120-230)/(208-400) В, частотой (50\u00B12,5) Гц, номинальным (максимальным) током 1(2) или 5(10) А при трансформаторном подключении по току и трансформаторном или непосредственном подключении по напряжению.    ",
                "list": null,
                "table": null
            },
            {
                "isPreview": true,
                "header": null,
                "text": null,
                "list": {
                    "type": "dots",
                    "items": [
                        {
                            "text": "активную электроэнергию прямого и обратного направления, как активную электроэнергию прямого направления (учет по модулю);",
                            "sublist": null
                        },
                        {
                            "text": "реактивную электроэнергию первого и третьего квадранта, как реактивную электроэнергию прямого направления (индуктивная нагрузка);",
                            "sublist": null
                        },
                        {
                            "text": "реактивную электроэнергию четвертого и второго квадранта, как реактивную электроэнергию обратного направления (емкостная нагрузка).",
                            "sublist": null
                        }
                    ]
                },
                "table": null
            },
            {
                "isPreview": false,
                "header": null,
                "text": "НОРМАТИВНО-ПРАВОВОЕ ОБЕСПЕЧЕНИЕ",
                "list": null,
                "table": null
            },
            {
                "isPreview": false,
                "header": "Соответствие ГОСТ 12.2.091-2012, ГОСТ 31818.11-2012, ТР ТС 004/2011, ТР ТС 020/2011",
                "text": " ",
                "list": null,
                "table": null
            },
            {
                "isPreview": false,
                "header": "ТЕХНИЧЕСКИЕ ОСОБЕННОСТИ ЭЛЕКТРОСЧЕТЧИКА",
                "text": null,
                "list": {
                    "type": "dots",
                    "items": [
                        {
                            "text": "Цифровая обработка сигналов.",
                            "sublist": null
                        },
                        {
                            "text": "Расширенный диапазон по напряжению 3?(57,7-115)/(100-200) или 3?(120-230)/(208-400) В.",
                            "sublist": null
                        },
                        {
                            "text": "Улучшенные показатели надежности. Отсутствуют электролитические конденсаторы.",
                            "sublist": null
                        },
                        {
                            "text": "Резервное питание от источника переменного или постоянного тока напряжением от 100 до 265 В.",
                            "sublist": null
                        },
                        {
                            "text": "Независимые равноприоритетные каналы связи: два RS-485 и оптический интерфейс (ГОСТ Р МЭК 61107-2001) у электросчетчика СЭТ-4ТМ.03М и один RS-485 и оптический интерфейс у счетчика электроэнергии СЭТ-4ТМ.02М.",
                            "sublist": null
                        },
                        {
                            "text": "ModBus-подобный, СЭТ-4ТМ.02-совместимый протокол обмена с возможностью расширенной адресации.",
                            "sublist": null
                        },
                        {
                            "text": "Четыре конфигурируемых изолированных испытательных выхода.",
                            "sublist": null
                        },
                        {
                            "text": "Два конфигурируемых цифровых входа.",
                            "sublist": null
                        },
                        {
                            "text": "Встроенные часы реального времени с высокой точностью хода (значительно лучше 0,5 с/сутки).",
                            "sublist": null
                        }
                    ]
                },
                "table": null
            },
            {
                "isPreview": false,
                "header": "ФУНКЦИОНАЛЬНЫЕ ВОЗМОЖНОСТИ ЭЛЕКТРОСЧЕТЧИКА",
                "text": "Ведение архивов тарифицированной учтенной электроэнергии и не тарифицированной энергии с учетом потерь в линии электропередачи и силовом трансформаторе (активной, реактивной прямого и обратного направления и 4-х квадрантной реактивной – восемь каналов): ",
                "list": null,
                "table": null
            },
            {
                "isPreview": false,
                "header": null,
                "text": null,
                "list": {
                    "type": "dots",
                    "items": [
                        {
                            "text": "всего от сброса (нарастающий итог);",
                            "sublist": null
                        },
                        {
                            "text": "за текущие и предыдущие календарные сутки;",
                            "sublist": null
                        },
                        {
                            "text": "на начало текущих и предыдущих календарных суток;",
                            "sublist": null
                        },
                        {
                            "text": "за каждые предыдущие календарные сутки глубиной до 30 дней;",
                            "sublist": null
                        },
                        {
                            "text": "на начало каждых предыдущих календарных суток глубиной до 30 дней.",
                            "sublist": null
                        },
                        {
                            "text": "за текущий месяц и двенадцать предыдущих календарных месяцев;",
                            "sublist": null
                        },
                        {
                            "text": "на начало текущего месяца и двенадцати предыдущих календарных месяцев;",
                            "sublist": null
                        },
                        {
                            "text": "за текущий и предыдущий календарный год;",
                            "sublist": null
                        },
                        {
                            "text": "на начало текущего и предыдущего календарного года.",
                            "sublist": null
                        }
                    ]
                },
                "table": null
            },
            {
                "isPreview": false,
                "header": "Тарификатор:",
                "text": null,
                "list": {
                    "type": "dots",
                    "items": [
                        {
                            "text": "восемь тарифов (Т1-Т8), ",
                            "sublist": null
                        },
                        {
                            "text": "восемь типов дней (понедельник, вторник, среда, четверг, пятница, суббота, воскресение, праздник),",
                            "sublist": null
                        },
                        {
                            "text": "двенадцать сезонов (на каждый месяц года),",
                            "sublist": null
                        },
                        {
                            "text": "дискрет тарифной зоны составляет 10 минут, чередование тарифных зон в сутках до 144;",
                            "sublist": null
                        },
                        {
                            "text": "используется расписание праздничных дней и список перенесенных дней.",
                            "sublist": null
                        }
                    ]
                },
                "table": null
            },
            {
                "isPreview": false,
                "header": null,
                "text": "Ведение трех независимых массивов профиля мощности (активной, реактивной, прямого и обратного направления, в том числе и с учетом потерь):",
                "list": null,
                "table": null
            },
            {
                "isPreview": false,
                "header": null,
                "text": null,
                "list": {
                    "type": "dots",
                    "items": [
                        {
                            "text": "время интегрирования от 1 до 60 минут (без учета потерь);",
                            "sublist": null
                        },
                        {
                            "text": "время интегрирования от 1 до 30 минут (с учетом потерь);",
                            "sublist": null
                        },
                        {
                            "text": "глубина хранения каждого массива 113 суток при времени интегрирования 30 минут. ",
                            "sublist": null
                        }
                    ]
                },
                "table": null
            },
            {
                "isPreview": false,
                "header": "",
                "text": "Фиксация утренних и вечерних максимумов мощность по каждому массиву профиля мощности (активной, реактивной, прямого и обратного направления) с использованием двенадцатисезонного расписания максимумов:",
                "list": null,
                "table": null
            },
            {
                "isPreview": false,
                "header": null,
                "text": null,
                "list": {
                    "type": "dots",
                    "items": [
                        {
                            "text": "интервальных максимумов (в интервале времени между сбросами);",
                            "sublist": null
                        },
                        {
                            "text": "месячных максимумов (за текущий месяц и двенадцать предыдущих календарных месяцев).",
                            "sublist": null
                        }
                    ]
                },
                "table": null
            },
            {
                "isPreview": false,
                "header": "Измерение параметров электрической сети и вспомогательных параметров по каждой фазе и сумме фаз:",
                "text": null,
                "list": {
                    "type": "dots",
                    "items": [
                        {
                            "text": "активной, реактивной и полной мощности;",
                            "sublist": null
                        },
                        {
                            "text": "активной и реактивной мощности потерь в линии электропередачи и силовом трансформаторе;",
                            "sublist": null
                        },
                        {
                            "text": "коэффициента мощности;",
                            "sublist": null
                        },
                        {
                            "text": "частоты сети;",
                            "sublist": null
                        },
                        {
                            "text": "фазных, межфазных напряжений и напряжения прямой последовательности;",
                            "sublist": null
                        },
                        {
                            "text": "коэффициентов искажения синусоидальности кривой фазных и межфазных напряжений;",
                            "sublist": null
                        },
                        {
                            "text": "коэффициентов несимметрии напряжения по нулевой и обратной последовательностям;",
                            "sublist": null
                        },
                        {
                            "text": "тока;",
                            "sublist": null
                        },
                        {
                            "text": "коэффициентов искажения синусоидальности кривой токов;",
                            "sublist": null
                        },
                        {
                            "text": "коэффициентов несимметрии тока по нулевой и обратной последовательностям;",
                            "sublist": null
                        },
                        {
                            "text": "текущего времени, даты и температуры.",
                            "sublist": null
                        }
                    ]
                },
                "table": null
            },
            {
                "isPreview": false,
                "header": "Измерение параметров качества электроэнергии:",
                "text": null,
                "list": {
                    "type": "dots",
                    "items": [
                        {
                            "text": "установившееся отклонение фазных, межфазных напряжений, напряжения прямой последовательности и частоты сети с нормированными метрологическими характеристиками в соответствии с требованиями ГОСТ 13109-97; ",
                            "sublist": null
                        },
                        {
                            "text": "коэффициентов искажения синусоидальности кривой фазных и межфазных напряжений, коэффициентов несимметрии напряжения по нулевой и обратной последовательностям с не нормированными метрологическими характеристиками.",
                            "sublist": null
                        },
                        {
                            "text": "автоматический контроль и регистрация выхода параметров сети за установленные пределы.",
                            "sublist": null
                        }
                    ]
                },
                "table": null
            },
            {
                "isPreview": false,
                "header": null,
                "text": "Счетчики электроэнергии СЭТ-4ТМ имеют четыре независимых испытательных выхода. Каждый выход может конфигурироваться для формирования: ",
                "list": null,
                "table": null
            },
            {
                "isPreview": false,
                "header": null,
                "text": null,
                "list": {
                    "type": "dots",
                    "items": [
                        {
                            "text": "импульсов телеметрии одного из каналов учета энергии (активной, реактивной, прямого и обратного направления, и четырехквадрантной реактивной, в том числе и с учетом потерь);",
                            "sublist": null
                        },
                        {
                            "text": "сигнала превышения установленного порога мощности;",
                            "sublist": null
                        },
                        {
                            "text": "сигнала телеуправления;",
                            "sublist": null
                        },
                        {
                            "text": "сигнала контроля точности хода часов.",
                            "sublist": null
                        }
                    ]
                },
                "table": null
            },
            {
                "isPreview": false,
                "header": null,
                "text": "Счетчики электроэнергии СЭТ-4ТМ имеют два цифровых входа, каждый из которых может конфигурироваться:",
                "list": null,
                "table": null
            },
            {
                "isPreview": false,
                "header": null,
                "text": null,
                "list": {
                    "type": "dots",
                    "items": [
                        {
                            "text": "как вход для управления режимами телеметрии (А или В, только вход 1) от внешнего напряжения;",
                            "sublist": null
                        },
                        {
                            "text": "как счетный вход для счета импульсов от внешних датчиков по переднему, заднему или обоим фронтам с фиксацией в архивах (аналогично архивам учтенной электроэнергии);",
                            "sublist": null
                        },
                        {
                            "text": "как вход телесигнализации с ведением журнала измененного состояния входа.",
                            "sublist": null
                        }
                    ]
                },
                "table": null
            },
            {
                "isPreview": false,
                "header": " ",
                "text": " ",
                "list": null,
                "table": null
            },
            {
                "isPreview": false,
                "header": "ТЕХНИЧЕСКИЕ ХАРАКТЕРИСТИКИ ЭЛЕКТРОСЧЕТЧИКА",
                "text": null,
                "list": null,
                "table": {
                    "columns": [
                        "Наименование величины",
                        "Значение"
                    ],
                    "rows": [
                        {
                            "items": [
                                "Номинальное (максимальное) значение тока, А ",
                                "1(2) или 5(10)"
                            ],
                            "isGroup": false,
                            "isGroupItem": false
                        },
                        {
                            "items": [
                                "Ток чувствительности, мА",
                                "0,001Iном"
                            ],
                            "isGroup": false,
                            "isGroupItem": false
                        },
                        {
                            "items": [
                                "Номинальное значение измеряемого напряжения, В",
                                "3x(57,7-115)/(100-200) или 3х(120-230)/(208-400)"
                            ],
                            "isGroup": false,
                            "isGroupItem": false
                        },
                        {
                            "items": [
                                "Рабочий диапазон измеряемых напряжений, В",
                                "от 0,8Uном до 1,15Uном"
                            ],
                            "isGroup": false,
                            "isGroupItem": false
                        },
                        {
                            "items": [
                                "Номинальное значение напряжения резервного питания, В",
                                "230 (постоянного или переменного тока)"
                            ],
                            "isGroup": false,
                            "isGroupItem": false
                        },
                        {
                            "items": [
                                "Рабочий диапазон напряжений резервного питания, В",
                                "от 100 до 265 (постоянного или переменного тока)"
                            ],
                            "isGroup": false,
                            "isGroupItem": false
                        },
                        {
                            "items": [
                                "Номинальная частота сети, Гц",
                                "50"
                            ],
                            "isGroup": false,
                            "isGroupItem": false
                        },
                        {
                            "items": [
                                "Рабочий диапазон частот сети, Гц",
                                "от 47,5 до 52,5"
                            ],
                            "isGroup": false,
                            "isGroupItem": false
                        },
                        {
                            "items": [
                                "Класс точности при измерении в прямом и обратном направлении:\u00A0"
                            ],
                            "isGroup": false,
                            "isGroupItem": false
                        },
                        {
                            "items": [
                                "\u00A0\u00A0\u00A0активной электроэнергии",
                                "0,2 S или 0,5 S"
                            ],
                            "isGroup": false,
                            "isGroupItem": false
                        },
                        {
                            "items": [
                                "\u00A0\u00A0\u00A0реактивной электроэнергии",
                                "0,5 или 1,0"
                            ],
                            "isGroup": false,
                            "isGroupItem": false
                        },
                        {
                            "items": [
                                "Пределы допускаемой основной погрешности измерения, %:\u00A0"
                            ],
                            "isGroup": false,
                            "isGroupItem": false
                        },
                        {
                            "items": [
                                "\u00A0\u00A0\u00A0напряжения (фазного, межфазного, прямой\u00A0\u00A0\u00A0последовательности и их усредненных значений)",
                                "\u00B10,4 % в диапазоне от 0,8Uном до 1,15Uном "
                            ],
                            "isGroup": false,
                            "isGroupItem": false
                        },
                        {
                            "items": [
                                "\u00A0\u00A0\u00A0тока",
                                "\u00B10,4% при Iном?I?Iмакс при 0,01Iном?I?Iном"
                            ],
                            "isGroup": false,
                            "isGroupItem": false
                        },
                        {
                            "items": [
                                "\u00A0\u00A0\u00A0частоты",
                                "\u00B10,05 в диапазоне от 47,5 до 52,5 Гц"
                            ],
                            "isGroup": false,
                            "isGroupItem": false
                        },
                        {
                            "items": [
                                "\u00A0\u00A0\u00A0мощности активных потерь в линии и трансформаторе",
                                ""
                            ],
                            "isGroup": false,
                            "isGroupItem": false
                        },
                        {
                            "items": [
                                "\u00A0\u00A0\u00A0мощности реактивных потерь в линии и трансформаторе",
                                ""
                            ],
                            "isGroup": false,
                            "isGroupItem": false
                        },
                        {
                            "items": [
                                "Точность хода встроенных часов в нормальных условиях во включенном и выключенном состоянии, лучше, с/сутки",
                                "\u00B10,5"
                            ],
                            "isGroup": false,
                            "isGroupItem": false
                        },
                        {
                            "items": [
                                "Активная (полная) мощность, потребляемая каждой параллельной цепью напряжения, не более, Вт (ВА)\u00A0"
                            ],
                            "isGroup": false,
                            "isGroupItem": false
                        },
                        {
                            "items": [
                                "\u00A0\u00A0\u00A0Uном =3x(57,7-115)/(100-200)В",
                                "1,0 (1,5)"
                            ],
                            "isGroup": false,
                            "isGroupItem": false
                        },
                        {
                            "items": [
                                "\u00A0\u00A0\u00A0Uном =3x(120-230)/(208-400)В",
                                "1,5 (2,5)"
                            ],
                            "isGroup": false,
                            "isGroupItem": false
                        },
                        {
                            "items": [
                                "Полная мощность, потребляемая каждой последовательной цепью, не более, В\u00B7А ",
                                "0,1 "
                            ],
                            "isGroup": false,
                            "isGroupItem": false
                        },
                        {
                            "items": [
                                "Ток потребления от резервного источника питания в диапазоне напряжений от 100 до 265 В, мА:\u00A0\u00A0\u00A0от источника постоянного тока\u00A0\u00A0\u00A0от источника переменного тока ",
                                "30-1545-28"
                            ],
                            "isGroup": false,
                            "isGroupItem": false
                        },
                        {
                            "items": [
                                "Число индицируемых разрядов жидкокристаллического индикатора",
                                "8"
                            ],
                            "isGroup": false,
                            "isGroupItem": false
                        },
                        {
                            "items": [
                                "Скорость обмена информацией, бит/с:\u00A0"
                            ],
                            "isGroup": false,
                            "isGroupItem": false
                        },
                        {
                            "items": [
                                "\u00A0\u00A0\u00A0по оптическому порту",
                                "9600"
                            ],
                            "isGroup": false,
                            "isGroupItem": false
                        },
                        {
                            "items": [
                                "\u00A0\u00A0\u00A0по интерфейсам RS-485",
                                "38400, 19200, 9600, 4800, 2400, 1200, 600"
                            ],
                            "isGroup": false,
                            "isGroupItem": false
                        },
                        {
                            "items": [
                                "Диапазон значений постоянной электросчетчика СЭТ-4ТМ имп/(кВт\u00B7ч), имп/(квар\u00B7ч)",
                                "от 1250 до 800000"
                            ],
                            "isGroup": false,
                            "isGroupItem": false
                        },
                        {
                            "items": [
                                "Сохранность данных при прерываниях питания, лет:"
                            ],
                            "isGroup": false,
                            "isGroupItem": false
                        },
                        {
                            "items": [
                                "\u00A0\u00A0\u00A0информации",
                                "более 40"
                            ],
                            "isGroup": false,
                            "isGroupItem": false
                        },
                        {
                            "items": [
                                "\u00A0\u00A0\u00A0внутренних часов",
                                "не менее 10 (питание от литиевой батареи)"
                            ],
                            "isGroup": false,
                            "isGroupItem": false
                        },
                        {
                            "items": [
                                "Защита информации",
                                "два уровня доступа и аппаратная защита памяти метрологических коэффициентов"
                            ],
                            "isGroup": false,
                            "isGroupItem": false
                        },
                        {
                            "items": [
                                "Самодиагностика",
                                "циклическая, непрерывная"
                            ],
                            "isGroup": false,
                            "isGroupItem": false
                        },
                        {
                            "items": [
                                "Рабочие условия эксплуатации:\u00A0"
                            ],
                            "isGroup": false,
                            "isGroupItem": false
                        },
                        {
                            "items": [
                                "\u00A0\u00A0\u00A0температура окружающего воздуха, \u00B0С",
                                "от -40 до \u002B60"
                            ],
                            "isGroup": false,
                            "isGroupItem": false
                        },
                        {
                            "items": [
                                "\u00A0\u00A0\u00A0относительная влажность, %",
                                "90 % при 30 \u00B0С"
                            ],
                            "isGroup": false,
                            "isGroupItem": false
                        },
                        {
                            "items": [
                                "\u00A0\u00A0\u00A0давление, кПа (мм. рт. ст.)",
                                "от 70 до 106,7 (от 537 до 800)"
                            ],
                            "isGroup": false,
                            "isGroupItem": false
                        },
                        {
                            "items": [
                                "Межповерочный интервал, лет",
                                "16"
                            ],
                            "isGroup": false,
                            "isGroupItem": false
                        },
                        {
                            "items": [
                                "Гарантийный срок эксплуатации, месяцев",
                                "60"
                            ],
                            "isGroup": false,
                            "isGroupItem": false
                        },
                        {
                            "items": [
                                "Средняя наработка счетчика электроэнергии СЭТ-4ТМ на отказ, час",
                                "140000"
                            ],
                            "isGroup": false,
                            "isGroupItem": false
                        },
                        {
                            "items": [
                                "Средний срок службы, лет",
                                "30"
                            ],
                            "isGroup": false,
                            "isGroupItem": false
                        },
                        {
                            "items": [
                                "Масса счетчика электроэнергии СЭТ-4ТМ, кг",
                                "1,6"
                            ],
                            "isGroup": false,
                            "isGroupItem": false
                        },
                        {
                            "items": [
                                "Габаритные размеры электросчетчика СЭТ-4ТМ, мм",
                                "330х170х80,2"
                            ],
                            "isGroup": false,
                            "isGroupItem": false
                        }
                    ]
                }
            }
        ]
};
//**************************************************************************************SET4_TM
//**************************************************************************************TARAN_T
const TARAN_T = {
    id: "TARAN_T",
    name: "<b>Таран-Т</b>",
    img: "/heatmeters/Таран-Т.png",
    imgAlt: "Таран-Т",
    description:
        [
            {
                "isPreview": true,
                "header": "",
                "text": "Теплосчетчики \u0022ТАРАН-Т\u0022 (далее ТС) предназначены для измерения и учета количества теплоты и теплоносителя.",
                "list": null,
                "table": null
            },
            {
                "isPreview": true,
                "header": "",
                "text": "Область применения - объекты промтеплоэнергетики, предприятия тепловых сетей, объекты теплопотребления промышленного и бытового назначения, в том числе для целей коммерческого учета.",
                "list": null,
                "table": null
            },
            {
                "isPreview": false,
                "header": "ОПИСАНИЕ",
                "text": "Принцип действия теплосчетчика основан на вычислении тепловой мощности и количества теплоты по величине расхода жидкости, разности ее температур в прямом и обратном трубопроводах теплосистемы и интервалу времени измерения.",
                "list": null,
                "table": null
            },
            {
                "isPreview": false,
                "header": "",
                "text": "Конструктивно ТС может состоять из одного или нескольких (до 32) первичных преобразователей расхода ТАРАН-Т/До (далее ППР), двух или более (до 32) термоэлектрических преобразователей градуировки ХА, либо платиновых термометров сопротивления ЮОП (ТАРАН-Т/Дт), двух или более преобразователей давления, соответствующего количества усилителей-нормопреобразователей ТАРАН-Т/НП (4 расходных канала и 4 температурных канала) и одного тепловычислителя. При максимальной комплектации с его помощью можно осуществлять контроль за потреблением теплоэнергии и всеми измеряемыми и вычисляемыми параметрами в восьми системах теплоснабжения открытого типа.",
                "list": null,
                "table": null
            },
            {
                "isPreview": false,
                "header": "",
                "text": "ППР является комбинированным прибором. Принцип действия его основан на измерении частоты отрыва вихрей от турбулизатора, выполненного в виде трапецеидальной призмы, помещенного в поток жидкости, протекающей по трубопроводу. Частота следования вихрей по каналу расходомера прямо пропорциональна расходу жидкости, статическая характеристика преобразования расходомера описывается линейной функцией.",
                "list": null,
                "table": null
            },
            {
                "isPreview": false,
                "header": "",
                "text": "Преобразование гидродинамических вихрей в электрический сигнал в ППР осуществляется с помощью магнитной системы на постоянных магнитах и пары потенциальных электродов (токосъемников). Турбулизатор изготавливается из нержавеющей стали, острые кромки турбулизатора для увеличения долговечности прибора притуплены.",
                "list": null,
                "table": null
            },
            {
                "isPreview": false,
                "header": "",
                "text": "ППР могут устанавливаться горизонтально, вертикально и под любым углом к горизонту. Рекомендуемые прямые участки трубопроводов, необходимые для стабилизации расхода в канале расходомера: до преобразователя - 5 Dy, после преобразователя - 2 \u00A3)у(отсчет от продольной оси турбулизатора).",
                "list": null,
                "table": null
            },
            {
                "isPreview": false,
                "header": "",
                "text": "ППР работает при кинематической вязкости жидкости не более 5\u0022 10\u0022 м /с, диапазон перекрываемых расходов Gmax/Gmin = 120:1, диапазон измеряемых температур (0-f200)\u00B0C, диапазон измеряемых давлений (0 2,5) МПа.",
                "list": null,
                "table": null
            },
            {
                "isPreview": false,
                "header": "",
                "text": "Термопреобразователи служат для измерения температур в подающем и обратном трубопроводах и разности этих температур.",
                "list": null,
                "table": null
            },
            {
                "isPreview": false,
                "header": "Функции, выполняемые тепловычислителем:",
                "text": null,
                "list": {
                    "type": "dots",
                    "items": [
                        {
                            "text": "сбор и первичная обработка сигналов от ППР и температуры;",
                            "sublist": null
                        },
                        {
                            "text": "определение характеристик потока жидкости и температуры рабочей среды с применением методов амплитудного и спектрального анализа;",
                            "sublist": null
                        },
                        {
                            "text": "вычисление интегральных характеристик (количества теплоты и объема прошедшей жидкости);",
                            "sublist": null
                        },
                        {
                            "text": "отображение результатов измерений на жидкокристаллическом дисплее;",
                            "sublist": null
                        },
                        {
                            "text": "накопление информации во внутренней энергонезависимой памяти контроллера с возможностью последующей перезаписи на гибкий диск, вывода на принтер или передачи на центральный компьютер по линии связи в одном из стандартов - RS-232-C (до 18 м), RS-422 или RS-485 (до 1200 м). Глубина архивации не менее 60 суток;",
                            "sublist": null
                        },
                        {
                            "text": "формирование управляющих воздействий в виде аналоговых сигналов, цифровых сигналов и дискретных сигналов типа \u0022сухой контакт\u0022;",
                            "sublist": null
                        }
                    ]
                },
                "table": null
            }
        ]
};
//**************************************************************************************TARAN_T
//**************************************************************************************TEROSS
const TEROSS = {
    id: "TEROSS",
    name: "<b>ТеРосс</b>",
    img: "/heatmeters/ТеРосс.png",
    imgAlt: "ТеРосс",
    description:
        [
            {
                "isPreview": true,
                "header": "Теплосчетчик ТеРосс-ТМ Ду10-300",
                "text": "Теплосчетчик ТеРосс-ТМ Ду10-300 электромагнитный многофункциональный многоканальный модульного исполнения c измерительными преобразователями расхода, давления, термопреобразователями и вычислительным устройством, соединенных между собой линиями связи, предназначен для обеспечения измерения, учета и регистрации тепловой энергии, расхода, объема, массы и других параметров теплоносителя в форме, удобной для реализации взаимных расчетов между потребителем и поставщиком тепла.",
                "list": null,
                "table": null
            },
            {
                "isPreview": false,
                "header": "Область применения теплосчетчика ТеРосс-ТМ:",
                "text": "",
                "list": null,
                "table": null
            },
            {
                "isPreview": false,
                "header": "",
                "text": "Преимущества теплосчётчика ТеРосс-ТМ.",
                "list": null,
                "table": null
            },
            {
                "isPreview": false,
                "header": "\u2014 Многопоточный. Поддерживает 4 тепловые системы, можно подключить до 8 расходомеров.",
                "text": " Выполнен по цифровым технологиям. Вся информация передается полностью (без искажений), с большей надежностью, без потерь.  Мультисистемный. Во время эксплуатации возможно расширение количества тепловых систем путем перепрограммирования вычислителя.",
                "list": null,
                "table": null
            },
            {
                "isPreview": false,
                "header": "",
                "text": "ТеРосс-ТМ стал лауреатом выставки \u00ABТочные измерения \u2014 основа качества и безопасности\u00BB, получил всероссийский ",
                "list": null,
                "table": null
            },
            {
                "isPreview": false,
                "header": "Преимущества теплосчетчика ТеРосс-ТМ",
                "text": "1. Удобство монтажа: антивандальное исполнение вычислительного устройства – корпус ТеРосс-В выполнен в металлическом корпусе, закрывается на ключ, имеет габаритные размеры – 22 х 18 х 10 см. В вычислительном устройстве уже размещены блок питания, автоматы защиты. В дополнительном монтажном щите необходимости нет. двухстрочный символьный дисплей в 24 символа, управление осуществляется с помощью шести кнопок. Одновременно на дисплее можно увидеть \u00ABрасход по подаче\u00BB, \u00ABрасход по обратке\u00BB, \u00ABподпиточный расход\u00BB, также ТеРосс-В показывает не только время работы, но и время не работы, с дисплея также можно посмотреть архив и многое другое.  Мультисистемный. Возможна переконфигурация тепловых систем с вычислительного устройства на объекте, модернизация теплосчетчика – увеличение количества тепловых систем до четырех без установки дополнительного вычислительного устройства в процессе эксплуатации теплосчетчика.  Ду 15 до Ду 300.  Межповерочный интервал 4 года, при продаже первичная поверка – ФГУ \u00ABРостест-Москва\u00BB.   Глубина архива: почасового \u2014 60 суток; посуточного \u2014 12 месяцев; помесячного \u2014 5 лет, погодового \u2014 12 лет.  Имеется возможность в последствии \u00ABобвязать\u00BB все приборы в одну систему диспетчеризации, которая позволит вести реальный мониторинг (реальное просматривание состояния объекта, сведения баланса, предсказывание аварийных ситуаций и т.п.) на основе сети ETERNЕT, GSM-модемов, телефонных модемов, радиомодемов. Демо версия, обслуживает до 4 ВУ).",
                "list": null,
                "table": null
            },
            {
                "isPreview": false,
                "header": "Технические характеристики",
                "text": null,
                "list": null,
                "table": {
                    "columns": [
                        "",
                        ""
                    ],
                    "rows": [
                        {
                            "items": [
                                "Завод изготовитель:",
                                "ООО \u00ABТехно-Терм\u00BB"
                            ],
                            "isGroup": false,
                            "isGroupItem": false
                        },
                        {
                            "items": [
                                "Уровень пылевлагозашиты:",
                                "IP65"
                            ],
                            "isGroup": false,
                            "isGroupItem": false
                        },
                        {
                            "items": [
                                "Средний срок службы (лет)",
                                "12"
                            ],
                            "isGroup": false,
                            "isGroupItem": false
                        },
                        {
                            "items": [
                                "Средняя наработка на отказ (часов)",
                                "20000"
                            ],
                            "isGroup": false,
                            "isGroupItem": false
                        },
                        {
                            "items": [
                                "Межповерочный интервал (мес.): ",
                                "48"
                            ],
                            "isGroup": false,
                            "isGroupItem": false
                        },
                        {
                            "items": [
                                "Гарантийный срок (мес.): ",
                                "18"
                            ],
                            "isGroup": false,
                            "isGroupItem": false
                        }
                    ]
                }
            }
        ]
};
//**************************************************************************************TEROSS
//**************************************************************************************TEKON_17
const TEKON_17 = {
    id: "TEKON_17",
    name: "<b>Тэкон-17</b>",
    img: "/heatmeters/Тэкон-17_1.png",
    imgAlt: "Тэкон-17",
    description:
        [
            {
                "isPreview": true,
                "header": "",
                "text": "Теплоэнергоконтроллер ТЭКОН-17 - многофункциональный вторичный прибор, совмещающий в себе функции многоканального регистратора, счетчика, тепловычислителя и контроллера.",
                "list": null,
                "table": null
            },
            {
                "isPreview": false,
                "header": "Предназначен для комплексного решения следующих задач:",
                "text": null,
                "list": {
                    "type": "dots",
                    "items": [
                        {
                            "text": "коммерческий учет энергоносителей с помощью любых типов датчиков расхода, перепада давлений, абсолютного и избыточного давления, температуры;",
                            "sublist": null
                        },
                        {
                            "text": "контроль состояния оборудования, положения исполнительных механизмов с помощью датчиков типа \u0022сухой контакт\u0022;",
                            "sublist": null
                        },
                        {
                            "text": "автоматическое регулирование заданных параметров;",
                            "sublist": null
                        },
                        {
                            "text": "автоматическое управление исполнительными механизмами (включить - выключить) по любым заданным алгоритмам - по спецзаказу;",
                            "sublist": null
                        },
                        {
                            "text": "вывод любых измеренных и расчетных параметров на показывающие или контрольно-самопишущие приборы;",
                            "sublist": null
                        },
                        {
                            "text": "архивирование (хранение в памяти) учетных параметров;",
                            "sublist": null
                        },
                        {
                            "text": "теледиспетчеризация - вывод на персональные ЭВМ диспетчерских пунктов всей информации об объекте;",
                            "sublist": null
                        },
                        {
                            "text": "телеуправление исполнительными механизмами по команде оператора.",
                            "sublist": null
                        }
                    ]
                },
                "table": null
            },
            {
                "isPreview": false,
                "header": "",
                "text": "Может применяться для технологического учета природного газа, сжатого воздуха, кислорода, СО2 в комплекте с многопараметрическими датчиками Метран-335, Метран-336.",
                "list": null,
                "table": null
            },
            {
                "isPreview": false,
                "header": "",
                "text": "Может применяться для технологического учета природного газа, сжатого воздуха, кислорода, СО2 в комплекте с многопараметрическими датчиками Метран-335, Метран-336.",
                "list": null,
                "table": null
            },
            {
                "isPreview": false,
                "header": " Энергоносители, контролируемые:",
                "text": null,
                "list": {
                    "type": "dots",
                    "items": [
                        {
                            "text": "измерением методом переменного перепада давлений на сужающем устройстве: вода, пар перегретый, пар насыщенный, природный газ, сжатый воздух, СО2, О2 технические газы с заданными термодинамическими характеристиками;",
                            "sublist": null
                        },
                        {
                            "text": "измерением расходомерами и счетчиками: любые энергоносители (вода, пар, нефть, электроэнергия, бензин, другие жидкости и газы)",
                            "sublist": null
                        },
                        {
                            "text": "Количество обслуживаемых независимых трубопроводов - от 1 до 16",
                            "sublist": null
                        },
                        {
                            "text": "Количество подключаемых измерительных преобразователей (датчиков) - до 64",
                            "sublist": null
                        },
                        {
                            "text": "Количество выходных сигналов:",
                            "sublist": null
                        },
                        {
                            "text": "токовых 0-5, 0-20, 4-20 мА - до 8;",
                            "sublist": null
                        },
                        {
                            "text": "дискретных управления/индикации - до 64",
                            "sublist": null
                        },
                        {
                            "text": "Встроенные законы автоматического управления и регулирования",
                            "sublist": null
                        },
                        {
                            "text": "Блочно-модульная безызбыточная расширяемая архитектура",
                            "sublist": null
                        },
                        {
                            "text": "Связь с ЭВМ диспетчерских пунктов",
                            "sublist": null
                        },
                        {
                            "text": "Вывод информации на принтер или регистратор информации",
                            "sublist": null
                        },
                        {
                            "text": "Класс точности 0,1",
                            "sublist": null
                        },
                        {
                            "text": "Внесен в Госреестр средств измерений под \u211620812-07.Сертификат Госстандарта \u21169495",
                            "sublist": null
                        }
                    ]
                },
                "table": null
            },
            {
                "isPreview": false,
                "header": "Технические характеристики",
                "text": null,
                "list": null,
                "table": {
                    "columns": [
                        "",
                        ""
                    ],
                    "rows": [
                        {
                            "items": [
                                "Завод изготовитель:",
                                "Инженерно-внедренческое предприятие \u00ABКрейт\u00BB"
                            ],
                            "isGroup": false,
                            "isGroupItem": false
                        },
                        {
                            "items": [
                                "Вес (кг):",
                                "6,5"
                            ],
                            "isGroup": false,
                            "isGroupItem": false
                        },
                        {
                            "items": [
                                "Габариты",
                                "310х225х130"
                            ],
                            "isGroup": false,
                            "isGroupItem": false
                        },
                        {
                            "items": [
                                "Уровень пылевлагозашиты:",
                                "IP20"
                            ],
                            "isGroup": false,
                            "isGroupItem": false
                        },
                        {
                            "items": [
                                "Средний срок службы (лет)",
                                "12"
                            ],
                            "isGroup": false,
                            "isGroupItem": false
                        },
                        {
                            "items": [
                                "Средняя наработка на отказ (часов)",
                                "25000"
                            ],
                            "isGroup": false,
                            "isGroupItem": false
                        },
                        {
                            "items": [
                                "Межповерочный интервал (мес.): ",
                                "36"
                            ],
                            "isGroup": false,
                            "isGroupItem": false
                        },
                        {
                            "items": [
                                "Гарантийный срок (мес.): ",
                                "18"
                            ],
                            "isGroup": false,
                            "isGroupItem": false
                        }
                    ]
                }
            }
        ]
};
//**************************************************************************************TEKON_17
//**************************************************************************************TEM104
const TEM104 = {
    id: "TEM104",
    name: "<b>ТЭМ-104</b>",
    img: "/heatmeters/тэм104.png",
    imgAlt: "ТЭМ-104",
    description:
        [
            {
                "isPreview": true,
                "header": "",
                "text": "Теплосчетчик\u00A0электромагнитный ТЭМ-104\u00A0предназначен для измерения и регистрации с целью коммерческого и технологического учета значений потребленного (отпущенного) количества теплоты (тепловой энергии), теплоносителя и других параметров систем теплоснабжения и горячего водоснабжения, а также для организации информационных сетей сбора данных.",
                "list": null,
                "table": null
            },
            {
                "isPreview": false,
                "header": "",
                "text": "Области применения ТЭМ-104: предприятия тепловых сетей, тепловые пункты жилых, общественных и производственных зданий, центральные тепловые пункты, тепловые сети объектов бытового назначения, источники теплоты.",
                "list": null,
                "table": null
            },
            {
                "isPreview": false,
                "header": "",
                "text": "Конструктивно теплосчетчик ТЭМ-104 представляет собой измерительно-вычислительный блок (ИВБ) и подключаемые к нему измерительные преобразователи:",
                "list": null,
                "table": null
            },
            {
                "isPreview": false,
                "header": "",
                "text": "\u2014 Расхода теплоносителя (первичный преобразователь расхода \u2014 ППР, измерительный преобразователь расхода с нормированным частотным или импульсным выходным сигналом \u2014 ИП); термопреобразователь сопротивления \u2014 ТС); ",
                "list": null,
                "table": null
            },
            {
                "isPreview": false,
                "header": "",
                "text": "Число систем, по которым теплосчетчик ТЭМ-104 позволяет одновременно вести учет – от одной до четырех. Схема учета для каждой из них устанавливается пользователем в режиме \u00ABКонфигурация\u00BB до постановки прибора на коммерческий учет.",
                "list": null,
                "table": null
            },
            {
                "isPreview": false,
                "header": "",
                "text": "Теплосчетчик ТЭМ-104 выпускается в четырех типовых исполнениях с различным количеством измерительных каналов:",
                "list": null,
                "table": null
            },
            {
                "isPreview": false,
                "header": null,
                "text": null,
                "list": null,
                "table": {
                    "columns": [
                        "ТЭМ-104/1",
                        "1",
                        "0",
                        "2",
                        "2"
                    ],
                    "rows": []
                }
            },
            {
                "isPreview": false,
                "header": "",
                "text": "Примечания: Gинд – индукционные каналы измерения расхода; Gчаст – частотно-импульсные каналы измерения расхода; Т – каналы измерения температуры; Р – каналы измерения давления.",
                "list": null,
                "table": null
            },
            {
                "isPreview": false,
                "header": "",
                "text": "Теплосчетчик имеет стандартные последовательные интерфейсы RS-232С и гальваноразвязанный RS-485, через которые производится обмен данными с прибором. Теплосчетчик имеет стандартный LPT-порт для подключения EPSON совместимых принтеров.",
                "list": null,
                "table": null
            },
            {
                "isPreview": false,
                "header": "Теплосчетчик ТЭМ-104 обеспечивает для каждой системы:",
                "text": "Измерение и индикацию:",
                "list": null,
                "table": null
            },
            {
                "isPreview": false,
                "header": "",
                "text": "\u2014 текущих значений объемного Gv [м3/ч] и массового Gм [т/ч] расходов теплоносителя в трубопроводах, на которых установлены ИП (с частотным выходным сигналом) или ППР; t [\u00B0С] теплоносителя в трубопроводах, на которых установлены ТС; ",
                "list": null,
                "table": null
            },
            {
                "isPreview": false,
                "header": "",
                "text": "Вычисление и индикацию: текущей разности температур dt [\u00B0С] между подающим и обратным трубопроводами;",
                "list": null,
                "table": null
            },
            {
                "isPreview": false,
                "header": null,
                "text": "Вычисление, индикацию и накопление с нарастающим итогом:",
                "list": null,
                "table": null
            },
            {
                "isPreview": false,
                "header": "ч:мин];",
                "text": "",
                "list": null,
                "table": null
            },
            {
                "isPreview": false,
                "header": null,
                "text": "Регистрацию:",
                "list": null,
                "table": null
            },
            {
                "isPreview": false,
                "header": "Тош прибора при наличии технической неисправности (ТН) в [ч:мин];",
                "text": " времени работы (Т:dt, Т:G, Т:G-) по каждой нештатной ситуации (НС) [ч:мин].",
                "list": null,
                "table": null
            },
            {
                "isPreview": false,
                "header": null,
                "text": "Глубина архива регистрируемых параметров ТЭМ-104:",
                "list": null,
                "table": null
            },
            {
                "isPreview": false,
                "header": "\u2014 часовых данных – 1536 (64 суток);",
                "text": " ",
                "list": null,
                "table": null
            },
            {
                "isPreview": false,
                "header": "",
                "text": "Вычислитель теплосчетчика ТЭМ-104 выдает информацию из архива данных по запросам от внешних устройств (компьютер, контроллер АСУ и т.д.) Возможен просмотр архива данных на ЖКИ теплосчетчика и вывод его на печать.",
                "list": null,
                "table": null
            },
            {
                "isPreview": false,
                "header": "",
                "text": "Теплосчетчик ТЭМ-104 осуществляет самодиагностику при включении в сеть, а также отслеживает обрывы и короткие замыкания в цепи датчиков температуры и давления с выводом на экран символа ТН (\u00ABНеиспр. канала t.\u00BB, \u00ABНеиспр. канала p.\u00BB). В случае возникновения ТН счет с накоплением останавливается.",
                "list": null,
                "table": null
            },
            {
                "isPreview": false,
                "header": "Технические характеристики",
                "text": null,
                "list": null,
                "table": {
                    "columns": [
                        "",
                        ""
                    ],
                    "rows": [
                        {
                            "items": [
                                "Завод изготовитель:",
                                "СООО \u00ABАРВАС\u00BB"
                            ],
                            "isGroup": false,
                            "isGroupItem": false
                        },
                        {
                            "items": [
                                "Вес (кг):",
                                "2"
                            ],
                            "isGroup": false,
                            "isGroupItem": false
                        },
                        {
                            "items": [
                                "Габариты",
                                "204x168x95"
                            ],
                            "isGroup": false,
                            "isGroupItem": false
                        },
                        {
                            "items": [
                                "Уровень пылевлагозашиты:",
                                "IP54"
                            ],
                            "isGroup": false,
                            "isGroupItem": false
                        },
                        {
                            "items": [
                                "Средний срок службы (лет)",
                                "10"
                            ],
                            "isGroup": false,
                            "isGroupItem": false
                        },
                        {
                            "items": [
                                "Средняя наработка на отказ (часов)",
                                "20000"
                            ],
                            "isGroup": false,
                            "isGroupItem": false
                        },
                        {
                            "items": [
                                "Межповерочный интервал (мес.): ",
                                "48"
                            ],
                            "isGroup": false,
                            "isGroupItem": false
                        }
                    ]
                }
            }
        ]
};
//**************************************************************************************TEM104
//**************************************************************************************UVP280
const UVP280 = {
    id: "UVP280",
    name: "<b>УВП 280</b>",
    img: "/heatmeters/УВП280.png",
    imgAlt: "УВП 280",
    description:
        [
            {
                "isPreview": true,
                "header": "Назначение",
                "text": "Вычислители УВП-280 предназначены для измерений выходных электрических сигналов от преобразователей расхода, температуры, давления, разности давлений, влагосодержания, плотности, вязкости, калорийности, счетчиков электрической энергии, их преобразований в значения физических величин и вычислений расхода и количества воды, пара, товарной и сырой нефти, нефтепродуктов, газов, количества тепловой и электрической энергии.",
                "list": null,
                "table": null
            },
            {
                "isPreview": false,
                "header": "Описание",
                "text": "Принцип работы вычислителей состоит в измерении сигналов, поступающих от первичных преобразователей расхода, температуры, давления, разности давлений, их преобразовании в значения физических величин и вычисления расхода, количества среды и количества тепловой энергии.",
                "list": null,
                "table": null
            },
            {
                "isPreview": false,
                "header": null,
                "text": "Вычислители УВП-280 имеют две модификации УВП-280А.01 и УВП-280Б.01. Модификации вычислителей УВП-280 отличаются конструктивным исполнением и количеством входов для подключения первичных преобразователей.",
                "list": null,
                "table": null
            },
            {
                "isPreview": false,
                "header": null,
                "text": "В модификации вычислителя УВП-280А.01 БВ и ПИК находятся в одном корпусе. В модификации вычислителя УВП-280Б.01 БВ и ПИК выполнены в отдельных корпусах, при этом блок ПИК выпускается в корпусе под названием ПИК3.01. Вычислители УВП-280Б.01 могут состоять только из БВ. Максимальное количество блоков ПИК3.01, подключаемых к одному БВ, равно четырем. Вычислители УВП-280А.01 и блоки БВ и ПИК3.01 вычислителей УВП-280Б.01 изготавливаются в пластмассовых корпусах для настенного монтажа или монтажа на DIN-рейку. Кроме этого, БВ может изготавливаться в конструктивном варианте для щитового монтажа в шкаф.",
                "list": null,
                "table": null
            },
            {
                "isPreview": false,
                "header": "К вычислителям УВП-280А.01 и УВП-280Б.01 может также подключаться контроллер КР-HART.",
                "text": "По результатам измерений выходных электрических сигналов от первичных преобразователей вычислители УВП-280 проводят вычисления:",
                "list": null,
                "table": null
            },
            {
                "isPreview": false,
                "header": "",
                "text": "- \u00A0\u00A0\u00A0расхода и количества измеряемой среды при применении стандартных сужающих устройств по ГОСТ 8.586.2-05, ГОСТ 8.586.3-05 (диафрагмы с угловым, фланцевым, трехрадиусным способами отбора давления, сопла ISA1932, сопла Вентури) и МИ 3152-08 (диафрагмы с угловым способом отбора давления, сопла ISA1932);",
                "list": null,
                "table": null
            },
            {
                "isPreview": false,
                "header": "",
                "text": "- \u00A0\u00A0\u00A0расхода и количества измеряемой среды при применении диафрагм серий \u201CRose-mount 405\u201D и \u201CRosemount 1595\u201D;",
                "list": null,
                "table": null
            },
            {
                "isPreview": false,
                "header": "",
                "text": "- \u00A0\u00A0\u00A0расхода и количества измеряемой среды при применении осредняющих напорных трубок ANNUBAR и ITABAR;",
                "list": null,
                "table": null
            },
            {
                "isPreview": false,
                "header": null,
                "text": "- \u00A0\u00A0\u00A0расхода и количества измеряемой среды при применении преобразователей расхода с частотным и токовым выходными сигналами, преобразователей объема (массы) с числоимпульсным выходным сигналом, преобразователей с цифровым выходом;",
                "list": null,
                "table": null
            },
            {
                "isPreview": false,
                "header": "- \u00A0\u00A0\u00A0массы нефти и нефтепродуктов по ГОСТ Р 8.595-04, ГОСТ Р 8.615-05 и МИ 2693-01;",
                "text": "- \u00A0\u00A0\u00A0плотности жидкостей при применении преобразователей плотности жидкости измерительных 7835;",
                "list": null,
                "table": null
            },
            {
                "isPreview": false,
                "header": null,
                "text": "- \u00A0\u00A0\u00A0тепловой энергии и тепловой мощности по каждому трубопроводу, а также в открытых и закрытых системах теплоснабжения в соответствии с МИ 2412-97 и МИ 2451-98;",
                "list": null,
                "table": null
            },
            {
                "isPreview": false,
                "header": "- \u00A0\u00A0\u00A0объема газов при стандартных условиях по ГОСТ 2939-63;",
                "text": "- \u00A0\u00A0\u00A0количества электрической энергии при подключении счетчиков электрической энергии с импульсным выходом.",
                "list": null,
                "table": null
            },
            {
                "isPreview": false,
                "header": "Вычислители УВП-280 обеспечивают вычисление теплофизических свойств:",
                "text": "- \u00A0\u00A0\u00A0природного газа по ГОСТ 30319.1-96, ГОСТ 30319.2-96 (NX19 мод, GERG-91 мод) и ГОСТ Р 8.662-09;",
                "list": null,
                "table": null
            },
            {
                "isPreview": false,
                "header": "- \u00A0\u00A0\u00A0сухого воздуха по ГСССД МР 112-03;",
                "text": "- \u00A0\u00A0\u00A0влажного нефтяного газа по ГСССД МР 113-03;",
                "list": null,
                "table": null
            },
            {
                "isPreview": false,
                "header": "- \u00A0\u00A0\u00A0умеренно-сжатых газовых смесей по ГСССД МР 118-05;",
                "text": "- \u00A0\u00A0\u00A0товарной нефти и нефтепродуктов по Р 50.2.076-2010;",
                "list": null,
                "table": null
            },
            {
                "isPreview": false,
                "header": "- \u00A0\u00A0\u00A0воды, перегретого и сухого насыщенного пара по ГСССД МР 147-08;",
                "text": "- \u00A0\u00A0\u00A0чистых газов (азота, ацетилена, кислорода, диоксида углерода, аммиака, аргона и водорода) по ГСССД МР 134-07.",
                "list": null,
                "table": null
            },
            {
                "isPreview": false,
                "header": "Кроме этого, вычислители УВП-280 обеспечивают:",
                "text": "- \u00A0\u00A0\u00A0программирование схемы подсоединения первичных преобразователей к конкретным входам вычислителя УВП-280, настройку карты параметров трубопроводов, вывод текущих параметров и накопленных архивов на принтер и экран компьютера по запросу оператора через интерфейсы USB и Ethernet при помощи программы локального пульта;",
                "list": null,
                "table": null
            },
            {
                "isPreview": false,
                "header": null,
                "text": "- \u00A0\u00A0\u00A0хранение часовых, суточных и минутных архивов для измеренных и вычисленных параметров, а также архива нештатных ситуаций по 10-ти трубопроводам с глубиной не менее 300 суток;",
                "list": null,
                "table": null
            },
            {
                "isPreview": false,
                "header": "",
                "text": "- \u00A0\u00A0\u00A0передачу архивных и текущих параметров в системы верхнего уровня по открытым и собственным протоколам связи через интерфейсы Ethernet, RS-232 и RS-485;",
                "list": null,
                "table": null
            },
            {
                "isPreview": false,
                "header": "",
                "text": "- \u00A0\u00A0\u00A0объединение в локальную сеть с целью совместного использования измеряемых и рассчитываемых параметров через интерфейсы Ethernet, RS-232 и RS-485;",
                "list": null,
                "table": null
            },
            {
                "isPreview": false,
                "header": "",
                "text": "- \u00A0\u00A0\u00A0подключение к локальным и глобальным сетям через порт Ethernet, либо через внешний GSM/GPRS-модем, подключаемый к порту RS-232;",
                "list": null,
                "table": null
            },
            {
                "isPreview": false,
                "header": null,
                "text": "- \u00A0\u00A0\u00A0хранение накопленной информации и работу часов реального времени в течение 5-ти лет при отключении сетевого питания;",
                "list": null,
                "table": null
            },
            {
                "isPreview": false,
                "header": "",
                "text": "- \u00A0\u00A0\u00A0работу с программой автоматического формирования базы архивных данных на компьютере через интерфейс Ethernet или GSM/GPRS;",
                "list": null,
                "table": null
            },
            {
                "isPreview": false,
                "header": null,
                "text": "- проведение контроля метрологических характеристик рабочих преобразователей расхода по контрольному преобразователю расхода при работе в составе систем для измерений массы нефти или нефтепродуктов.",
                "list": null,
                "table": null
            },
            {
                "isPreview": false,
                "header": "",
                "text": "Вычислитель соответствует требованиям ГОСТ Р 8.733-2011, ГОСТ Р 8.740-2011 к вычислительным устройствам, входящим в состав измерительных комплексов природного газа.",
                "list": null,
                "table": null
            },
            {
                "isPreview": false,
                "header": "Технические характеристики",
                "text": null,
                "list": null,
                "table": {
                    "columns": [
                        "",
                        ""
                    ],
                    "rows": [
                        {
                            "items": [
                                "Завод изготовитель:",
                                "СКБ \u00ABПромавтоматика\u00BB"
                            ],
                            "isGroup": false,
                            "isGroupItem": false
                        },
                        {
                            "items": [
                                "Вес (кг):",
                                "1"
                            ],
                            "isGroup": false,
                            "isGroupItem": false
                        },
                        {
                            "items": [
                                "Габариты",
                                "200x120x61"
                            ],
                            "isGroup": false,
                            "isGroupItem": false
                        },
                        {
                            "items": [
                                "Уровень пылевлагозашиты:",
                                "IP54"
                            ],
                            "isGroup": false,
                            "isGroupItem": false
                        },
                        {
                            "items": [
                                "Межповерочный интервал (мес.): ",
                                "12"
                            ],
                            "isGroup": false,
                            "isGroupItem": false
                        },
                        {
                            "items": [
                                "Гарантийный срок (мес.): ",
                                "60"
                            ],
                            "isGroup": false,
                            "isGroupItem": false
                        }
                    ]
                }
            }
        ]
};
//**************************************************************************************UVP280
//**************************************************************************************ESKO_T
const ESKO_T = {
    id: "ESKO_T",
    name: "<b>ЭСКО-Т</b>",
    img: "/heatmeters/ЭСКО-Т.png",
    imgAlt: "ЭСКО-Т",
    description:
        [
            {
                "isPreview": true,
                "header": "",
                "text": "Теплосчетчик \u00ABЭСКО-Т\u00BB предназначен для измерений и хранений значений количества отпущенной тепловой энергии, теплоносителя и его параметров в закрытых и открытых водяных системах теплоснабжения при учетно-расчетных операциях. Комплектуется стационарным или переносными адаптерами переноса данных, осуществляет связь с периферийными устройствами по интерфейсам RS 232, RS 485 и через модем.",
                "list": null,
                "table": null
            },
            {
                "isPreview": false,
                "header": null,
                "text": "Область применения: Предприятия тепловых сетей, тепловые пункты, тепловые сети объектов промышленного и бытового назначения.",
                "list": null,
                "table": null
            },
            {
                "isPreview": false,
                "header": "Теплосчетчик выпускается в трех модификациях: ЭСКО-Т-1, ЭСКО-Т-2, ЭСКО-Т-3.Основные достоинства:",
                "text": null,
                "list": {
                    "type": "dots",
                    "items": [
                        {
                            "text": "широкий динамический диапазон и высокая точность измерений;",
                            "sublist": null
                        },
                        {
                            "text": "возможность применения в любых системах теплоснабжения;",
                            "sublist": null
                        },
                        {
                            "text": "эффективный съем показаний и накопленной статистики;",
                            "sublist": null
                        },
                        {
                            "text": "удобство монтажа;",
                            "sublist": null
                        },
                        {
                            "text": "высокая надежность;",
                            "sublist": null
                        },
                        {
                            "text": "невысокая стоимость.",
                            "sublist": null
                        }
                    ]
                },
                "table": null
            },
            {
                "isPreview": false,
                "header": "Функциональные возможности теплосчетчиков ЭСКО-Т",
                "text": "Теплосчетчики осуществляют:",
                "list": null,
                "table": null
            },
            {
                "isPreview": false,
                "header": "Измерение и индикацию:",
                "text": null,
                "list": {
                    "type": "dots",
                    "items": [
                        {
                            "text": "объемных расходов теплоносителя в прямом, обратном и подпиточном трубопроводах системы теплоснабжения, а также ГВС;",
                            "sublist": null
                        },
                        {
                            "text": "температуры теплоносителя в трубопроводах систем теплоснабжения или ГВС и трубопроводах холодного водоснабжения;",
                            "sublist": null
                        },
                        {
                            "text": "текущего времени (с указанием часов, минут) и даты (с указанием числа, месяца, года).",
                            "sublist": null
                        }
                    ]
                },
                "table": null
            },
            {
                "isPreview": false,
                "header": "Вычисление и индикацию:",
                "text": null,
                "list": {
                    "type": "dots",
                    "items": [
                        {
                            "text": "массовых расходов теплоносителя в прямом, обратном и подпиточном трубопроводах системы теплоснабжения, а также в трубопроводе ГВС;",
                            "sublist": null
                        },
                        {
                            "text": "разности температур теплоносителя в прямом и обратном (трубопроводе холодного водоснабжения) трубопроводах системы теплоснабжения.",
                            "sublist": null
                        }
                    ]
                },
                "table": null
            },
            {
                "isPreview": false,
                "header": "Накопление, хранение и индикацию:",
                "text": null,
                "list": {
                    "type": "dots",
                    "items": [
                        {
                            "text": "суммарных с нарастающим итогом объемов и (или) масс теплоносителя, протекших по трубопроводам, на которых установлены соответствующие первичные преобразователи расхода;",
                            "sublist": null
                        },
                        {
                            "text": "суммарного с нарастающим итогом потребленного (отпущенного) количества теплоты;",
                            "sublist": null
                        },
                        {
                            "text": "времени наработки при поданном напряжении питания;",
                            "sublist": null
                        },
                        {
                            "text": "времени работы в зоне ошибок.",
                            "sublist": null
                        }
                    ]
                },
                "table": null
            },
            {
                "isPreview": false,
                "header": "Технические характеристики",
                "text": null,
                "list": null,
                "table": {
                    "columns": [
                        "",
                        ""
                    ],
                    "rows": [
                        {
                            "items": [
                                "Завод изготовитель:",
                                "ЗАО \u00ABЭнергосервисная компания 3Э\u00BB"
                            ],
                            "isGroup": false,
                            "isGroupItem": false
                        },
                        {
                            "items": [
                                "Вес (кг):",
                                "1,5"
                            ],
                            "isGroup": false,
                            "isGroupItem": false
                        },
                        {
                            "items": [
                                "Средний срок службы (лет)",
                                "12"
                            ],
                            "isGroup": false,
                            "isGroupItem": false
                        },
                        {
                            "items": [
                                "Средняя наработка на отказ (часов)",
                                "20000"
                            ],
                            "isGroup": false,
                            "isGroupItem": false
                        }
                    ]
                }
            }
        ]
};
//**************************************************************************************ESKO_T



let heatmeters = { meterType: "Теплосчётчики", routid: "routMetersHeatmeters", image: "/heatmeters/heatMeters.png", meters: [] };
let electricPowerMeters = { meterType: "Электросчётчики", routid: "routElectroMeters", image: "/heatmeters/electroMeters.png", meters: [] };
let liquidFlowSensorsMeters = { meterType: "Счётчики жидкости, расходомеры", routid: "routMetersliquidFlowSensorsMeters", image: "/heatmeters/flowMeters.png", meters: [] };
let gasVolumeCorrectors = { meterType: "Корректоры объема газа", routid: "routGasMeters", image: "/heatmeters/gasMeters.png", meters: [] };
let outWaterMeters = { meterType: "Учёт сточных вод", routid: "routOutWaterMeters", image: "/heatmeters/outWaterMeters.png", meters: [] };
let pulseCounters = { meterType: "Счётчики импульсов", routid: "routImpulseCounters", image: "/heatmeters/impulseCounters.png", meters: [] };
let controllersAndHubs = { meterType: "Контроллеры и регуляторы", routid: "controllersAndHubs", image: "/heatmeters/controllers.png", meters: [] };

//Теплосчетчики
heatmeters.meters.push(VKT9);
heatmeters.meters.push(VKT7);
heatmeters.meters.push(VKT5);
heatmeters.meters.push(VKT4);
heatmeters.meters.push(VIST);
heatmeters.meters.push(KM5);
heatmeters.meters.push(SA94);
heatmeters.meters.push(MAGICA);
heatmeters.meters.push(MKTS);
heatmeters.meters.push(TEROSS);
heatmeters.meters.push(UVP280);
heatmeters.meters.push(TEM05);
heatmeters.meters.push(TEM104);
heatmeters.meters.push(TEM106);
heatmeters.meters.push(RPT1100);
heatmeters.meters.push(RPT2200);
heatmeters.meters.push(TARAN_T);
heatmeters.meters.push(VTE1);
heatmeters.meters.push(TV7);
heatmeters.meters.push(SKM2);
heatmeters.meters.push(SPT941);
heatmeters.meters.push(SPT943);
heatmeters.meters.push(SPT961);
heatmeters.meters.push(ESKO_T);
heatmeters.meters.push(STD);
heatmeters.meters.push(TEKON_17);
heatmeters.meters.push(IM2300);
heatmeters.meters.push(TSRV010M);
heatmeters.meters.push(TSRV023);
heatmeters.meters.push(TSR024M);
heatmeters.meters.push(TSR026M);
heatmeters.meters.push(TSR027);
heatmeters.meters.push(TSRV030);
heatmeters.meters.push(TSR031);
heatmeters.meters.push(TSR032);
heatmeters.meters.push(TSR033);
heatmeters.meters.push(TSR034);
heatmeters.meters.push(IRVIKON_VT200);
heatmeters.meters.push(KARAT);
heatmeters.meters.push(MULTICAL66);
heatmeters.meters.push(MULTICAL601);
heatmeters.meters.push(TMKN120);

//Электросчетчики
electricPowerMeters.meters.push(MERCURY203);
electricPowerMeters.meters.push(MERCURY230_ART);
electricPowerMeters.meters.push(MERCURY234);
electricPowerMeters.meters.push(MERCURY236);
electricPowerMeters.meters.push(SE102);
electricPowerMeters.meters.push(CE301);
electricPowerMeters.meters.push(SET4_TM);
electricPowerMeters.meters.push(PSCH_ZART_09);

//Счетчики воды
liquidFlowSensorsMeters.meters.push(RM5);
liquidFlowSensorsMeters.meters.push(PREM);
liquidFlowSensorsMeters.meters.push(AKRON01);

//Корректоры объема газа
gasVolumeCorrectors.meters.push(SPG761);
gasVolumeCorrectors.meters.push(EK260);
gasVolumeCorrectors.meters.push(EK88);
gasVolumeCorrectors.meters.push(GVC2010);

//Учёт сточных вод
outWaterMeters.meters.push(AKRON01);

//Счетчики импульсов
pulseCounters.meters.push(PULSAR);
pulseCounters.meters.push(PULSARGPRS);
pulseCounters.meters.push(PULSAR2K);
pulseCounters.meters.push(RADIO_PULSAR);

//Контроллеры и регуляторы
controllersAndHubs.meters.push(DANFOS);
controllersAndHubs.meters.push(DANFOSS_ECL310);
controllersAndHubs.meters.push(VTR10I);
controllersAndHubs.meters.push(VTR210I);
controllersAndHubs.meters.push(LOGGER_PROMODEM);
controllersAndHubs.meters.push(AnСom);
controllersAndHubs.meters.push(DELTAM);
controllersAndHubs.meters.push(UM31);
controllersAndHubs.meters.push(PLK100);


export let devices = [];
devices.push(heatmeters);
devices.push(electricPowerMeters);
devices.push(liquidFlowSensorsMeters);
devices.push(gasVolumeCorrectors);
devices.push(outWaterMeters);
devices.push(pulseCounters);
devices.push(controllersAndHubs);
